<template>
  <div class="app" ref="app">
    <div onselect="return false" class="student-list">
      <div @click="selectAllStudent()" class="selectall">
        {{ selectState ? "取消全选" : "全选" }}
      </div>
      <div
        v-for="(item, index) in studentList"
        :key="index"
        @click="selectStudent(index,$event)"
        :class="{ select: item.select, active: item.id == s_id }"
        class="cell"
      >
        <img
          onselect="return false"
          :src="
            item.head_img ? item.head_img : require('../assets/icon-11.png')
          "
          alt=""
        />
        <div class="name">{{ item.name }}</div>
        <div v-if="item.has_element === false" class="pos-tip">同位素差异</div>
      </div>
      <div
        style="margin-right:30px;margin-bottom:20px;display:flex;flex-direction:row;justify-content:space-between;width:100%;padding:15px;border-top:1px solid #eee"
        class="moreselect"
      >
        <div class="">多选状态</div>
        <a-switch
          checked-children="开"
          un-checked-children="关"
          v-model="moreSelect"
        />
      </div>
      <div
        class="tip"
        style="color:#ff0000;text-align:center;width:100%;clear:both;font-size:14px;padding:10px;box-sizing:border-box;padding:0 30px;margin-bottom:20px"
      >
        按住ctrl点击可多选学生，全选状态按住alt则切换当前显示的学生成长册
      </div>
    </div>
    <div class="leftChat" ref="leftChat" :style="leftChatStyle">
      <div class="leftDrags">
        <div @click="refreshDrags" class="title">未完成组件•点击刷新</div>
        <div
          @click="changeDrag(index)"
          v-for="(item, index) in drags"
          v-if="item.noFill"
          class="drag-cell"rocess=image/resize,w_200,h_
          :class="index == activeIndex ? 'active' : ''"
        >
          <div class="msg">
            <div class="name">
              {{ item.type | filterType }}{{ item.ec_id.substr(0, 4) }}
            </div>
          </div>
          <div class="status" :class="item.noFill ? 'nofill' : ''"></div>
        </div>
        <div v-if="showFootbtn" class="del" style="text-align:center">
          <a-button @click="delAll">批量删除</a-button>
        </div>
      </div>
      <div
        ref="body"
        onselectstart="return false"
        class="body"
        :key="dragKey"
        :class="leftChatMouseStateMove ? 'mask' : ''"
        :style="wrapperStyle"
      >
        <img
          v-if="backgroundImage"
          class="backimg"
          :src="backgroundImage"
          alt=""
        />
        <vue-draggable-resizable
          
          @changeLevel="changeLevel"
          @changeLevelData="changeLevelData"
          @rotating="dragRotating"
          @dragging="dragMoving"
          @resizing="dragResizing"
          :spinning="item.spinning"
          :w="item.width"
          @handleUnlock="handleUnlock"
          :textShadow="item.textShadow ? true : false"
          :h="item.height"
          :x="item.left"
          :y="item.top"
          :r="item.rotate"
          :z="item.zIndex"
          :className="item.selects ? 'vdr select' : 'vdr'"
          :parent="true"
          :minWidth="12"
          :minHeight="12"
          :nofill="item.noFill"
          :level="item.level"
          :levelType="item.levelType"
          :levelNum="item.levelNum"
          :fontFamily="item.fontFamily"
          @changeHeight="changeHeight"
          :frameId="'frame' + index"
          :photoScale="item.photoScale"
          :photoLeft="item.photoLeft"
          :photoTop="item.photoTop"
          :showDrag="item.show"
          :showPhoto="item.showPhoto"
          :shadow="item.shadow ? true : false"
          :allIndex="allIndex"
          :dIndex="index"
          :debug="false"
          :textDecoration="item.textDecoration"
          :textIndent="item.textIndent"
          :photoRotate="item.photoRotate"
          :writingMode="item.writeMode"
          :lineHeight="item.lineHeight"
          :fontWeight="item.fontWeight"
          :fontStyle="item.fontStyle"
          :textAlign="item.textAlign"
          :type="item.type"
          :isConflictCheck="false"
          :snap="false"
          :snapTolerance="1"
          :lockAspectRatio="item.lockAspectRatio ? true : false"
          :backImg="item.backgroundImg ? item.backgroundImg : ''"
          :bImg2="item.backImg2"
          :bRadius="item.borderRadius"
          :draggable="item.draggable"
          @refLineParams="getRefLineParams"
          @activated="changeDrag(index)"
          @changeContent="changeContent"
          @showEdit="showEdit"
          :fontColor="item.fColor"
          :text="item.textarea"
          :o="item.opacity"
          :l="item.lock || pageDetail.is_locked ? true : false"
          :backColor="item.bColor"
          :borderColor="item.bordersColor"
          :borderLeft="item.bLeft"
          :borderTop="item.bTop"
          :borderRight="item.bRight"
          :borderBottom="item.bBottom"
          :borderStyle="item.bStyle"
          :paddingLeft="item.paddingLeft"
          :paddingTop="item.paddingTop"
          :paddingRight="item.paddingRight"
          :paddingBottom="item.paddingBottom"
          :active="item.active ? true : false"
          :fontSize="item.fSize"
          v-for="(item, index) in drags"
          ref="drag"
          :key="item.ec_id"
          @changeDrag="changeDragHistory"
          @pmoving="pmoving"
          @photoChange="photoChange"
          @resizestop="resizing"
          @movingStop="movingStop"
          @rotatingStop="rotating"
          @dragstop="dragging"
          @upTop="upTop(index)"
          @mouseEnter="listenMouseEnter"
          @mouserLeave="listenMouseLeave"
          @confirmComb="confirmComb"
          @dropImg="dropImg"
        >
          <div v-if="item.type == 3" class="look" style="z-index: -1">
            <div
              class="wrap"
              :style="{
                width: item.width + 'px',
                height: item.height + 'px',
                transform: `scale(${item.width /
                  item.orignWidth},${item.height / item.orignHeight})`,
                transformOrigin: '0px 0px',
              }"
            >
              <vue-draggable-resizable
                v-for="(item2, index2) in item.coms"
                :key="'com' + index2"
                :w="item2.width"
                :h="item2.height"
                :x="item2.left"
                :y="item2.top"
                :r="item2.rotate"
                :z="item2.zIndex"
                :frameId="'frame' + index + '_' + index2"
                :photoScale="item2.photoScale"
                :photoLeft="item2.photoLeft"
                :photoTop="item2.photoTop"
                :showPhoto="item2.showPhoto"
                :shadow="item2.shadow ? true : false"
                :allIndex="allIndex"
                :dIndex="index"
                :debug="false"
                :disable="true"
                :lineHeight="item2.lineHeight"
                :fontFamily="item2.fontFamily"
                :textDecoration="item2.textDecoration"
                :textIndent="item2.textIndent"
                :photoRotate="item2.photoRotate"
                :writingMode="item2.writeMode"
                :fontWeight="item2.fontWeight"
                :fontStyle="item2.fontStyle"
                :textAlign="item2.textAlign"
                :type="item2.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item2.lockAspectRatio ? true : false"
                :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                :bImg2="item2.backImg2"
                :bRadius="item2.borderRadius"
                :fontColor="item2.fColor"
                :text="item2.textarea"
                :o="item2.opacity"
                :l="item2.lock ? true : false"
                dragHandle="false"
                :backColor="item2.bColor"
                :borderColor="item2.bordersColor"
                :borderLeft="item2.bLeft"
                :borderTop="item2.bTop"
                :borderRight="item2.bRight"
                :borderBottom="item2.bBottom"
                :borderStyle="item2.bStyle"
                :paddingLeft="item2.paddingLeft"
                :paddingTop="item2.paddingTop"
                :paddingRight="item2.paddingRight"
                :paddingBottom="item2.paddingBottom"
                :active="false"
                :fontSize="item2.fSize"
              ></vue-draggable-resizable>
            </div>
          </div>
        </vue-draggable-resizable>
        <!-- @rotating="dragRotating"
          @dragging="dragMoving"
          @resizing="dragResizing"
          @changeDrag="changeDragHistory"
          @pmoving="pmoving"
          @resizestop="resizing"
          @movingStop="movingStop"
          @rotatingStop="rotating"
          @dragstop="dragging" -->
        <vue-draggable-resizable
          v-if="dragsSelectIndexs.length > 1"
          ref="multiDrag"
          :w="multipleDrag.width"
          @handleUnlock="handleUnlock"
          :textShadow="multipleDrag.textShadow ? true : false"
          :h="multipleDrag.height"
          :x="multipleDrag.left"
          :y="multipleDrag.top"
          :r="multipleDrag.rotate"
          :z="multipleDrag.zIndex"
          :parent="true"
          :minWidth="12"
          :minHeight="12"
          :level="multipleDrag.level"
          :levelType="multipleDrag.levelType"
          :levelNum="multipleDrag.levelNum"
          :fontFamily="multipleDrag.fontFamily"
          @changeHeight="changeHeight"
          :photoScale="multipleDrag.photoScale"
          :photoLeft="multipleDrag.photoLeft"
          :photoTop="multipleDrag.photoTop"
          :showPhoto="multipleDrag.showPhoto"
          :shadow="multipleDrag.shadow ? true : false"
          :debug="false"
          :textDecoration="multipleDrag.textDecoration"
          :textIndent="multipleDrag.textIndent"
          :photoRotate="multipleDrag.photoRotate"
          :writingMode="multipleDrag.writeMode"
          :lineHeight="multipleDrag.lineHeight"
          :fontWeight="multipleDrag.fontWeight"
          :fontStyle="multipleDrag.fontStyle"
          :textAlign="multipleDrag.textAlign"
          :type="multipleDrag.type"
          :isConflictCheck="false"
          :snap="false"
          :snapTolerance="1"
          :lockAspectRatio="true "
          :backImg="
            multipleDrag.backgroundImg ? multipleDrag.backgroundImg : ''
          "
          :bImg2="multipleDrag.backImg2"
          :bRadius="multipleDrag.borderRadius"
          :draggable="multipleDrag.draggable"
          :fontColor="multipleDrag.fColor"
          :text="multipleDrag.textarea"
          :o="multipleDrag.opacity"
          :l="multipleDrag.lock ? true : false"
          :backColor="multipleDrag.bColor"
          :borderColor="multipleDrag.bordersColor"
          :borderLeft="multipleDrag.bLeft"
          :borderTop="multipleDrag.bTop"
          :borderRight="multipleDrag.bRight"
          :borderBottom="multipleDrag.bBottom"
          :borderStyle="multipleDrag.bStyle"
          :paddingLeft="multipleDrag.paddingLeft"
          :paddingTop="multipleDrag.paddingTop"
          :paddingRight="multipleDrag.paddingRight"
          :paddingBottom="multipleDrag.paddingBottom"
          :active="multipleDrag.active ? true : false"
          :fontSize="multipleDrag.fSize"
          :key="multipleDrag.ec_id"
          @pmoving="pmoving"
          @resizestop="resizingComStop"
          @movingStop="movingStop"
          @rotatingStop="rotating"
          @dragstop="draggingComStop"
          @dragging="draggingCom"
          @resizing= "resizingCom"
          @upTop="upTop(index)"
          @mouseEnter="listenMouseEnter"
          @mouserLeave="listenMouseLeave"
        >
          <div class="look" style="z-index: -1">
            <div
              class="wrap"
              :style="{
                width: multipleDrag.width + 'px',
                height: multipleDrag.height + 'px',
                transform: `scale(${multipleDrag.width /
                  multipleDrag.orignWidth},${multipleDrag.height /
                  multipleDrag.orignHeight})`,
                transformOrigin: '0px 0px',
              }"
            >
              <vue-draggable-resizable
                v-for="(item2, index2) in multipleDrag.coms"
                :key="'com' + index2"
                :w="item2.width"
                :h="item2.height"
                :x="item2.left"
                :y="item2.top"
                :r="item2.rotate"
                :z="item2.zIndex"
                :frameId="'frame' + '_' + index2"
                :photoScale="item2.photoScale"
                :photoLeft="item2.photoLeft"
                :photoTop="item2.photoTop"
                :showPhoto="item2.showPhoto"
                :shadow="item2.shadow ? true : false"
                :allIndex="allIndex"
                :dIndex="index2"
                :debug="false"
                :disable="true"
                :lineHeight="item2.lineHeight"
                :fontFamily="item2.fontFamily"
                :textDecoration="item2.textDecoration"
                :textIndent="item2.textIndent"
                :photoRotate="item2.photoRotate"
                :writingMode="item2.writeMode"
                :fontWeight="item2.fontWeight"
                :fontStyle="item2.fontStyle"
                :textAlign="item2.textAlign"
                :type="item2.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item2.lockAspectRatio ? true : false"
                :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                :bImg2="item2.backImg2"
                :bRadius="item2.borderRadius"
                :fontColor="item2.fColor"
                :text="item2.textarea"
                :o="item2.opacity"
                :l="item2.lock ? true : false"
                dragHandle="false"
                :backColor="item2.bColor"
                :borderColor="item2.bordersColor"
                :borderLeft="item2.bLeft"
                :borderTop="item2.bTop"
                :borderRight="item2.bRight"
                :borderBottom="item2.bBottom"
                :borderStyle="item2.bStyle"
                :paddingLeft="item2.paddingLeft"
                :paddingTop="item2.paddingTop"
                :paddingRight="item2.paddingRight"
                :paddingBottom="item2.paddingBottom"
                :active="false"
                :fontSize="item2.fSize"
              ></vue-draggable-resizable>
            </div>
          </div>
        </vue-draggable-resizable>
        <!--辅助线-->
        <span
          class="ref-line v-line"
          v-for="item in vLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength,
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in hLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength,
          }"
        />
        <!--辅助线END-->
        <div
          class="leftLine"
          :style="{
            left: haomi + 'px',
            top: haomi + 'px',
            bottom: haomi + 'px',
          }"
        ></div>
        <div
          class="topLine"
          :style="{
            top: haomi + 'px',
            left: haomi + 'px',
            right: haomi + 'px',
          }"
        ></div>
        <div
          class="rightLine"
          :style="{
            right: haomi + 'px',
            top: haomi + 'px',
            bottom: haomi + 'px',
          }"
        ></div>
        <div
          class="bottomLine"
          :style="{
            bottom: haomi + 'px',
            left: haomi + 'px',
            right: haomi + 'px',
          }"
        ></div>
        <i
          v-if="
            activeIndex > -1 &&
              drags[activeIndex].type != 4 &&
              showIcon &&
              dragsSelectIndexs.length < 2 &&  !this.drags[this.activeIndex].spinning
          "
          :style="rotateStyle"
          class="rotatebox iconfont icon-xuanzhuan"
          style="transform: none;"
          @mousedown.stop.prevent="handleRotateTouchDown(null, $event)"
          @touchstart.stop.prevent="handleRotateDown(null, $event)"
          @touchend.stop.prevent="handleRotateUp"
        ></i>
        <i
          v-if="activeIndex > -1 && canShowIcon && dragsSelectIndexs.length < 2 &&  !this.drags[this.activeIndex].spinning"
          :style="rotateStyle2"
          class="rotatebox iconfont icon-xuanzhuan_huaban1"
          @click="rotatePhoto"
        ></i>

        <div
          v-if="
            dragsSelectIndexs.length < 2 &&
              activeIndex > -1 &&
              (drags[activeIndex].type == 2 ||
                drags[activeIndex].type == 1 ||
                drags[activeIndex].type == 9) &&
              showIcon &&  !this.drags[this.activeIndex].spinning
          "
          :style="moveBoxStyle"
          class="moveBOX"
        >
          <img @click="fangda" src="../assets/fangda.png" alt="" />
          <img
            @mousedown.stop.prevent="handleMoveTouchDown(null, $event)"
            @touchstart.stop.prevent="handleMoveDown(null, $event)"
            @touchend.stop.prevent="handleRotateUp"
            src="../assets/yidong.png"
            alt=""
          />
          <img @click="suoxiao" src="../assets/suoxiao.png" alt="" />
        </div>
        <div
          v-if="
            kongwei &&
              pages2[page].page_num % 2 == 1 &&
              pages2[page].page_num != 0
          "
          class="circles"
          :style="{ left: haomi * 2.6 + 'px' }"
        >
          <div class="circle">
            <div></div>
          </div>
          <div class="circle">
            <div></div>
          </div>
          <div class="circle">
            <div></div>
          </div>
        </div>
        <div
          v-if="
            kongwei &&
              pages2[page].page_num % 2 == 0 &&
              pages2[page].page_num != 0
          "
          class="circles"
          :style="{ right: haomi * 2.6 + 'px' }"
        >
          <div class="circle">
            <div></div>
          </div>
          <div class="circle">
            <div></div>
          </div>
          <div class="circle">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottomChat">
      <div class="pagebox">
        <div
          @click="changePageNum(index)"
          v-for="(item, index) in pageObject"
          :key="index"
          class="item"
          :class="currentRowPage == index ? 'active' : ''"
        >
          {{ item.type == 1 ? "封" : item.type == 2 ? item.page_num : "底" }}
        </div>
        <div @click="addPage" class="add-page">
          +
        </div>
      </div>
    </div> -->
    <div onselectstart="return false" class="fixtop">
      <div class="left">
        <div @click="backIndex" style="cursor: pointer;" class="name">
          成长册编辑
        </div>
        <div class="icon">></div>
        <div @click="$router.back()" class="main blue" style="cursor: pointer;">
          预览 - {{ studentName }}
        </div>
        <div class="icon">></div>
        <div
          @click="pageModal = true"
          style="cursor: pointer;"
          class="main blue"
          v-if="pages2.length > 0"
        >
          {{
            pages2[page].type == 1
              ? "封面"
              : pages2[page].type == 3
              ? "封底"
              : "第" + pages2[page].page_num + "页"
          }}
        </div>
        <a-icon
          @click="pageModal = true"
          :style="{ color: '#67b0dc' }"
          type="caret-down"
        />
      </div>
      <div class="cz">
        <div @click="up()" class="cz-item">
          <i class="iconfont icon-shangyiyiceng"></i>
          <div class="name">上移一层</div>
        </div>
        <div @click="down()" class="cz-item">
          <i class="iconfont icon-xiayiyiceng"></i>
          <div class="name">下移一层</div>
        </div>
        <div @click="toTop()" class="cz-item">
          <i class="iconfont icon-control-top"></i>
          <div class="name">置顶</div>
        </div>
        <div @click="toBottom()" class="cz-item">
          <i class="iconfont icon-control-bottom"></i>
          <div class="name">置底</div>
        </div>
      </div>
      <div class="right">
        <div style="margin-right:12px" class="network">
          <a-tooltip placement="bottom" v-if="netWork == -1" title="网络已断开">
            <img
              style="width:18px"
              v-if="netWork <= 1"
              src="../assets/online3.gif"
              alt=""
            />
          </a-tooltip>
          <a-tooltip
            placement="bottom"
            v-if="netWork > 0"
            :title="
              netWork > 200
                ? '网络状态较差' + netWork
                : netWork > 100
                ? '网络状态一般' + netWork
                : '网络极佳' + netWork
            "
          >
            <img
              style="width:18px"
              v-if="netWork > 200"
              src="../assets/network-bad.jpg"
              alt=""
            />
            <img
              style="width:18px"
              v-else-if="netWork > 100"
              src="../assets/network-good.png"
              alt=""
            />
            <img
              style="width:18px"
              v-else
              src="../assets/network-good.png"
              alt=""
            />
          </a-tooltip>
        </div>
        <div
          style="display:flex;flex-direction:row;align-items:center;margin-right:15px"
        >
          <span style="margin-right:10px">孔位提示</span>
          <a-switch
            size="small"
            @change="changeKongwei"
            v-model="kongwei"
          ></a-switch>
        </div>

        <div class="savebox flex-row">
          <a-icon :type="saveDraging ? 'loading' : 'check'" />
          <span>{{ saveDraging ? "上传中..." : "保存成功！" }}</span>
        </div>
        <div class="sizebox flex-row">
          <div class="name">缩放比列</div>
          <a-select style="width:70px" v-model="sizeSelct" size="small">
            <a-select-option key="50" value="50">50%</a-select-option>
            <a-select-option key="60" value="60">60%</a-select-option>
            <a-select-option key="70" value="70">70%</a-select-option>
            <a-select-option key="80" value="80">80%</a-select-option>
            <a-select-option key="90" value="90">90%</a-select-option>
            <a-select-option key="100" value="100">100%</a-select-option>
            <a-select-option key="125" value="125">125%</a-select-option>
            <a-select-option key="125" value="150">150%</a-select-option>
            <a-select-option key="125" value="200">200%</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <img v-if="priviewImg" class="priview-img" :src="priviewImg" alt="" />
    <div class="rightChat" @click="catchClick">
      <div class="tabbar">
        <div
          @click="changeTab(0)"
          @contextmenu="rightClick"
          class="tab-item"
          :class="tabIndex == 0 ? 'active' : ''"
        >
          属性
        </div>
        <div
          @click="changeTab(1)"
          class="tab-item"
          :class="tabIndex == 1 ? 'active' : ''"
        >
          照片
        </div>
        <div
          @click="changeTab(2)"
          class="tab-item"
          :class="tabIndex == 2 ? 'active' : ''"
        >
          素材
        </div>
        <!-- <div
          @click="changeTab(3)"
          class="tab-item"
          :class="tabIndex == 3 ? 'active' : ''"
        >
          文本框
        </div> -->

        <div
          @click="changeTab(4)"
          class="tab-item"
          :class="tabIndex == 4 ? 'active' : ''"
        >
          相框
        </div>
        <div
          @click="changeTab(5)"
          class="tab-item"
          :class="tabIndex == 5 ? 'active' : ''"
        >
          背景
        </div>
        <div
          v-if="activeIndex == -1 || drags[activeIndex].type != 5"
          @click="changeTab(6)"
          class="tab-item"
          :class="tabIndex == 6 ? 'active' : ''"
        >
          组合
        </div>
        <div
          v-if="activeIndex > -1 && drags[activeIndex].type == 5"
          @click="changeTab(8)"
          class="tab-item"
          :class="tabIndex == 8 ? 'active' : ''"
        >
          文本模板
        </div>
        <div
          v-if="activeIndex > -1 && drags[activeIndex].type == 5"
          @click="changeTab(7)"
          class="tab-item"
          :class="tabIndex == 7 ? 'active' : ''"
        >
          编辑
        </div>
        <div
          @click="changeTab(10)"
          class="tab-item"
          :class="tabIndex == 10 ? 'active' : ''"
        >
          日志
        </div>
        <!-- <div
          @click="changeTab(9)"
          class="tab-item"
          :class="tabIndex == 9 ? 'active' : ''"
        >
          编辑
        </div> -->
      </div>
      <div class="content">
        <div
          class="cell photo-box"
          onselectstart="return false"
          v-if="tabIndex == 0"
        >
          <div v-if="drags.length == 0" class="section">
            <div class="section-item">
              <div class="item-line">
                <div class="title">
                  {{ dragsSelectIndexs.length > 1 ? "组合元件" : "暂无组件" }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="pageDetail" class="section" style="min-height: 50px;">
            <div class="section-item">
              <div class="item-line">
                <div class="title">页面锁定</div>
                <i
                  @click="lockPage"
                  style="margin-right: 0"
                  class="iconfont"
                  :class="pageDetail.is_locked ? 'icon-suoding1' : 'icon-suo'"
                ></i>
              </div>
            </div>
          </div>
          <div
            v-if="
              drags.length > 0 &&
                activeIndex > -1 
            "
            class="section"
          >
            <div v-if="!multipleDrag" class="section-item">
              <div class="item-line">
                <div class="title">元件属性</div>
                <i
                  v-if="drags[activeIndex].type != 3 && !pageDetail.is_locked"
                  @click="lockDrag"
                  style="margin-right: 0"
                  class="iconfont"
                  :class="
                    drags[activeIndex].lock ? 'icon-suoding1' : 'icon-suo'
                  "
                ></i>
              </div>
            </div>
            <div >
              <div v-if="!multipleDrag" class="section-item">
                <div class="item-line">
                  <div class="cell">
                    <span class="name">X</span>
                    <a-input-number
                      v-model="drags[activeIndex].left"
                      controls-position="right"
                      :min="-500"
                      :max="1000"
                      :disabled="
                        drags[activeIndex].lock || pageDetail.is_locked
                          ? true
                          : false
                      "
                      type="number"
                    ></a-input-number>
                  </div>
                  <div class="cell">
                    <span class="name">Y</span>
                    <a-input-number
                      v-model="drags[activeIndex].top"
                      controls-position="right"
                      :min="-500"
                      :disabled="
                        drags[activeIndex].lock || pageDetail.is_locked
                          ? true
                          : false
                      "
                      :max="1000"
                    ></a-input-number>
                  </div>
                </div>
                <div class="item-line">
                  <div class="cell">
                    <span class="name">W</span>
                    <a-input-number
                      v-model="drags[activeIndex].width"
                      controls-position="right"
                      :min="12"
                      disabled
                      :max="1000"
                    ></a-input-number>
                  </div>
                  <div class="cell">
                    <span class="name">H</span>
                    <a-input-number
                      v-model="drags[activeIndex].height"
                      controls-position="right"
                      :min="12"
                      disabled
                      :max="1000"
                    ></a-input-number>
                  </div>
                </div>
                <div v-if="drags[activeIndex].type != 4" class="item-line">
                  <div class="cell">
                    <span class="name">R</span>
                    <a-input-number
                      v-model="drags[activeIndex].rotate"
                      controls-position="right"
                      :min="0"
                      :max="359"
                      :disabled="
                        drags[activeIndex].lock || pageDetail.is_locked
                          ? true
                          : false
                      "
                    ></a-input-number>
                  </div>
                  <div
                    v-if="
                      (drags[activeIndex].type == 1 ||
                        drags[activeIndex].type == 9) && !pageDetail.is_locked
                    "
                    class="cell"
                  >
                    <span class="name" style="width: auto">比列锁定</span>
                    <i
                      @click="
                        drags[activeIndex].lockAspectRatio = !drags[activeIndex]
                          .lockAspectRatio
                      "
                      style="margin-right: 0"
                      class="iconfont"
                      :class="
                        drags[activeIndex].lockAspectRatio
                          ? 'icon-suoding1'
                          : 'icon-suo'
                      "
                    ></i>
                  </div>
                </div>
              </div>
              <div v-if="false" class="section-item">
                <div
                  class="item-line"
                  :class="this.dragsSelectIndexs.length > 1 ? ' ' : 'dq_none'"
                >
                  <span class="name" style="width: 70px">组件对齐</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-row>
                      <a-col
                        @click="dqdrags('left')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="左对齐">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_horizalign-left"
                            ></i>
                            <!-- <div class="name">左对齐</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                        @click="dqdrags('right')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="右对齐">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_horizalign-right"
                            ></i>
                            <!-- <div class="name">右对齐</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                        @click="dqdrags('top')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="顶对齐">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_verticalalign-top"
                            ></i>
                            <!-- <div class="name">顶对齐</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                        @click="dqdrags('bottom')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="底对齐">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_verticalalign-bottom"
                            ></i>
                            <!-- <div class="name">底对齐</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                        @click="dqdrags('horCenter')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="水平居中">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_horizalign-center"
                            ></i>
                            <!-- <div class="name">水平居中</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                        @click="dqdrags('verCenter')"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="垂直居中">
                          <div class="align-item">
                            <i
                              class="iconfont3 icon-jurassic_verticalalign-center"
                            ></i>
                            <!-- <div class="name">垂直居中</div> -->
                          </div>
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
              <!-- <div class="section-item">
                <div
                  class="item-line"
                  :class="this.dragsSelectIndexs.length > 1 ? ' ' : 'dq_none'"
                >
                  <span class="name" style="width: 70px">组合元件</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-row>
                      <a-col
                        @click="addCom()"
                        style="cursor: pointer"
                        :span="4"
                      >
                        <a-tooltip title="组合元件">
                          <div class="align-item">
                            <i class="miconfont icon-appstoreadd"></i>
                          </div>
                        </a-tooltip>
                      </a-col>
                      <a-col
                      @click="addCom()"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="打散">
                        <div class="align-item">
                          <i
                            class="iconfont2 icon-jurassic_horizalign-right"
                          ></i>
                        </div>
                      </a-tooltip>
                    </a-col>
                    </a-row>
                  </div>
                </div>
              </div> -->
              <div
                v-if="
                  !drags[activeIndex].lock &&
                    drags[activeIndex].type != 3 &&
                    !pageDetail.is_locked && !multipleDrag
                "
                class="section-item"
              >
                <div class="item-line">
                  <span class="name" style="width: 70px">透明度</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-slider v-model="drags[activeIndex].opacity"></a-slider>
                  </div>
                </div>
              </div>
              <div
                v-if="(!drags[activeIndex].lock || !multipleDrag) && !pageDetail.is_locked"
                class="section-item"
              >
                <div class="item-line">
                  <span class="name2" style="width: 70px">组件</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-button type="primary" @click="copythisDrag"
                      >复制组件</a-button
                    >
                    <a-button
                      type="primary"
                      style="margin-left:10px"
                      @click="pasterDrag"
                      >粘贴组件</a-button
                    >
                  </div>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px"></span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-button @click="handleRemoveDrag">删除组件</a-button>
                    <a-button
                      v-if="
                        (drags[activeIndex].type == 1 ||
                          drags[activeIndex].type == 2 ||
                          drags[activeIndex].type == 9 ) &&  !multipleDrag
                      "
                      style="margin-left:10px"
                      @click="previewFrame = true"
                      >更换相框</a-button
                    >
                    <a-button
                      v-if="drags[activeIndex].type == 5"
                      style="margin-left:10px"
                      @click="saveTextTel"
                      >保存文本</a-button
                    >
                  </div>
                </div>
                <!-- <div class="item-line">
                <span class="name2" style="width: 70px"></span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-button @click="previewFrame = true">更换相框</a-button>
                </div>
              </div> -->
                <section v-if="!multipleDrag">
                  <div
                  v-if="
                    drags[activeIndex].type != 2 &&
                      drags[activeIndex].type != 5 &&
                      drags[activeIndex].type != 0 &&
                      drags[activeIndex].type != 8 &&
                      drags[activeIndex].type != 3
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">背景色</span>
                  <div class="flex-1" @click="cancelPasterDrag" style="padding-right: 20px">
                    <el-color-picker
                      color-format="hex"
                      v-model="drags[activeIndex].bColor"
                    >
                    </el-color-picker>
                  </div>
                  <!-- <div class="flex-1">
                    <a-button @click="cancelBcolor">清空</a-button>
                  </div> -->
                </div>
                <div
                  v-if="
                    drags[activeIndex].type != 2 &&
                      drags[activeIndex].type != 5 &&
                      drags[activeIndex].type != 0 &&
                      drags[activeIndex].type != 8 &&
                      drags[activeIndex].type != 3
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">边框色</span>
                  <div class="flex-1" @click="cancelPasterDrag" style="padding-right: 20px">
                    <el-color-picker
                      color-format="hex"
                      v-model="drags[activeIndex].bordersColor"
                    >
                    </el-color-picker>
                  </div>
                  <!-- <div class="flex-1">
                    <a-button @click="calcelbordersColor">清空</a-button>
                  </div> -->
                </div>
                <div
                  v-if="
                    drags[activeIndex].type != 2 &&
                      drags[activeIndex].type == 8 &&
                      drags[activeIndex].type != 4
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">线条颜色</span>
                  <div
                    class="flex-1"
                    @click="cancelPasterDrag"
                    style="padding-right: 20px"
                  >
                    <el-color-picker
                      color-format="hex"
                      v-model="drags[activeIndex].bordersColor"
                    >
                    </el-color-picker>
                  </div>
                  <div class="flex-1">
                    <a-button @click="calcelbordersColor">清空</a-button>
                  </div>
                </div>
                <div
                  v-if="
                    drags[activeIndex].type == 1 ||
                      drags[activeIndex].type == 7 ||
                      drags[activeIndex].type == 9
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">圆角</span>
                  <div class="flex-1" style="padding-right: 0px">
                    <a-input-number
                      v-model="drags[activeIndex].borderRadius"
                      controls-position="right"
                      :min="0"
                      :max="maxRound"
                      size="small"
                    ></a-input-number>
                  </div>
                </div>

                <div
                  v-if="
                    drags[activeIndex].type != 2 &&
                      drags[activeIndex].type != 5 &&
                      drags[activeIndex].type != 0 &&
                      drags[activeIndex].type != 8 &&
                      drags[activeIndex].type != 3
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px"></span>
                  <div class="flex-1" style="padding-right: 0px">
                    <div class="num-item" style="margin-bottom: 10px">
                      <div class="num-cell">
                        <i class="iconfont icon-jurassic_border-left"></i>
                        <a-input-number
                          v-model="drags[activeIndex].bLeft"
                          controls-position="right"
                          :min="0"
                          :max="359"
                          size="small"
                        ></a-input-number>
                      </div>
                      <div class="num-cell">
                        <i class="iconfont icon-jurassic_border-top"></i>
                        <a-input-number
                          v-model="drags[activeIndex].bTop"
                          controls-position="right"
                          :min="0"
                          :max="359"
                          size="small"
                        ></a-input-number>
                      </div>
                    </div>
                    <div class="num-item">
                      <div class="num-cell">
                        <i class="iconfont icon-jurassic_border-right"></i>
                        <a-input-number
                          v-model="drags[activeIndex].bRight"
                          controls-position="right"
                          :min="0"
                          :max="359"
                          size="small"
                        ></a-input-number>
                      </div>
                      <div class="num-cell">
                        <i class="iconfont icon-jurassic_border-bottom"></i>
                        <a-input-number
                          v-model="drags[activeIndex].bBottom"
                          controls-position="right"
                          :min="0"
                          :max="359"
                          size="small"
                        ></a-input-number>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="drags[activeIndex].type == 8" class="item-line">
                  <span class="name2" style="width: 70px">线条高度</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-input-number
                      v-model="drags[activeIndex].bBottom"
                      controls-position="right"
                      :min="0"
                      :max="359"
                      size="small"
                    ></a-input-number>
                  </div>
                </div>
                <div
                  v-if="
                    drags[activeIndex].type != 2 &&
                      drags[activeIndex].type != 5 &&
                      drags[activeIndex].type != 0 &&
                      drags[activeIndex].type != 3
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">{{
                    drags[activeIndex].type == 8 ? "线条样式" : "边框样式"
                  }}</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-select
                      v-model="drags[activeIndex].bStyle"
                      placeholder="请选择"
                    >
                      <a-select-option label="实线" value="solid"
                        >实线
                      </a-select-option>
                      <a-select-option label="虚线" value="dashed">
                        虚线</a-select-option
                      >
                      <a-select-option label="点状" value="dotted"
                        >点状
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
                <!-- <div
                  v-if="
                    drags[activeIndex].type != 0 &&
                      drags[activeIndex].type != 8 &&
                      drags[activeIndex].type != 5 &&
                      drags[activeIndex].type != 3
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">阴影</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-switch
                      @click="changeSwitch"
                      :checked="drags[activeIndex].shadow ? true : false"
                    >
                    </a-switch>
                  </div>
                </div> -->
                <!-- <div v-if="drags[activeIndex].type== 5" class="item-line">
                <span class="name2" style="width: 70px">阴影</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-switch @click="changeSwitch2" :checked="drags[activeIndex].textShadow ? true : false">
                  </a-switch>
                </div>
              </div> -->
                <div
                  v-if="
                    drags[activeIndex].type == 1 ||
                      drags[activeIndex].type == 2 ||
                      drags[activeIndex].type == 9
                  "
                  class="item-line"
                >
                  <span class="name2" style="width: 70px">照片</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-button @click="calcelPhoto">去除照片</a-button>
                  </div>
                </div>
                </section>
                
              </div>
              <section v-if="!multipleDrag">
                <div
                v-if="!drags[activeIndex].lock && drags[activeIndex].type == 4"
                class="section-item"
              >
                <div @click="cancelPasterDrag" class="item-line">
                  <span class="name2" style="width: 70px">评级颜色</span>
                  <div class="flex-1" @click="cancelPasterDrag" style="padding-right: 20px">
                    <el-color-picker
                      v-model="drags[activeIndex].fColor"
                      color-format="hex"
                    >
                    </el-color-picker>
                  </div>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px">评级类型</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-select
                      @change="changeLevelType"
                      v-model="drags[activeIndex].levelType"
                      style="width:100%"
                    >
                      <a-select-option label="星星" :value="1"
                        >星星
                      </a-select-option>
                      <a-select-option label="打钩" :value="2">
                        打钩</a-select-option
                      >
                    </a-select>
                  </div>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px">评级</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-select
                      @change="changeCurrnetLevel"
                      v-model="drags[activeIndex].level"
                      style="width:100%"
                    >
                      <a-select-option label="1" :value="1"
                        >1
                      </a-select-option>
                      <a-select-option label="2" :value="2">
                        2</a-select-option
                      >
                      <a-select-option label="3" :value="3">
                        3</a-select-option
                      >
                      <a-select-option label="4" v-if="drags[activeIndex].levelNum == 4" :value="4">
                        4</a-select-option
                      >
                    </a-select>
                  </div>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px">图标大小</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-input-number
                      v-model="drags[activeIndex].fSize"
                      :min="12"
                    />
                  </div>
                </div>
                <div v-if="drags[activeIndex].levelType == 2" class="item-line">
                  <span class="name2" style="width: 70px">档位</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-select
                      v-model="drags[activeIndex].levelNum"
                      placeholder="请选择"
                      style="width:100%"
                    >
                      <a-select-option label="3档" :value="3"
                        >3档
                      </a-select-option>
                      <a-select-option
                        v-if="drags[activeIndex].levelType == 2"
                        label="4档"
                        :value="4"
                      >
                        4档</a-select-option
                      >
                    </a-select>
                  </div>
                </div>
              </div>
              <div v-if="drags[activeIndex].type == 5" class="section-item">
                <div class="item-line">
                  <div class="section">
                    <div
                      class="item"
                      style="
                    height: 40px;
                    padding: 4px;
                    box-sizing: border-box;
                    margin-bottom: 20px;
                  "
                    >
                      <a-row :gutter="[10, 10]">
                        <!-- <a-col
                        v-for="(item, index) in fonts"
                        :key="index"
                        :span="24"
                      >
                        <div
                          @click="changeFamily(item)"
                          :style="{ fontFamily: item }"
                          style="
                          border: 1px solid #eee;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                          white-space: nowrap;
                          text-align: center;
                          font-size: 12px;
                        "
                        >
                          {{ item }}
                        </div>
                      </a-col> -->
                        <a-col :span="24">
                          <div
                            @click="handleChangeFamily()"
                            :style="{
                              fontFamily: drags[activeIndex].fontFamily,
                            }"
                            style="
                          border: 1px solid #eee;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                          white-space: nowrap;
                          text-align: center;
                          font-size: 14px;
                          position: relative;
                          cursor: pointer;
                        "
                          >
                            {{
                              drags[activeIndex].fontFamily
                                ? drags[activeIndex].fontFamily
                                : "默认字体"
                            }}
                          </div>
                          <a-row v-show="familyMask" class="selectFamily">
                            <a-col
                              v-for="(item, index) in fonts"
                              :key="index"
                              :span="24"
                            >
                              <div
                                @click="changeFamily(item)"
                                :style="{ fontFamily: item }"
                                style="
                                border: 1px solid #eee;
                                height: 40px;
                                text-align: center;
                                line-height: 40px;
                                white-space: nowrap;
                                text-align: center;
                                font-size: 14px;
                                margin: 2px 0;
                              "
                              >
                                {{ item }}
                              </div>
                            </a-col>
                          </a-row>
                        </a-col>
                      </a-row>
                    </div>
                    <div class="item">
                      <div class="row">
                        <div
                          @click="changeB"
                          class="label"
                          :class="
                            drags[activeIndex].fontWeight == 'bold'
                              ? 'active'
                              : ''
                          "
                        >
                          <b>B</b>
                        </div>
                        <div
                          @click="changeI"
                          class="label"
                          :class="
                            drags[activeIndex].fontStyle == 'italic'
                              ? 'active'
                              : ''
                          "
                        >
                          <em>I</em>
                        </div>
                        <div
                          @click="changeU"
                          class="label"
                          :class="
                            drags[activeIndex].textDecoration == 'underline'
                              ? 'active'
                              : ''
                          "
                        >
                          <u> U </u>
                        </div>
                        <div
                          @click="changeS"
                          class="label"
                          :class="
                            drags[activeIndex].textDecoration == 'line-through'
                              ? 'active'
                              : ''
                          "
                        >
                          <s>S</s>
                        </div>
                        <div @click="clear" class="label">清除</div>
                      </div>
                      <div class="row">
                        <div class="col-3">
                          <div
                            @click="drags[activeIndex].textAlign = 'left'"
                            :class="
                              drags[activeIndex].textAlign == 'left' ||
                              !drags[activeIndex].textAlign
                                ? 'active'
                                : ''
                            "
                            class="cell"
                          >
                            <i class="miconfont icon-align-left"></i>
                          </div>
                          <div
                            @click="drags[activeIndex].textAlign = 'center'"
                            :class="
                              drags[activeIndex].textAlign == 'center'
                                ? 'active'
                                : ''
                            "
                            class="cell"
                          >
                            <i class="miconfont icon-align-center"></i>
                          </div>
                          <div
                            @click="drags[activeIndex].textAlign = 'right'"
                            :class="
                              drags[activeIndex].textAlign == 'right'
                                ? 'active'
                                : ''
                            "
                            class="cell"
                          >
                            <i class="miconfont icon-align-right"></i>
                          </div>
                          <div
                            @click="drags[activeIndex].textAlign = 'justify'"
                            :class="
                              drags[activeIndex].textAlign == 'justify'
                                ? 'active'
                                : ''
                            "
                            class="cell"
                          >
                            <i class="miconfont icon-menu"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--缩进-->
                    <div class="item">
                      <div class="row">
                        <div @click="addTextIndent" class="label outline">
                          <i
                            style="font-size: 22px"
                            class="miconfont icon-indent"
                          ></i>
                        </div>
                        <div @click="decTextIndent" class="label outline">
                          <i
                            style="font-size: 22px"
                            class="miconfont icon-outdent"
                          ></i>
                        </div>
                        <div @click="cancelPasterDrag" class="label outline">
                          <a-row>
                            <a-col :span="24" style="text-align: center">
                              <div style="margin-bottom: 5px">字体颜色</div>
                              <el-color-picker
                                color-format="hex"
                                v-model="drags[activeIndex].fColor"
                              ></el-color-picker>
                            </a-col>
                          </a-row>
                        </div>
                      </div>
                    </div>
                    <!--字号-->
                    <div class="item">
                      <div class="row">
                        <div
                          @click="changeFSize(58.667)"
                          :class="
                            drags[activeIndex].fSize == 58.667 ? 'active' : ''
                          "
                          class="label"
                        >
                          初号
                        </div>
                        <div
                          @click="changeFSize(48)"
                          :class="
                            drags[activeIndex].fSize == 48 ? 'active' : ''
                          "
                          class="label"
                        >
                          小初号
                        </div>
                        <div
                          @click="changeFSize(32)"
                          :class="
                            drags[activeIndex].fSize == 32 ? 'active' : ''
                          "
                          class="label"
                        >
                          小一号
                        </div>
                        <div
                          @click="changeFSize(29.333)"
                          :class="
                            drags[activeIndex].fSize == 29.333 ? 'active' : ''
                          "
                          class="label"
                        >
                          二号
                        </div>
                        <div
                          @click="changeFSize(24)"
                          :class="
                            drags[activeIndex].fSize == 24 ? 'active' : ''
                          "
                          class="label"
                        >
                          小二号
                        </div>
                      </div>
                      <div class="row">
                        <div
                          @click="changeFSize(21.333)"
                          :class="
                            drags[activeIndex].fSize == 21.333 ? 'active' : ''
                          "
                          class="label"
                        >
                          三号
                        </div>
                        <div
                          @click="changeFSize(18.667)"
                          :class="
                            drags[activeIndex].fSize == 18.667 ? 'active' : ''
                          "
                          class="label"
                        >
                          四号
                        </div>
                        <div
                          @click="changeFSize(16)"
                          :class="
                            drags[activeIndex].fSize == 16 ? 'active' : ''
                          "
                          class="label"
                        >
                          小四号
                        </div>
                        <div
                          @click="changeFSize(14)"
                          :class="
                            drags[activeIndex].fSize == 14 ? 'active' : ''
                          "
                          class="label"
                        >
                          五号
                        </div>
                        <div
                          @click="changeFSize(12)"
                          :class="
                            drags[activeIndex].fSize == 12 ? 'active' : ''
                          "
                          class="label"
                        >
                          小五号
                        </div>
                      </div>
                    </div>
                    <!--颜色-->
                  </div>
                </div>
              </div>
              <div
                v-if="drags[activeIndex].type == 5 && !drags[activeIndex].lock"
                class="section-item"
              >
                <div class="item-line">
                  <span class="name2" style="width: 70px">内容</span>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px">文字行高</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-input
                      :disabled="drags[activeIndex].lineHeightAutoSize == 1"
                      class="input"
                      v-model="drags[activeIndex].lineHeight"
                      type="number"
                    >
                    </a-input>
                  </div>
                </div>
                <div class="item-line">
                  <span class="name2" style="width: 70px"></span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-checkbox
                      @change="onChangeAutoSize"
                      :checked="drags[activeIndex].lineHeightAutoSize == 1"
                    >
                      自动计算行高
                    </a-checkbox>
                  </div>
                </div>
                <!-- <div class="item-line">
                <span class="name2" style="width: 70px">排列方式</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-select v-model="drags[activeIndex].writeMode" placeholder="请选择" style="width:120px">
                    <a-select-option label="横排" value="horizontal-tb">横排</a-select-option>
                    <a-select-option label="竖排-从右向左" value="vertical-rl">
                      竖排-从右向左</a-select-option
                    >
                    <a-select-option label="竖排-从左向右" value="vertical-lr">
                      竖排-从左向右</a-select-option>
                  </a-select>
                </div>
              </div> -->
              </div>
              <div class="section-item">
                <div class="item-line">
                  <div class="cell" style="width:100%">
                    <span class="name" style="width:70px">创建时间</span>
                    <span>{{
                      dayjs(drags[activeIndex].create_time * 1000).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    }}</span>
                  </div>
                </div>
                <div class="item-line">
                  <div class="cell" style="width:100%">
                    <span class="name" style="width:70px">上次更新</span>
                    <span>{{
                      dayjs(drags[activeIndex].update_time * 1000).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  drags[activeIndex].type == 1 ||
                    drags[activeIndex].type == 2 ||
                    drags[activeIndex].type == 9
                "
                class="section-item"
              >
                <div class="item-line">
                  <div class="cell" style="width:100%">
                    <span class="name" style="width:70px">照片格式</span>
                    <span>{{ drags[activeIndex] | filterPhoto }}</span>
                  </div>
                </div>
              </div>
              <div v-if="showFootbtn" class="section-item">
                <div class="item-line">
                  <a-input-search
                    v-model="search_id"
                    @search="searchId"
                    placeholder="c_id检索"
                  ></a-input-search>
                </div>
                <div class="item-line">
                  <a-input-search
                    v-model="search_id2"
                    @search="searchId2"
                    placeholder="ec_id检索"
                  ></a-input-search>
                </div>
              </div>
              </section>
              
            </div>
          </div>
        </div>
        <div
          class="cell photo-box"
          ref="pic"
          onselectstart="return false"
          v-if="tabIndex == 1"
        >
          <div
            class="searchbox"
            style="display:flex;flex-direction:row;justify-content:center"
          >
            <a-select
              style="width:160px;margin-left:10px"
              v-model="album_id"
              @change="changeAlbum"
            >
              <a-select-option
                v-for="item in albumList"
                :key="item.id"
                :value="item.id"
              >
                <div class="flex-row" style="justify-content: space-between;">
                  <span>{{ item.name }}</span>
                  <span
                    v-if="item.id == album_id"
                    class="total"
                    style="margin-left: 5px;"
                    >({{ picturePage.total }})</span
                  >
                </div>
              </a-select-option>
            </a-select>
            <a-button @click="openUploadModal">
              <a-icon type="upload"></a-icon>上传照片
            </a-button>
          </div>
          <a-empty
            description="暂无内容"
            v-show="!photoLoad && pictures.length == 0"
            style="margin-top:10px;width:100%"
          />
          <div
            v-show="!photoLoad && pictures.length == 0"
            @click="refreshAlbum"
            style="line-height: 14px;cursor: pointer;color: blue;text-align: center;margin: 10px auto;"
          >
            <i class="miconfont icon-sync"></i>
            刷新重试
          </div>
          <a-spin :spinning="photoLoad">
            <div
              v-for="(item, index) in pictures"
              :key="index"
              class="back-item"
              style="background: #eee;min-height: 50px;"
            >
              <div
                @click="togoPhoto(item, index)"
                class="back"
                :class="item.select ? 'select' : ''"
                style="margin-bottom: 0;"
              >
                <img
                  @mouseenter="handleMouseEnterImg(item.img_url)"
                  @mouseleave="handleMouseLeaveImg(item.img_url)"
                  @mousedown="handleSelectPhoto(item.img_url)"
                  @mouseup="mouseUpPhoto(item.img_url)"
                  class="img"
                  :src="item.img_url"
                  alt=""
                />
                <div v-if="item.select" class="iconfont3 icon-duigou"></div>
                <div v-if="item.use_times" class="times">
                  {{ item.use_times }}
                </div>
              </div>
              <!-- <div class="name">{{ item.p_id }}</div> -->
            </div>
          </a-spin>

          <div v-if="picturePage" class="pagebox">
            <a-pagination
              show-quick-jumper
              :defaultPageSize="15"
              size="small"
              :current="picturePage.current_page"
              :total="picturePage.total"
              @change="onChangepicturePage"
            />
          </div>
        </div>
        <div
          class="cell photo-box"
          onselectstart="return false"
          v-if="tabIndex == 2"
        >
          <div class="searchbox" style="display: block;">
            <a-row>
              <a-col :span="12">
                <a-select
                  style="width:100%;"
                  v-model="pasterType"
                  @change="changePasterType"
                >
                  <a-select-option :value="1">通用素材</a-select-option>
                  <a-select-option :value="2">专属素材</a-select-option>
                  <a-select-option :value="3">个人素材</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12" style="padding-right: 10px;">
                <a-select
                  style="width:100%;margin-left:10px;"
                  v-model="pasterClassId"
                  @change="changePasterClassId"
                >
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in pasterClass"
                    :key="index"
                    :value="item.pc_id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>

            <a-input-search
              style="margin-top:10px"
              placeholder="搜索名称"
              v-model="pasterTag"
              enter-button
              @search="onSearchimgs"
            />
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleSelectText()"
              @click="addText()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleStarSelect()"
              @click="addStar()"
              class="look"
            >
              <img class="img" :src="require('../assets/rant.png')" alt="" />
            </div>
          </div>
          <div v-for="(item, index) in imgs" :key="index" class="back-item">
            <div v-if="pasterType != 3" class="back">
              <img
                ref="paster"
                @mousedown="handleSelectPhotoUrl(item.paster, index)"
                @mouseup="mouseUpPhoto(item.paster)"
                @click="addPhoto2(item.paster)"
                class="img"
                :src="item.paster"
                alt=""
              />
            </div>
            <div v-if="pasterType == 3" class="back">
              <img
                ref="paster"
                @mousedown="handleSelectPhotoUrl(item.img_personal)"
                @mouseup="mouseUpPhoto(item.img_personal)"
                @click="addPhoto2(item.img_personal)"
                class="img"
                :src="item.img_personal"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              show-quick-jumper
              show-less-items
              size="small"
              :defaultPageSize="16"
              :current="imgPage.current_page"
              :total="imgPage.total"
              @change="onChangeImgPage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 3">
          <div class="photo-item">
            <div
              @mousedown="handleSelectText()"
              @click="addText()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
            <div class="name">文本框</div>
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleStarSelect()"
              @click="addStar()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
            <div class="name">文本框</div>
          </div>
        </div>
        <div
          class="cell photo-box"
          onselectstart="return false"
          v-if="tabIndex == 4"
        >
          <div class="searchbox">
            <a-select
              style="width:120px;margin-left:10px"
              v-model="frameType"
              @change="changeFrameType"
            >
              <a-select-option :value="1">通用相框</a-select-option>
              <a-select-option :value="2">专属相框</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="frameTag"
              enter-button
              @search="onSearchphotos"
            />
          </div>
          <div
            v-for="(item, index) in suireList"
            :key="'squire' + index"
            class="photo-item"
          >
            <div
              @mousedown="handleAddSquire(index)"
              @click="addSquire(0)"
              class="look"
              draggable="true"
              :style="{ border: '1px solid #eee', backgroundColor: '#eeeeee' }"
            >
              <div
                :style="{
                  width: '100%',
                  height: (item.height * 100) / item.width + 'px',
                  paddingLeft: item.paddingLeft + 'px',
                  paddingTop: item.paddingTop + 'px',
                  paddingRight: item.paddingRight + 'px',
                  paddingBottom: item.paddingBottom + 'px',
                  backgroundColor: item.bColor,
                  borderRadius: item.borderRadius + 'px',
                  borderColor: item.bordersColor,
                  borderStyle: item.bStyle,
                  borderTopWidth: item.bTop + 'px',
                  borderBottomWidth: item.bBottom + 'px',
                  borderLeftWidth: item.bLeft + 'px',
                  borderRightWidth: item.bRight + 'px',
                }"
              ></div>
            </div>
          </div>
          <div v-for="(item, index) in photos" :key="index" class="photo-item">
            <div
              @mousedown="handleSelectPhoto2(item, index)"
              @click="addPhoto(item)"
              :style="item"
              class="look"
            >
              <img
                ref="frame"
                :style="{ borderRadius: item.borderRadius }"
                class="img"
                :src="item.backgroundImg"
                alt=""
              />
              <img
                v-if="item.backImg2"
                class="img2"
                :src="item.backImg2"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              :defaultPageSize="14"
              :current="photoPage.current_page"
              :total="photoPage.total"
              show-quick-jumper
              show-less-items
              @change="onChangeframePage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 5">
          <div class="searchbox">
            <a-select
              style="width:120px;margin-left:10px"
              v-model="backgroundType"
              @change="changeBackType"
            >
              <a-select-option :value="1">通用背景</a-select-option>
              <a-select-option :value="2">专属背景</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="backgroundTag"
              enter-button
              @search="onSearchbacks"
            />
          </div>
          <a-empty
            description="暂无内容"
            v-show="backs.length == 0"
            style="margin-top:10px"
          />
          <div v-for="(item, index) in backs" :key="index" class="back-item">
            <div class="back">
              <img
                @click="changeBack(item.background)"
                class="img"
                :src="item.background"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              :defaultPageSize="12"
              show-quick-jumper
              show-less-items
              :current="backPage.current_page"
              :total="backPage.total"
              @change="onChangeBackPage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 6">
          <div class="searchbox">
            <a-select
              v-model="buildUpType"
              style="width:120px;margin-left:10px"
              @change="changeBuildType"
            >
              <a-select-option :value="1">通用组合</a-select-option>
              <a-select-option :value="2">专属组合</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              enter-button
              v-model="buildUpTag"
              @search="onSearchbuildup"
            />
          </div>
          <a-empty
            description="暂无内容"
            v-show="buildUp.length == 0"
            style="margin-top:10px"
          />
          <div
            v-for="(build, index) in buildUp"
            :key="index"
            @mousedown="handleSelectCombination($event, index)"
            class="build-item"
            draggable="true"
          >
            <div @mouseup="handleEndMovecom" ref="comItem" class="look">
              <div
                class="wrap"
                :style="{
                  width: build.width + 'px',
                  height: build.height + 'px',
                  transform: `scale(${build.scale})`,
                }"
              >
                <vue-draggable-resizable
                  v-for="(item, index2) in build.coms"
                  :key="index2"
                  :w="item.width"
                  :h="item.height"
                  :x="item.left"
                  :y="item.top"
                  :r="item.rotate"
                  :z="item.zIndex"
                  :frameId="'buildup' + index + '_' + index2"
                  :photoScale="item.photoScale"
                  :photoLeft="item.photoLeft"
                  :photoTop="item.photoTop"
                  :showPhoto="item.showPhoto"
                  :shadow="item.shadow ? true : false"
                  :allIndex="allIndex"
                  :dIndex="index"
                  :debug="false"
                  :disable="true"
                  :lineHeight="item.lineHeight"
                  :fontWeight="item.fontWeight"
                  :fontStyle="item.fontStyle"
                  :textAlign="item.textAlign"
                  :type="item.type"
                  :isConflictCheck="false"
                  :snap="true"
                  :snapTolerance="1"
                  :lockAspectRatio="item.lockAspectRatio ? true : false"
                  :backImg="item.backgroundImg ? item.backgroundImg : ''"
                  :bImg2="item.backImg2"
                  :bRadius="item.borderRadius"
                  :fontColor="item.fColor"
                  :text="item.textarea"
                  :o="item.opacity"
                  :l="item.lock ? true : false"
                  dragHandle="false"
                  :backColor="item.bColor"
                  :borderColor="item.bordersColor"
                  :borderLeft="item.bLeft"
                  :borderTop="item.bTop"
                  :borderRight="item.bRight"
                  :borderBottom="item.bBottom"
                  :borderStyle="item.bStyle"
                  :paddingLeft="item.paddingLeft"
                  :paddingTop="item.paddingTop"
                  :paddingRight="item.paddingRight"
                  :paddingBottom="item.paddingBottom"
                  :active="false"
                  :fontSize="item.fSize"
                ></vue-draggable-resizable>
              </div>
            </div>
            <!-- <div class="name">{{ index }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              show-quick-jumper
              show-less-items
              :defaultPageSize="15"
              :current="buildUpPage.current_page"
              :total="buildUpPage.total"
              @change="onChangeBuildPage"
            />
          </div>
        </div>
        <div class="cell" v-if="tabIndex == 7">
          <div class="edit-list">
            <div
              v-for="(item, index) in editList"
              :key="index"
              class="edit-cell"
            >
              <div class="name">{{ item.student_name }}</div>
              <a-textarea
                style="width:100%;height: auto"
                v-if="item.type == 5"
                v-model="item.textarea"
                @blur="pressEnter($event, index)"
                @focus="editorFocus($event, index)"
                @change="changeEditText($event, index)"
              ></a-textarea>
              <a-button
                size="small"
                @click="saveThisEdit(index)"
                style="margin-left:4px"
                :disabled="item.saveState ? false : true"
                type="primary"
                >保存</a-button
              >
            </div>
          </div>
        </div>
        <div class="cell" v-if="tabIndex == 9">
          <div class="edit-list">
            <div
              v-for="(item, index) in editList"
              :key="index"
              class="edit-cell"
            >
              <div class="name">{{ item.student_name }}</div>
              <a-textarea
                style="width:100%;height: auto"
                v-model="item.eguc_id"
                @blur="pressEnter($event, index)"
                @focus="editorFocus($event, index)"
                @change="changeEditText($event, index)"
              ></a-textarea>
              <a-button
                size="small"
                @click="saveThisEdit(index)"
                style="margin-left:4px"
                :disabled="item.saveState ? false : true"
                type="primary"
                >保存</a-button
              >
            </div>
          </div>
        </div>
        <div class="cell" v-if="tabIndex == 8">
          <div class="tel-list">
            <div class="search">
              <a-input-search
                style="border: none;"
                v-model="telSearch"
                placeholder="关键字搜索"
                enter-button
                @search="onTelSearch"
              ></a-input-search>
            </div>
            <a-empty
              description="暂无内容"
              v-show="telList.length == 0"
              style="margin-top:10px"
            />
            <div v-for="(item, index) in telList" :key="index" class="tel-cell">
              <div class="name">{{ item.content }}</div>
              <!-- <a-textarea
                style="width:100%;height: auto"
                v-model="item.content"
              ></a-textarea> -->
              <div class="button" style="clear: both;overflow: hidden;">
                <a-button
                  size="small"
                  style="margin-left:4px"
                  type="primary"
                  v-clipboard:copy="item.content"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >复制</a-button
                >
              </div>
            </div>
          </div>
          <div v-if="telPage" class="pagebox">
            <a-pagination
              show-quick-jumper
              :defaultPageSize="9"
              size="small"
              :current="telPage.current_page"
              :total="telPage.total"
              @change="onChangeTelPage"
            />
          </div>
        </div>
        <div class="cell" v-if="tabIndex == 10">
          <div class="log-list-header">
            <div class="log-view-status">
              <span class="log-view-label">当前查看：</span>
              <span 
                class="log-view-text" 
                :class="logViewMode === 'all' ? 'mode-all' : 'mode-single'"
              >
                {{ logViewMode === 'all' ? '全部日志' : '单个组件日志' }}
              </span>
              <!-- <span v-if="logViewMode === 'single' && currentEcId" class="log-view-ec">
                ({{ currentEcId }})
              </span> -->
            </div>
            <a-button 
              v-if="logViewMode === 'single'" 
              size="small" 
              @click="viewAllLogs"
            >
              查看全部
            </a-button>
          </div>
          <operation-log-list
            :log-list="logList"
            :loading="loadingLog"
            :pagination="pagination"
            @pagination-change="handleLogPaginationChange"
          />
        </div>
        <div v-if="fixBtnLeft > 0" class="fixbtn" :style="leftBtnStyle">
          <div class="tip">按住空格键SPACE可自由拖拽画布</div>
          <div class="flex-row">
            <a-button @click="downloadImg" type="primary">生成图片</a-button>
          </div>
          <div class="flex-row">
            <div @click="cancelStep" alt="ctrl+z" class="item">
              <a-tooltip placement="bottom">
                <template #title>
                  <span>ctrl+z</span>
                </template>
                <a-icon
                  :style="{ fontSize: '28px', color: '#1890ff' }"
                  type="swap-left"
                />
                <div class="name">撤销</div>
              </a-tooltip>
            </div>
            <div
              @click="nextStep"
              alt="ctrl+shift+z"
              class="item"
              style="margin-left:16px"
            >
              <a-tooltip placement="bottom">
                <template #title>
                  <span>ctrl+shift+z</span>
                </template>
                <a-icon
                  :style="{ fontSize: '28px', color: '#1890ff' }"
                  type="swap-right"
                />
                <div class="name">前进</div>
              </a-tooltip>
            </div>
          </div>
          <!-- <div class="step">
            <div class="num">当前{{ step }}步</div>
            <div v-for="(item, index) in czHistory" :key="index">
              <div class="index">第{{ index }}步</div>
              <div class="type">{{ czHistory[index].type }}</div>
            </div>
          </div> -->
          <!-- <a-button @click="savePlateContent" type="primary">保存此页</a-button>
          <a-button @click="delPlateContent" type="default">删除此页</a-button> -->
        </div>
        <!-- <div v-if="fixBtnLeft > 0" class="fixbtn" :style="networkStyle">
          <div class="flex-row">
            <a-button @click="downloadImg" type="primary">生成图片</a-button>
          </div>
        </div> -->
      </div>
      <div v-show="familyMask" @click="familyMask = false" class="mask2"></div>

      <a-modal
        :visible="drawImg"
        centered
        :footer="false"
        width="300px"
        :mask="true"
        @cancel="cancelDrawimg"
        :closable="true"
      >
        <div class="uploadstate">
          <a-icon type="loading"></a-icon>
          图片生成中
        </div>
      </a-modal>
      <a-modal
        :visible="showSaveText"
        centered
        title="保存文本模板"
        :mask="true"
        @cancel="showSaveText = false"
        @ok="confirmSaveText"
        :closable="true"
      >
        <div class="uploadstate">
          <a-input
            v-model="textTel.name"
            style="margin-bottom: 10px;"
            placeholder="请输入文本模板标题"
          ></a-input>
          <a-textarea
            v-model="textTel.content"
            style="height: 160px;"
          ></a-textarea>
        </div>
      </a-modal>
      <a-modal
        v-model="showTypeSelect"
        title="选择新增内容"
        centered
        width="800px"
        @ok="confirmPageType"
      >
        <a-radio-group
          v-show="!pageObject"
          v-model="addType"
          @change="changeAddtype"
          style="margin-bottom:20px"
        >
          <a-radio key="0" value="">页面</a-radio>
          <a-radio key="3" value="3">封面模板</a-radio>
          <a-radio key="1" value="1">完整模板</a-radio>
        </a-radio-group>

        <a-select
          v-if="!addType"
          style="width:100%"
          v-model="typeSelect"
          @change="changePage"
        >
          <a-select-option
            v-for="item in typeSelector"
            :key="item.type"
            :value="item.type"
            >{{ item.name }}
          </a-select-option>
        </a-select>

        <div v-if="addType" class="plate">
          <div class="search">
            <a-input-search
              placeholder="输入模板名称搜索"
              v-model="plate_name"
              enter-button
              @search="onPlateSearch"
            >
            </a-input-search>
          </div>
          <a-empty
            description="暂无内容"
            style="margin-top:20px"
            v-show="plateList.length == 0"
          />
          <div v-show="plateList.length > 0" class="plate-list">
            <div
              @click="selectPlate(index)"
              :class="item.select ? 'select' : ''"
              v-for="(item, index) in plateList"
              :key="index"
              :style="{
                backgroundImage: 'url(' + item.cover + ')',
                backgroundSize: 'contain',
              }"
              class="cell"
            >
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
          <div
            v-show="plateList.length > 0"
            class="page"
            style="clear:both;overflow:hidden;margin-top:20px"
          >
            <a-pagination
              show-quick-jumper
              show-less-items
              size="small"
              style="float:right"
              :current="currentPage"
              :total="plateTotal"
              :defaultPageSize="10"
              @change="onChangePlatePage"
            />
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="uploadModal"
        centered
        :title="'添加照片'"
        width="1180px"
        footer=""
        @cancel="uploadModal = false"
      >
        <div class="photos">
          <a-upload-dragger
            name="file"
            list-type="picture-card"
            :multiple="true"
            :file-list="fileList"
            :data="{related_path: 'album'}"
            :action="$api.domain + $api.addPhoto"
            :before-upload="beforeUpload"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic"
            @preview="handlePreview"
            @change="handleuploadChange"
            :transform-file="transformFile"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或者拖拽图片到此处
            </p>
          </a-upload-dragger>
          <div v-if="errorUploadState" style="text-align:right">
            <a-space>
              <a-button @click="cancelUpload">
                取消添加
              </a-button>
              <a-button @click="confirmUpload" type="primary">
                忽略并添加相册
              </a-button>
            </a-space>
          </div>
        </div>
      </a-modal>
      <a-modal
        title="页码"
        width="750px"
        :dialog-style="{ top: '0px', margin: 0, left: '307px' }"
        :visible="pageModal"
        :centered="false"
        :mask="false"
        @cancel="pageModal = false"
        footer=""
      >
        <div v-if="pages.length > 0 && pageModal" class="page-list">
          <div
            @click="changeGrowPage(index)"
            v-for="(pageitem, index) in pages2"
            :key="pageitem.c_id"
            class="cell"
          >
            <div
              class="dragbox"
              :style="{ height: (750 * 120) / wrapperWidth + 'px' }"
            >
              <div
                class="wrapper"
                :style="{
                  transform: `scale(${(750 * 120) / wrapperWidth / 750})`,
                }"
              >
                <div
                  class="wrap2"
                  :style="{
                    width: wrapperWidth + 'px',
                    height: 750 + 'px',
                    backgroundImage: 'url(' + pageitem.img_bg + ')',
                    backgroundSize: '100% 100%',
                    backgroundColor: '#cccccc',
                  }"
                >
                  <vue-draggable-resizable
                    v-for="(item, index2) in pageitem.content"
                    :key="item.ec_id"
                    :w="item.width"
                    :h="item.height"
                    :enableNativeDrag="true"
                    :x="item.left"
                    :y="item.top"
                    :r="item.rotate"
                    :fontFamily="item.fontFamily"
                    :z="item.zIndex"
                    :photoRotate="item.photoRotate"
                    :level="item.level"
                    :levelType="item.levelType"
                    :frameId="'item' + index + index2"
                    :photoScale="item.photoScale"
                    :photoLeft="item.photoLeft"
                    :photoTop="item.photoTop"
                    :showPhoto="item.showPhoto"
                    :shadow="item.shadow ? true : false"
                    :allIndex="allIndex"
                    :dIndex="index"
                    :debug="false"
                    :disable="true"
                    :textDecoration="item.textDecoration"
                    :textIndent="item.textIndent"
                    :writingMode="item.writeMode"
                    :lineHeight="item.lineHeight"
                    :fontWeight="item.fontWeight"
                    :fontStyle="item.fontStyle"
                    :textAlign="item.textAlign"
                    :type="item.type"
                    :isConflictCheck="false"
                    :snap="true"
                    :snapTolerance="1"
                    :lockAspectRatio="item.lockAspectRatio ? true : false"
                    :backImg="item.backgroundImg ? item.backgroundImg : ''"
                    :bImg2="item.backImg2"
                    :bRadius="item.borderRadius"
                    :fontColor="item.fColor"
                    :text="item.textarea"
                    :o="item.opacity"
                    :l="item.lock ? true : false"
                    dragHandle="false"
                    :backColor="item.bColor"
                    :borderColor="item.bordersColor"
                    :borderLeft="item.bLeft"
                    :borderTop="item.bTop"
                    :borderRight="item.bRight"
                    :borderBottom="item.bBottom"
                    :borderStyle="item.bStyle"
                    :paddingLeft="item.paddingLeft"
                    :paddingTop="item.paddingTop"
                    :paddingRight="item.paddingRight"
                    :paddingBottom="item.paddingBottom"
                    :active="false"
                    :fontSize="item.fSize"
                  >
                    <div v-if="item.type == 3" class="look" style="z-index:-1">
                      <div
                        class="wrap"
                        :style="{
                          width: item.width + 'px',
                          height: item.height + 'px',
                          transform: `scale(${item.width /
                            item.orignWidth},${item.height /
                            item.orignHeight})`,
                          transformOrigin: '0px 0px',
                        }"
                      >
                        <vue-draggable-resizable
                          v-for="(item2, index2) in item.coms"
                          :key="index2"
                          :w="item2.width"
                          :h="item2.height"
                          :x="item2.left"
                          :y="item2.top"
                          :r="item2.rotate"
                          :z="item2.zIndex"
                          :showPhoto="item2.showPhoto"
                          :shadow="item2.shadow ? true : false"
                          :allIndex="allIndex"
                          :dIndex="index"
                          :debug="false"
                          :disable="true"
                          :textDecoration="item.textDecoration"
                          :textIndent="item.textIndent"
                          :writingMode="item.writeMode"
                          :lineHeight="item2.lineHeight"
                          :fontWeight="item2.fontWeight"
                          :fontStyle="item2.fontStyle"
                          :textAlign="item2.textAlign"
                          :type="item2.type"
                          :isConflictCheck="false"
                          :snap="true"
                          :snapTolerance="1"
                          :lockAspectRatio="
                            item2.lockAspectRatio ? true : false
                          "
                          :backImg="
                            item2.backgroundImg ? item2.backgroundImg : ''
                          "
                          :bImg2="item2.backImg2"
                          :bRadius="item2.borderRadius"
                          :fontColor="item2.fColor"
                          :text="item2.textarea"
                          :o="item2.opacity"
                          :l="item2.lock ? true : false"
                          dragHandle="false"
                          :backColor="item2.bColor"
                          :borderColor="item2.bordersColor"
                          :borderLeft="item2.bLeft"
                          :borderTop="item2.bTop"
                          :borderRight="item2.bRight"
                          :borderBottom="item2.bBottom"
                          :borderStyle="item2.bStyle"
                          :paddingLeft="item2.paddingLeft"
                          :paddingTop="item2.paddingTop"
                          :paddingRight="item2.paddingRight"
                          :paddingBottom="item2.paddingBottom"
                          :active="false"
                          :fontSize="item2.fSize"
                        ></vue-draggable-resizable>
                      </div>
                    </div>
                  </vue-draggable-resizable>
                </div>
              </div>
              <div v-show="pageitem.is_lock" class="lock">
                <i class="iconfont icon-suoding1"></i>
                <div class="name">
                  {{
                    pageitem.lock_info.is_teacher
                      ? pageitem.lock_info.teacher_name
                      : pageitem.lock_info.relation
                  }}
                </div>
              </div>
            </div>
            <div class="name">
              {{
                pageitem.type == 1
                  ? "封面"
                  : pageitem.type == 3
                  ? "封底"
                  : pageitem.page_num
              }}
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="previewVisible"
        width="800px"
        :footer="null"
        @cancel="handleCancel"
      >
        <div style="padding:20px">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
      <a-modal
        title="点击下载"
        :visible="pdfPageState"
        :footer="null"
        @cancel="pdfPageState = false"
      >
        <div style="padding:20px">
          <a :href="pdfPage" target="_blank" rel="noopener noreferrer">
            <img alt="example" style="width: 100%" :src="pdfPage" />
          </a>
        </div>
      </a-modal>
      <a-modal
        title="更换页码"
        :visible="showPageNum"
        @cancel="showPageNum = false"
        @ok="changePageNum2"
      >
        <div style="padding:20px">
          <a-input
            v-model="newPageNum"
            placeholder="请输入跳转后页码"
          ></a-input>
        </div>
      </a-modal>
      <a-modal
        :visible="previewFrame"
        width="810px"
        title="更换相框"
        :footer="null"
        @cancel="previewFrame = false"
        centered
      >
        <div class="frameModal" style="padding:20px">
          <div class="searchbox" style="margin-bottom:10px">
            <a-select
              style="width:120px;margin-left:10px"
              v-model="frameType2"
              @change="changeFrameType2"
            >
              <a-select-option :value="1">通用相框</a-select-option>
              <a-select-option :value="2">专属相框</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="frameTag2"
              enter-button
              @search="onSearchphotos2"
            />
          </div>
          <div v-for="(item, index) in photos2" :key="index" class="photo-item">
            <div @click="changeFrame(item)" :style="item" class="look">
              <img
                ref="frame"
                :style="{ borderRadius: item.borderRadius }"
                class="img"
                :src="item.backgroundImg"
                alt=""
              />
              <img
                v-if="item.backImg2"
                class="img2"
                :src="item.backImg2"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div
            v-if="photoPage2"
            style="text-align:right;padding-right:20px"
            class="pagebox"
          >
            <a-pagination
              size="small"
              :defaultPageSize="14"
              :current="photoPage2.current_page"
              :total="photoPage2.total"
              show-quick-jumper
              show-less-items
              @change="onChangeframePage2"
            />
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="eiditVisible"
        width="800px"
        centered
        :closable="false"
        @ok="confirmEdit"
        @cancel="handleCancelEdit"
      >
        <div
          style="padding:0px;height:500px;box-sizing:border-box;border: 1px solid #eee;"
        >
          <div class="tool">
            <button></button>
          </div>
          <!-- <quill-editor
            v-model="editText"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
            @textChange="onTextchange($event)"
            class="editor"
          >
          </quill-editor> -->

          <textarea
            v-if="activeIndex > -1"
            :style="style3"
            name=""
            id=""
            v-model="editText"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </a-modal>
    </div>
    <div v-if="tabIndex == 1" class="rightfix">
      <div @click="pullPhoto" class="pull-p">
        <img src="../assets/logo4.png" alt="" />
        <span>照片导入</span>
      </div>
      <div @click="clearPhoto" class="clear-p">
        <img src="../assets/logo5.png" alt="" />
        <span>照片清除</span>
      </div>
    </div>
    <div v-if="tabIndex != 1" class="rightfix">
      <div @click="showSaveTpl = true" class="pull-p">
        <img src="../assets/logo4.png" alt="" />
        <span>另存模板</span>
      </div>
      <a-modal
        :visible="showSaveTpl"
        centered
        title="保存个人模板"
        :mask="true"
        @cancel="showSaveTpl = false"
        @ok="handleSaveToTpl"
        :confirm-loading="confirmLoding"
        :closable="true"
      >
        <div class="uploadstate">
          <a-input
            v-model="tplName"
            style="margin-bottom: 10px;"
            placeholder="请输入模板名称"
          ></a-input>
          
        </div>
        <template slot="footer">
            <a-checkbox style="float: left;" v-model="has_photos">保留照片</a-checkbox>
          
          <a-button key="back" @click="showSaveTpl = false">
            取消
          </a-button>
          <a-button key="submit" type="primary" :loading="confirmLoding" @click="handleSaveToTpl">
            确认
          </a-button>
      </template>
      </a-modal>
    </div>
    <div v-if="showFootbtn" class="clearbt">
      <!-- <a-button
        @click="downloadImgNew"
        style="background-color:rgb(42, 135, 197);margin-right:10px;color:#fff"
      >
        下载预览图片（新系统）</a-button
      > -->
      <a-button @click="clearErrorDrag" style="background-color:rgb(42, 135, 97);margin-right:10px;color:#fff" type="primary">清理宽度异常组件</a-button>
      <a-button
        @click="downloadImg2"
        style="background-color:rgb(42, 135, 197);margin-right:10px;color:#fff"
        >下载预览图片
      </a-button>
      <a-button @click="resetPage" type="danger" style="margin-right:10px"
        >重置学生成长册</a-button
      >
      <a-button
        @click="showPageNum = true"
        v-show="dzuoBtn"
        style="margin-right:10px"
        type="primary"
        >更改页码</a-button
      >
      <a-button @click="clearPage" type="primary">清除并还原此页组件</a-button>
    </div>
    <div class="left-tools">
      <div @mousedown="handleSelectSquire" class="item">
        <div class="type-squire"></div>
      </div>
      <div @mousedown="handleSelectCircle" class="item">
        <div class="type-circle"></div>
      </div>
      <div @mousedown="handleSelectLine" class="item">
        <div class="type-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import axios from "axios";
import { api } from "../api/api.js";
import { checkFileFormat } from "@/utils/validate";
import _ from "lodash";
import { mapState } from "vuex";
import * as Quill from "vue-quill-editor";
import { addQuillTitle } from "../js/quill-title.js";
import html2canvas from "html2canvas";
import FileSaver from "file-saver";
import { compressImageIfNeeded } from "../js/imageCom.js";
import { getCoordinate } from "../utils/fns.js";
import OperationLogList from "../components/operationLogList.vue";

import dayjs from "dayjs";
function getBlob(canvas) {
  //获取blob对象
  var data = canvas.toDataURL("image/png", 1);
  data = data.split(",")[1];
  data = window.atob(data);
  var ia = new Uint8Array(data.length);
  for (var i = 0; i < data.length; i++) {
    ia[i] = data.charCodeAt(i);
  }

  return new Blob([ia], {
    type: "image/jpeg",
  });
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  name: "app",
  components: {
    VueDraggableResizable,
    OperationLogList,
  },
  data() {
    return {
      has_photos:false,
      multipleDrag: {
        left: null,
        top: null,
        width: 240,
        height: 180,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#cccccc",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#ffffff",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        type: 9,
        name: "方块一",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        borderRadius: 0,
        coms: [],
      },
      confirmLoding: false,
      showSaveTpl: false,
      tplName: "",
      dzuoBtn: false,
      showPageNum: false,
      dayjs: dayjs,
      pasterClass: [],
      pasterClassId: "",
      showFootbtn: false,
      previewFrame: false,
      photos2: [],
      photoPage2: null,
      showIcon: false,
      priviewImg: "",
      moreSelect: false, //苹果电脑多选控制
      editContent: "",
      eiditVisible: false,
      editText: "",
      editorOption2: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [],
        },
      },
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [],
        },
      },
      previewImage: "",
      previewVisible: false,
      uploadModal: false,
      fileList: [],
      addType: "",
      step: -1,
      sizeSelct: 100,
      saveDraging: false,
      comHtml: null,
      showTypeSelect: false,
      album_id: "",
      photoLoad: false,
      typeSelector: [
        { type: 1, name: "封面" },
        { type: 2, name: "内页" },
        { type: 3, name: "封底" },
      ],
      familyMask: false,
      activeIndex: -1,
      pageDetail: null,
      drags: [],
      vLine: [],
      hLine: [],
      search_id: "",
      search_id2: "",
      kongwei: false,
      familyMask: false,
      tabIndex: 0,
      imgs: [
        { url: require("../assets/img01.png"), name: "背景1" },
      ],
      dragsSelectIndexs: [],
      dragsSelect: [],
      dragKey:1,
      suireList: [
        {
          left: null,
          top: null,
          width: 240,
          height: 180,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 240,
          height: 180,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
      ],
      stars: {
        left: null,
        top: null,
        width: 200,
        height: 38,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: "#ff6d2c",
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        borderRadius: 0,
        type: 4,
        name: "评级",
        lineHeight: "1.6",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        levelNum: 3,
        levelType: 1,
        level: 2,
      },
      errorUploadState: false,
      newPageNum: "",
      texts: {
        left: null,
        top: null,
        width: 200,
        height: 28,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 5,
        name: "文字框",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      },
      telSearch: "",
      selectHeight: 0,
      photoPage: null,
      imgPage: null,
      backPage: null,
      photos: [],
      pictures: [],
      backs: [],
      typeSelect: 2,
      currentBuild: 1,
      currentPaster: 1,
      currentPhoto: 1,
      currentBack: 1,
      currentFrame: 1,
      frameTag2: "",
      currentFrame2: 1,
      currentPicture: 1,
      api: api,
      fixBtnLeft: 0,
      pageModal: false,
      buildUp: [],
      buildUpPage: null,
      backgroundImage: "",
      allIndex: 0,
      wrapperWidth: 500,
      mouseIn: [],
      selectImg: "",
      maxPage: 0,
      selectPhoto: null,
      pageObject: null,
      selectPageType: 2,
      currentRowPage: 0,
      plateContent: null,
      czHistory: [],
      originDrags: [],
      ComIndex: -1, //拖动的组合
      bodyTranslateX: 0,
      bodyTranslateY: 0,
      leftChatMouseStateMove: false,
      uid: "",
      htmlUrl: "",
      plate_name: "",
      pages2: [],
      currentPage: 1,
      plateList: [],
      plateTotal: 0,
      s_id: "",
      studentList: [],
      pages: [],
      currentStudentIndex: -1,
      selectState: false,
      backgroundTag: "",
      frameTag: "",
      frameTag: "",
      frameType: 1,
      frameType2: 1,
      buildUpType: 1,
      pasterType: 1,
      backgroundType: 1,
      buildUpTag: "",
      pasterTag: "",
      editList: [],
      albumList: [],
      picturePage: null,
      pageLists: [],
      haomi: 0,
      studentName: "",
      page: 0,
      cover_size: [],
      editorState: false,
      moveBoxRight: 0,
      moveBoxTop: 0,
      moveBoxRotate: 0,
      rotateStyles: { left: 0, top: 0 },
      is_complete: false,
      drawImg: false,
      pdfPage: "",
      pdfPageState: false,
      keyDown: {
        shiftKey: false,
        ctrlKey: false,
      },
      selectPhotos: [],
      pullState: false,
      telPage: {
        currentPage: 1,
      },
      telList: [],
      textTel: {
        name: "",
        content: "",
        tc_id: "",
      },
      showSaveText: false,
      logList: [],
      loadingLog: false,
      logViewMode: 'all', // 'all' 或 'single'
      currentEcId: '',
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      },
    };
  },

  mounted() {
    window.addEventListener("beforeunload", this.updateHandler);
    var that = this;
    document.ondragover = function(e) {
      e.preventDefault();
    };
    // setTimeout(() => {
    //   this.saveHistoryChange();
    // }, 10000);
    this.$refs["body"].addEventListener(
      "mouseenter",
      (e) => {
        this.mouseEnterBody = true;
      },
      true
    );
    this.$refs["body"].addEventListener(
      "mouseleave",
      (e) => {
        this.mouseEnterBody = false;
      },
      true
    );
    this.$refs["body"].addEventListener("drop", (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectImg) {
        this.addDrag(e);
        setTimeout(() => {
          this.selectImg = "";
        }, 20);
      } else if (this.selectPhoto || this.ComIndex > -1) {
        this.addDrag(e);
      }
    });
    this.$refs["leftChat"].addEventListener("mousedown", (e) => {
      this.familyMask = false;
      this.dragsSelectIndexs = [];
    });
    this.$refs["body"].addEventListener("mousedown", (e) => {
      e.stopPropagation();
    });
    this.$refs["app"].addEventListener("drop", (e) => {
      setTimeout(() => {
        this.ComIndex = -1;
        this.selectPhoto = null;
        this.selectImg = "";
      }, 400);
    });
    setTimeout(() => {
      this.allIndex = this.drags.length;
    }, 1000);
    var that = this;
    document.onerror = function(e) {
      console.log(e);
    };
    this.$refs["leftChat"].addEventListener("mousedown", this.listenMouseDown);
    this.$refs["leftChat"].addEventListener("mouseup", () => {
      this.$refs["leftChat"].removeEventListener(
        "mousemove",
        this.listenMouseMove
      );
    });

    // 覆盖鼠标滑动
    document.body.addEventListener('wheel', (e) => {
        if (e.ctrlKey) {
            if (e.deltaY < 0) {
                e.preventDefault();
                return false;
            }
            if (e.deltaY > 0) {
                e.preventDefault();
                return false;
            }
        }
    }, { passive: false });
    document.onkeydown = async function(e) {
      var e = e || event;
      var currKey = e.keyCode || e.which || e.charCode;
      if (e.shiftKey) {
        that.keyDown.shiftKey = true;
        if (that.multipleDrag) {
          that.multipleDrag.zIndex = 0;
        }
      }
      if (e.ctrlKey) {
        that.keyDown.ctrlKey = true;
        //禁用ctrl + a 功能
        
      }

      if (e.ctrlKey && e.key == "-") {
        //禁用ctrl + a 功能
        that.sizeSelct -= 10;
        e.preventDefault();
        return false;
      }
      if (e.ctrlKey && e.key == "=") {
        //禁用ctrl + a 功能
        that.sizeSelct += 10;
        e.preventDefault();
        return false;
      }

      if (e.ctrlKey && window.event.keyCode == 90 && !e.shiftKey) {
        that.cancelStep();
        return false;
      }
      if (e.ctrlKey && e.shiftKey && window.event.keyCode == 90) {
        that.nextStep();
        return false;
      }
      if (e.ctrlKey && window.event.keyCode == 67) {
        //复制
        console.log("复制");
        if (that.eiditVisible) {
          that.copyDrag = null;
          return false;
        }
        if (that.dragsSelectIndexs && that.dragsSelectIndexs.length > 1) {
          that.copyDrag = [];
          that.dragsSelectIndexs.forEach((dragIndex) => {
            that.copyDrag.push(that.drags[dragIndex]);
          });
          return;
        }
        if (that.activeIndex > -1) {
          that.copyDrag = _.cloneDeep(that.drags[that.activeIndex]);
          delete that.copyDrag.ec_id;
          delete that.copyDrag.eguc_id;
          delete that.copyDrag.guc_id;
          delete that.copyDrag.c_id;
        }
      }
      if (e.ctrlKey && window.event.keyCode == 86) {
        if (that.editorState) return false;
        //粘贴
        that.pasterDrag();
      }
      if (currKey == 32) {
        that.leftChatMouseStateMove = true;
      }
    };
    document.onkeyup = function(e) {
      that.keyDown.ctrlKey = false;
      if (!e.shiftKey) {
        that.keyDown.shiftKey = false;
      }
      that.leftChatMouseStateMove = false;
      if (that.multipleDrag && e.shiftKey == false) { 
        that.multipleDrag.zIndex = 1000;
      }
      var e = e || event;
      var currKey = e.keyCode || e.which || e.charCode;
      if (currKey == 46) {
        that.handleRemoveDrag();
      }
    };
  },
  computed: {
    ...mapState(["headers", "userInfo", "fonts", "netWork"]),
    maxRound() {
      if (
        this.drags[this.activeIndex].height == "auto" ||
        !this.drags[this.activeIndex].height
      ) {
        return Number(this.drags[this.activeIndex].width);
      } else {
        return this.drags[this.activeIndex].width >
          this.drags[this.activeIndex].height
          ? Number(this.drags[this.activeIndex].height)
          : Number(this.drags[this.activeIndex].width);
      }
    },
    studentNum() {
      var student_num = 0;
      this.studentList.forEach((arr, index) => {
        if (arr.select) {
          student_num++;
        }
      });
      return student_num;
    },
    canShowIcon() {
      if (this.activeIndex < 0) return false;
      if (
        (this.drags[this.activeIndex].type == 1 ||
          this.drags[this.activeIndex].type == 9) &&
        this.drags[this.activeIndex].backgroundImg 
      ) {
        return true;
      }
      // if (this.drags[this.activeIndex].type == 2 && this.drags[this.activeIndex].showPhoto) {
      //   return true
      // }
      return false;
    },
    style3() {
      return {
        fontFamily: this.drags[this.activeIndex].fontFamily,
        fontWeight: this.drags[this.activeIndex].fontWeight,
        writingMode: this.drags[this.activeIndex].writingMode,
        webkitWritingMode: this.drags[this.activeIndex].writingMode,
        fontStyle: this.drags[this.activeIndex].fontStyle,
        textDecoration: this.drags[this.activeIndex].textDecoration,
        lineHeight:
          this.drags[this.activeIndex].lineHeight < 5
            ? this.drags[this.activeIndex].lineHeight
            : this.drags[this.activeIndex].lineHeight + "px",
        textAlign: this.drags[this.activeIndex].textAlign,
        color: this.drags[this.activeIndex].fColor,
        textIndent: this.drags[this.activeIndex].textIndent + "em",
        outline: "none",
        fontSize:
          this.drags[this.activeIndex].fSize != 0
            ? this.drags[this.activeIndex].fSize + "px"
            : "",
      };
    },
    leftChatStyle() {
      return {
        cursor: this.leftChatMouseStateMove ? "grab" : "auto",
      };
    },
    moveBoxStyle() {
      return {
        top: this.moveBoxTop + "px",
        left: this.moveBoxRight + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.transformX}px ${this.transformY}px`,
      };
    },
    rotateStyle() {
      return {
        top: this.rotateStyles.top - 44 + "px",
        left: this.rotateStyles.left + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.rotateStyles.rotateX}px ${this.rotateStyles
          .rotateY + 44}px`,
      };
    },
    rotateStyle2() {
      return {
        top: this.rotateStyles.top - 33 + "px",
        left:
          this.rotateStyles.left +
          this.$refs.drag[this.activeIndex].width / 2 +
          "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.rotateStyles.rotateX -
          this.$refs.drag[this.activeIndex].width / 2}px ${this.rotateStyles
          .rotateY + 33}px`,
      };
    },
    wrapperStyle() {
      return {
        width: this.wrapperWidth + "px",
        height: 750 + "px",
        backgroundImage: `url(${this.backgroundImage})`,
        transform: `scale(${this.sizeSelct / 100}) translate(${
          this.bodyTranslateX
        }px,${this.bodyTranslateY}px)`,
      };
    },
    leftBtnStyle() {
      return {
        right: 400 + "px",
        top: 110 + "px",
      };
    },
    networkStyle() {
      return {
        right: 400 + "px",
        bottom: 30 + "px",
      };
    },
  },
  created() {
    console.log(this.$store.state.forceToken);
    const host = window.location.href;
    if (host.indexOf("test") >= 0) {
      this.showFootbtn = true;
    }
    if (host.indexOf("operator=dianzuo") >= 0) {
      this.dzuoBtn = true;
    }
    var sizes = [
      // "262px",
      // "225px",
      "44px",
      "175px",
      "150px",
      "131px",
      "116px",
      "87px",
      "75px",
      "66px",
      "58px",
      "50px",

      "37px",
      // "33px",
      // "28px",
      // "22px",
      // "18px",
    ];

    Quill.Quill.imports["formats/size"].whitelist = sizes;
    Quill.Quill.register(Quill.Quill.imports["formats/size"]);

    const fonts = this.fonts;
    Quill.Quill.imports["formats/font"].whitelist = fonts;
    Quill.Quill.register(Quill.Quill.imports["formats/font"]);
    this.editorOption = {
      placeholder: "请在这里输入",
      modules: {
        clipboard: {
          matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
        },
        toolbar: [
          ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
          // ["blockquote", "code-block"], //引用，代码块
          // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
          [{ list: "ordered" }, { list: "bullet" }], //列表
          // [{ script: "sub" }, { script: "super" }], // 上下标
          [{ indent: "-1" }, { indent: "+1" }], // 缩进
          // [{ direction: "rtl" }], // 文本方向
          [{ size: sizes }], // 字体大小
          // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
          [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
          [{ font: fonts }], //字体
          [{ align: [] }], //对齐方式
          ["clean"], //清除字体样式
          // ["image", "video"], //上传图片、上传视频
        ],
      },
    };
    this.$forceUpdate();
    var screenHeight = document.documentElement.clientHeight;
    // if (screenHeight - 100 < 750) {
    //   this.sizeSelct = ((screenHeight - 100) / 750) * 100;
    // }
    this.studentName = this.$route.query.name;
    this.guc_id = this.$route.params.guc_id;
    this.s_id = this.$route.params.s_id;
    this.page = parseInt(this.$route.query.page);
    if (localStorage.getItem("s_id")) {
      this.s_id = localStorage.getItem("s_id");
    }
    if (localStorage.getItem("student_name")) {
      this.studentName = localStorage.getItem("student_name");
    }
    if (localStorage.getItem("page")) {
      this.page = localStorage.getItem("page");
    }
    if (this.userInfo) {
      this.getStudent();
      this.getGrowupDetail();
      this.getPasterClass();
      this.getFrame();
      this.getFrame2();
      this.getPaster();
      this.getBackground();
      this.getBuiltUp();
      this.initTel();
      this.checkCompleteTask = setInterval(() => {
        this.checkComplete();
      }, 120000);
    }
  },
  filters: {
    filterPhoto(drag) {
      let et = "";
      if ((drag.type == 1 || drag.type == 9) && drag.backgroundImg) {
        const index = drag.backgroundImg.indexOf("?");
        if (index > -1) {
          et = drag.backgroundImg.substr(index - 6, index - 1);
          console.log(index, et);
        } else {
          et = drag.backgroundImg.substr(
            drag.backgroundImg.length - 6,
            drag.backgroundImg.length - 1
          );
        }

        const index2 = et.indexOf(".");
        const index3 = et.indexOf("?");
        if (index3 > -1) {
          et = et.substr(index2, index3 - 2);
        } else {
          et = et.substr(index2);
        }
      } else if (drag.type == 2 && drag.showPhoto) {
        const index = drag.showPhoto.indexOf("?");
        if (index > -1) {
          et = drag.showPhoto.substr(index - 6, index - 1);
        } else {
          et = drag.showPhoto.substr(
            drag.showPhoto.length - 6,
            drag.showPhoto.length - 1
          );
        }

        const index2 = et.indexOf(".");
        const index3 = et.indexOf("?");
        if (index3 > -1) {
          et = et.substr(index2, index3 - 2);
        } else {
          et = et.substr(index2);
        }
      }
      return et;
    },
    filterType(type) {
      switch (type) {
        case 0:
          return "素材";
          break;
        case 1:
          return "矢量相框";
          break;
        case 2:
          return "相框";
          break;
        case 5:
          return "文本框";
          break;
        default:
          break;
      }
    },
  },
  watch: {
    dragsSelectIndexs(newV, oldV) {
      this.drags.forEach((arr) => {
        arr.show = true;
      });
      this.drags = this.drags.map(arr=>{
        arr.selects = false
        return arr
      })
      if (newV.length < 2) return false
      newV.forEach(dragIndex=>{
        this.drags[dragIndex].selects = true
      })
    },
    netWork(val) {
      if (val == -1) {
        this.$message.info("网络已断开");
      } else if (val > 200) {
        this.$message.info("当前网络状态较差");
      } else if (val > 100) {
      } else {
      }
    },
    editorState(val) {},
    s_id() {
      localStorage.setItem("s_id", this.s_id);
    },
    studentName() {
      localStorage.setItem("student_name", this.studentName);
    },
    page() {
      localStorage.setItem("page", this.page);
    },
    fonts(val) {
      var sizes = [
        // "262px",
        // "225px",
        "44px",
        "175px",
        "150px",
        "131px",
        "116px",
        "87px",
        "75px",
        "66px",
        "58px",
        "50px",
        "37px",
        // "33px",
        // "28px",
        // "22px",
        // "18px",
      ];
      Quill.Quill.imports["formats/size"].whitelist = sizes;
      Quill.Quill.register(Quill.Quill.imports["formats/size"]);
      const fonts = val;
      Quill.Quill.imports["formats/font"].whitelist = fonts;
      Quill.Quill.register(Quill.Quill.imports["formats/font"]);
      this.editorOption = {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
            // ["blockquote", "code-block"], //引用，代码块
            // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], //列表
            // [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{ direction: "rtl" }], // 文本方向
            [{ size: sizes }], // 字体大小
            // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: fonts }], //字体
            [{ align: [] }], //对齐方式
            ["clean"], //清除字体样式
            // ["image", "video"], //上传图片、上传视频
          ],
        },
      };
      this.$forceUpdate();
    },
    pageModal(val) {
      if (val) {
        this.getGrowPages();
      }
    },
    czHistory(val) {
      // this.historyChangeState = true;
      console.log(this.czHistory, this.step);
      if (val.length > 20) {
        this.step--;
        this.czHistory.splice(0, 1);
      }
    },
    step() {
      // this.historyChangeState = true;
    },
    userInfo(val) {
      if (val) {
        this.getStudent();
        this.getGrowupDetail();
        this.getFrame();
        this.getFrame2();
        this.getPasterClass();
        this.getPaster();
        this.getBackground();
        this.getBuiltUp();
        this.getAlbum();
        this.initTel();
        if (!this.checkCompleteTask) {
          this.checkCompleteTask = setInterval(() => {
            this.checkComplete();
          }, 120000);
        }
      }
    },
  },
  beforeDestroy() {
    this.uploadWaitDrag();
    clearTimeout(this.saveTimeout);
    localStorage.removeItem("s_id");
    localStorage.removeItem("student_name");
    localStorage.removeItem("page");
    clearInterval(this.checkCompleteTask);
    clearInterval(this.getPdfTaskPageTime);
    clearInterval(this.time);
    // this.changeBack('https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-13/2a754ae4cf2bf825b27d7681a2ab9c76.png')
  },
  methods: {
    //获取操作日志
    getLogList(ec_id) {
      this.loadingLog = true;
      // 更新视图模式
      if (ec_id) {
        this.logViewMode = 'single';
        this.currentEcId = ec_id;
      } else {
        this.logViewMode = 'all';
        this.currentEcId = '';
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.getLogList,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          gu_id: this.gu_id,
          page: this.pagination.current,
          limit: this.pagination.pageSize,
          ec_id: ec_id || '',
          s_id: this.s_id
        },
      }).then((res) => {
        console.log('log',res)
        this.loadingLog = false;
        if (res.data.status == 200 && res.data.data.rows && res.data.data.rows.length > 0) {
          this.logList = res.data.data.rows;
          this.pagination.total = res.data.data.total;
        } else {
          this.logList = [];
          this.pagination.total = 0;
        }
      }).catch(() => {
        this.loadingLog = false;
        this.logList = [];
        this.pagination.total = 0;
      });
    },
    // 查看全部日志
    viewAllLogs() {
      this.pagination.current = 1;
      this.getLogList('');
    },
    // 处理日志列表分页变化
    handleLogPaginationChange(pag) {
      this.pagination.current = pag.current;
      this.pagination.pageSize = pag.pageSize;
      this.getLogList(this.logViewMode === 'single' ? this.currentEcId : '');
    },
    transformFile(file) {
      return compressImageIfNeeded(file);
    },
    initTel(state) {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.getTextClass,
        headers: { Authorization: this.headers },
      }).then((res) => {
        if (res.data.status == 200 && res.data.data.data.length > 0) {
          this.textTel.tc_id = res.data.data.data[0].tc_id;
        } else if (!state) {
          this.$axios({
            method: "POST",
            url: this.$api.domain + this.$api.addTextClass,
            headers: { Authorization: this.headers },
            data: {
              name: "分类1",  
            },
          }).then((res) => {
            if (res.data.status == 200) {
              this.initTel(true);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    async lockDrag() {
      const drags = [];
      const state = !this.drags[this.activeIndex].lock;
      if (this.dragsSelectIndexs.length) {
        this.dragsSelectIndexs.forEach(async (arr) => {
          const drag = { ...this.drags[arr] };
          drag.lock = state;
          drags.push(drag);
          this.drags[arr].lock = state;
          this.changeDragHistory(arr)
        });
      } else {
        this.changeDragHistory(this.activeIndex)
      }
      
      // await this.batchChangeDrag2(drags);
      // this.dragsSelectIndexs.forEach(async (arr) => {
      //   this.drags[arr].lock = state;
      // });
    },
    handleUnlock(index) {
      this.drags[index].lock = false;
      this.batchChangeDrag2([this.drags[index]]);
    },
    checkComplete() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.is_complete = res.data.data.info.is_complete ? true : false;
            if (this.is_complete && !this.$store.state.forceToken) {
              this.$message.error("成长册已提交，不能继续编辑");
              clearInterval(this.checkCompleteTask);
              setTimeout(() => {
                this.$router.back();
              }, 1500);
            }
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    async changeFrame(item) {
      if (this.pageDetail.is_locked) {
        this.$message.error("页面已锁定不支持新增");
        return false;
      }
      this.drags[this.activeIndex].spinning = true 
      this.drags[this.activeIndex].draggable = false;
      this.$message.loading({content:'相框更换中',duration:1})
      var drags = [];
      var oldDrag = [];
      const backgroundImg = this.clearUrl(this.drags[this.activeIndex].backgroundImg) 
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].showPhoto = this.clearUrl(backgroundImg) 
        this.drags[this.activeIndex].bLeft = 0
        this.drags[this.activeIndex].bTop = 0 
        this.drags[this.activeIndex].bRight = 0
        this.drags[this.activeIndex].bBottom = 0
      }
      this.drags[this.activeIndex].backgroundImg = this.clearUrl(item.backgroundImg) ;
      this.drags[this.activeIndex].backImg2 = this.clearUrl(item.backImg2) ;
      this.drags[this.activeIndex].height = "auto";
      
      
      setTimeout(() => {
        this.drags[this.activeIndex].type = 2;
        this.$refs.drag[this.activeIndex].changeFrame(item)
      }, 10);
      
      setTimeout(() => {
        this.previewFrame = false;
      }, 1000);
    },
    rotatePhoto() {
      this.$refs.drag[this.activeIndex].rotatePhoto();
    },
    dataURLToBlob(dataURL) {
      var BASE64_MARKER = ";base64,";
      var parts;
      var contentType;
      var raw;
      if (dataURL.indexOf(BASE64_MARKER) === -1) {
        parts = dataURL.split(",");
        contentType = parts[0].split(":")[1];
        raw = decodeURIComponent(parts[1]);

        return new Blob([raw], { type: contentType });
      }

      parts = dataURL.split(BASE64_MARKER);
      contentType = parts[0].split(":")[1];
      raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    },
    captureScreenshot() {
      html2canvas(this.$refs.body, {
        backgroundColor: null,
        useCORS: true,
        // scale:2
      }).then((canvas) => {
        const fileBlob = this.dataURLToBlob(
          canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream")
        );
        const fileName = `file_${this.page}.png`;
        FileSaver.saveAs(fileBlob, fileName);
      });
    },
    getPdfTaskPage(id) {
      this.$axios({
        method: "GET",
        url: "https://guanmipdf.dzuo.net/ds" + this.$api.getPdfTaskPage,
        // headers: { Authorization: this.$store.state.headers },
        params: {
          pageId: id,
        },
      }).then((res) => {
        if (res.data.result) {
          this.pdfPage = "";
          this.pdfPage = res.data.data.file_url + "?time=" + Math.random();
          setTimeout(() => {
            this.pdfPageState = true;
            this.drawImg = false;
          }, 700);
          clearInterval(this.getPdfTaskPageTime);
        }
      });
    },
    saveTpl() {
      this.$confirm({
        title: "提示",
        content: "确认将此页保存为个人模板吗？",
        centered: true,
        onOk: () => {
          this.handleSaveToTpl();
        },
      });
    },
    async handleSaveToTpl() {
      if (!this.tplName) {
        this.$message.error("请填写模板名称");
        return;
      }
      this.confirmLoding = true;
      const res = await this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.copyStudentTpl,
        headers: { Authorization: this.headers },
        data: {
          gu_id: this.gu_id,
          s_id: this.s_id,
          name: this.tplName,
          has_photos: this.has_photos ? 1 : 0
        },
      });

      if (res.data.status == 200) {
        this.$message.success("复制成功");
        this.showSaveTpl = false;
        this.confirmLoding = false;
      } else {
        this.$message.success(res.data.msg);
        this.confirmLoding = false;
      }
    },
    getTextTel() {
      this.telList = [];

      this.$message.loading({
        key: "load",
        content: "数据读取中",
        duration: 5,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.getTextList,
        headers: { Authorization: this.headers, 'Content-Type': 'application/x-www-form-urlencoded' },
        data: {
          limit: 9,
          name: this.telSearch,
          page:
            this.telPage && this.telPage.currentPage
              ? this.telPage.currentPage
              : 1,
        },
      })
        .then((res) => {
          this.load = true;
          if (res.data.status == 200) {
            this.telList = res.data.data.data;
            this.telPage.total = res.data.data.total;
            this.$message.success({
              key: "load",
              content: "读取成功",
              duration: 1,
            });
          } else {
            this.$message.error({ content: res.data.msg, key: "load" });
          }
        })
        .catch((res) => {
          this.load = true;
          this.$message.error(res.data.msg);
        });
    },
    downloadImg2() {
      if (this.drawImg) {
        this.$message.info("图片处理中，请稍后");
        return false;
      }
      this.drawImg = true;
      // this.$message.loading({ content: "图片生成中", key: "drawImg" });
      this.$axios({
        method: "GET",
        url: "https://guanmipdf.dzuo.net/ds" + this.$api.downloadDrawpage,
        // headers: { Authorization: this.$store.state.headers },
        params: {
          guc_id: this.guc_id,
          s_id: parseInt(this.s_id),
        },
      })
        .then((res) => {
          if (res.data.result) {
            this.getPdfTaskPageTime = setInterval(() => {
              this.getPdfTaskPage(res.data.data);
            }, 2000);
          }
        })
        .catch((res) => {
          this.$message.error("服务器或网络错误");
          this.drawImg = false;
        });
    },
    downloadImgNew() {
      if (this.drawImg) {
        this.$message.info("图片处理中，请稍后");
        return false;
      }
      this.drawImg = true;
      // this.$message.loading({ content: "图片生成中", key: "drawImg" });
      this.$axios({
        method: "GET",
        url: "https://yjk.dzuo.net/ds" + this.$api.downloadDrawpage,
        // headers: { Authorization: this.$store.state.headers },
        params: {
          guc_id: this.guc_id,
          s_id: parseInt(this.s_id),
        },
      })
        .then((res) => {
          if (res.data.result) {
            this.getPdfTaskPageTime = setInterval(() => {
              this.getPdfTaskPage(res.data.data);
            }, 2000);
          }
        })
        .catch((res) => {
          this.$message.error("服务器或网络错误");
          this.drawImg = false;
        });
    },
    downloadImg() {
      if (this.activeIndex > -1) {
        this.drags[this.activeIndex].draggable = false;
        this.drags[this.activeIndex].active = false;
      }
      this.activeIndex = -1;
      setTimeout(() => {
        this.captureScreenshot();
      }, 200);
    },
    handleMouseEnterImg(url) {
      this.priviewImg =
        this.clearUrl(url) +
        "?x-image-process=image/resize,w_480/quality,Q_120";
    },
    handleMouseLeaveImg(url) {
      this.priviewImg = "";
    },
    handleRotateTouchDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateTouchDown(handle, e);
    },
    // 旋转柄按下
    handleRotateDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateDown(handle, e);
    },
    dragRotating(left, top, width, height, rotate, index) {
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    dragResizing(left, top, width, height, rotate, sacle, index) {
      // var orignX =
      //   this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      // var orignY =
      //   this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      // this.moveBoxRight =
      //   this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      // this.moveBoxTop =
      //   this.$refs.drag[index].top +
      //   this.$refs.drag[index].getHeight() / 2 -
      //   67;
      // this.transformX = orignX - this.moveBoxRight;
      // this.transformY = orignY - this.moveBoxTop;
      // this.rotateStyles = {
      //   top: this.$refs.drag[index].top - 10,
      //   left:
      //     this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
      //   rotateX:
      //     orignX -
      //     (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
      //   rotateX2:
      //     orignX -
      //     (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
      //   rotateY: orignY - (this.$refs.drag[index].top - 10),
      // };
      // this.moveBoxRotate = this.$refs.drag[index].rotate;
      this.calcPos(this.activeIndex);
    },
    dragMoving(m, n, index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left +
          this.$refs.drag[index].width / 2 -
          22 +
          6,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    fangda() {
      this.$refs.drag[this.activeIndex].fangda();
    },
    suoxiao() {
      this.$refs.drag[this.activeIndex].suoxiao();
    },
    handleRotateUp() {
      this.$refs.drag[this.activeIndex].handleRotateUp();
    },
    handleMoveTouchDown(handle, e) {
      this.IconTouch = true;
      this.$refs.drag[this.activeIndex].handleMoveTouchDown(handle, e);
    },
    // 旋转柄按下
    handleMoveDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleMoveDown(handle, e);
    },
    async pasterDrag() {
      if (this.pageDetail.is_locked) {
        this.$message.error('页面已锁定不支持粘贴')
        return
      }
      var that = this;
      //粘
      if (that.copyDrag && !_.isArray(this.copyDrag)) {
        var drag = _.cloneDeep(that.copyDrag);
        // drag.left += 10;
        // drag.top += 10;
        var addState = await that.batchAddDrag([drag]);
        if (addState.length > 0) {
          that.drags = [...that.drags, ...addState];
          that.drags.forEach((arr, index) => {
            arr.active = false;
            if (index == that.drags.length - 1) {
              arr.active = true;
            }
            arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
            return arr;
          });
          that.activeIndex = that.drags.length - 1;
          that.allIndex = that.drags.length;
          that.selectPhoto = null;
          that.ComIndex = -1;
          var getElement = await that.batchGetElement(addState[0].eguc_id);
          this.copyDrag = null;
          this.$message.success("粘贴成功");
          this.visible = false;
          this.$forceUpdate();
          var ids = [];
          var sids = [];
          if (getElement) {
            that.studentList.forEach((arr) => {
              if (arr.select) {
                that.editList.forEach((edit) => {
                  if (arr.id == edit.s_id) {
                    ids.push(edit.ec_id);
                    sids.push(arr.id)
                  }
                });
              }
            });
          }
          that.czHistory = [
            ...that.czHistory,
            {
              type: "adddrag",
              index: null,
              detail: { new: addState, old: null ,sids: sids.join(',')},
              ids: ids.join(","),
            },
          ];
          this.step++;
          that.originDrags = _.cloneDeep(that.drags);
        } else {
          this.$message.error('请求失败，请重试')
          this.saveDraging = false
        }
      } else if (that.copyDrag.length) {
        that.pasterDrag2();
      }
    },
    async pasterDrag2() {
      try {
        var that = this;
        //粘贴
        console.log(that.copyDrag);
        let addStateList = [];
        for (let i = 0; i < that.copyDrag.length; i++) {
          var drag = _.cloneDeep(that.copyDrag[i]);
          // drag.left += 10;
          var addState = await that.batchAddDrag([drag]);
          if (addState.length > 0) {
            addState[0].show = true;
            addStateList.push(...addState);

            var ids = [];
            var sids = [];
            that.studentList.forEach((arr) => {
              if (arr.select) {
                that.editList.forEach((edit) => {
                  if (arr.id == edit.s_id) {
                    ids.push(edit.ec_id);
                    sids.push(arr.id)
                  }
                });
              }
            });
            that.czHistory = [
              ...that.czHistory,
              {
                type: "adddrag",
                index: null,
                detail: { new: addState, old: null ,sids:sids.join(',')},
                ids: ids.join(","),
              },
            ];
            this.step++;
            that.originDrags = _.cloneDeep(that.drags);

            if (i == that.copyDrag.length - 1) {
              this.$message.success("粘贴成功");
              that.drags = [...that.drags, ...addStateList];
              that.selectPhoto = null;
              that.ComIndex = -1;

              this.visible = false;
              this.$forceUpdate();
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    openUploadModal() {
      if (this.albumList.length == 0) {
        this.$message.error("请至少添加一个相册上传照片");
        return false;
      }
      this.uploadModal = true;
    },
    changeLevelType(e) {
      this.drags[this.activeIndex].levelType = e;
    },
    async changeCurrnetLevel(e) {
      const index = this.activeIndex 
      const n = e
      if (this.changelevelState) {
        this.hide = this.$message.error("正在保存评级，请稍后");
        return false;
      } else {
        this.changelevelState = true;
        await this.batchGetElement(this.drags[index].eguc_id);
        if (this.check_drag_edit) {
          this.$set(this.drags[index], "level", n);
          await this.changeDragHistory(index);
          this.changelevelState = false;
        } else {
          this.changelevelState = false;
        }
        
        if (this.hide) {
          this.hide();
        }
      }
    },
    async changeLevel(n, index) {
      if (this.changelevelState) {
        this.hide = this.$message.error("正在保存评级，请稍后");
        return false;
      } else {
        this.changelevelState = true;
        await this.batchGetElement(this.drags[index].eguc_id);
        if (this.check_drag_edit) {
          this.$set(this.drags[index], "level", n);
          await this.changeDragHistory(index);
          this.changelevelState = false;
        } else {
          this.changelevelState = false;
        }
        
        if (this.hide) {
          this.hide();
        }
      }
    },
    async copythisDrag() {
      if (
        this.$refs.drag[this.activeIndex] &&
        this.$refs.drag[this.activeIndex].editState
      ) {
        console.log("编辑状态，并不复制");
        return false;
      }
      var that = this;
      if (this.dragsSelectIndexs.length > 1) {
        that.copyDrag = [];
        this.dragsSelectIndexs.forEach((dragIndex) => {
          that.copyDrag.push(this.drags[dragIndex]);
        });
      } else {
        that.copyDrag = _.cloneDeep(this.drags[this.activeIndex]);
        delete that.copyDrag.ec_id;
        delete that.copyDrag.eguc_id;
        delete that.copyDrag.guc_id;
        delete that.copyDrag.c_id;
      }
      this.$message.success("复制成功，请使用粘贴组件");
    },
    backIndex() {
      localStorage.removeItem("s_id");
      localStorage.removeItem("student_name");
      localStorage.removeItem("page");
      this.$router.push({ path: "/plate" });
    },
    changeKongwei(e) {
      this.kongwei = e;
    },
    handleCancelEdit() {
      this.eiditVisible = false;
    },
    getMaxFont(txt) {
      var regeQl = /ql-size-([\d]+)|font-size:[\s]*([\d]+)px/;
      var result = [];
      var maxFsize = 0;
      var matched = txt.match(regeQl);
      while (matched != null) {
        if (matched[1] != null) {
          result.push(matched[1]);
          if (matched[1] > maxFsize) {
            maxFsize = matched[1];
          }
        }
        if (matched[2] != null) {
          result.push(matched[2]);
          if (matched[2] > maxFsize) {
            maxFsize = matched[2];
          }
        }
        txt = txt.substr(matched.index + matched[0].length);
        matched = txt.match(regeQl);
      }
      switch (maxFsize) {
        case "175":
          maxFsize = 58.667;
          break;
        case "150":
          maxFsize = 48;
          break;
        case "116":
          maxFsize = 34.667;
          break;
        case "44":
          maxFsize = 14;
          break;
        case "131":
          maxFsize = 32;
          break;

        case "87":
          maxFsize = 29.333;
          break;

        case "66":
          maxFsize = 21.333;
          break;

        case "75":
          maxFsize = 24;
          break;

        case "58":
          maxFsize = 18.667;
          break;

        case "50":
          maxFsize = 16;
          break;

        case "37":
          maxFsize = 12;
          break;
      }
      return maxFsize;
    },
    async confirmEdit() {
      var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      var match = emojiReg.exec(this.editText);
      if (match && match.length > 0) {
        this.$message.error("不支持emjo表情功能");
        return false;
      }
      var drags = [];
      var maxFsize = this.getMaxFont(this.editText);
      this.editText = this.matchSpace(this.editText);
      this.studentList.forEach((arr) => {
        if (arr.select) {
          this.editList.forEach((edit, index) => {
            if (arr.id == edit.s_id) {
              let drag = _.cloneDeep(edit);
              drag.textarea = this.editText;
              if (drag.lineHeightAutoSize) {
                if (maxFsize) {
                  drag.lineHeight = Math.ceil(drag.fSize * 1.23);
                } else {
                  drag.lineHeight = 18;
                }
              }
              drags.push(drag);
              this.$nextTick(() => {
                this.editList[index].saveState = false;
              });
            }
          });
        }
      });
      this.$forceUpdate();
      var res = await this.batchChangeDrag2(drags);
      if (res) {
        this.eiditVisible = false;
        this.drags[this.activeIndex].textarea = this.editText;
        if (this.drags[this.activeIndex].lineHeightAutoSize) {
          if (maxFsize) {
            this.drags[this.activeIndex].lineHeight = Math.ceil(
              maxFsize * 1.23
            );
          } else {
            this.drags[this.activeIndex].lineHeight = 18;
          }
        }
      } else {
        if (!this.$store.state.online) {
          this.$message.info("网络或服务错误，请确认后刷新重试");
        } else {
          this.$message.info("字体加载中，请稍后保存");
        }
      }
    },
    showEdit(index) {
      this.batchGetElement(this.drags[index].eguc_id);
      // this.editText = this.drags[index].textarea;
      this.eiditVisible = true;
      setTimeout(() => {
        this.editText = this.drags[index].textarea;
      }, 20);
      // setTimeout(() => {
      //   addQuillTitle();
      // }, 40);
    },
    onTextchange($event) {},
    onEditorBlur() {},
    onEditorFocus(e) {},
    editorFocus(e, index) {
      setTimeout(() => {
        this.editorState = true;
      }, 20);
    },
    onEditorChange(e) {
      var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      this.editText = e.html;
      // if ((e.html.length - this.editText.length) > 10) {
      //   this.editText = e.text
      // }
      // this.editText = e.html;
    },
    changeText(item) {
      var select = false;
      this.studentList.forEach((arr) => {
        if (arr.id == item.s_id && arr.select) {
          select = true;
        }
      });
      if (select) {
        this.studentList.forEach((arr) => {
          if (arr.select) {
            this.editList = this.editList.map((edit) => {
              if (arr.id == edit.s_id) {
                edit.textarea = item.textarea;
              }
              return edit;
            });
          }
        });
        this.$forceUpdate();
      }
    },
    changeEditText($e, index) {
      this.editList[index].saveState = true;
      this.editState = true;
    },
    saveThisEdit(index) {
      this.pressEnter(null, index);
    },
    changePageNum2() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.batchEditBg,
        headers: { Authorization: this.$store.state.headers  },
        data: {
          page_num: this.newPageNum,
          guc_id: this.guc_id,
          is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          this.showPageNum = false;
        })
        .catch((res) => {
          console.log("getalbum错误");
          this.$message.error("服务器或网络错误");
        });
    },
    pressEnter(e, index) {
      var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      var match = emojiReg.exec(this.editList[index].textarea);
      if (match && match.length > 0) {
        this.$message.error("不支持emjo表情功能");
        return false;
      }
      this.editorState = false;
      if (!this.editState) return false;
      var res = this.batchChangeDrag2([this.editList[index]]);
      if (res) {
        this.editList[index].saveState = false;
        if (this.editList[index].s_id == this.s_id) {
          this.drags.forEach((arr, index2) => {
            if (arr.ec_id == this.editList[index].ec_id) {
              this.drags[index2].textarea = this.editList[index].textarea;
            }
          });
        }
        // this.$message.success("编辑成功");
        this.$forceUpdate();
        this.editState = false;
      } else {
        this.editState = false;
        this.$message.error("编辑失败，请稍后再试");
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    cancelUpload() {
      this.uploadModal = false;
      this.fileList = [];
      this.errorUploadState = false;
    },
    confirmUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = [];
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (
          this.fileList[i].status == "done" &&
          this.fileList[i].response &&
          this.fileList[i].response.data
        ) {
          img_url.push(this.fileList[i].response.data.url);
        }
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false;
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: ids.join(","),
          img_url: img_url.join(","),
          album_id: this.album_id,
        },
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 300);
          if (res.data.status == 200) {
            this.uploadModal = false;
            setTimeout(() => {
              this.getPhoto();
            }, 200);
          } else if (res.data.status == 204) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = [];
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (
          this.fileList[i].status == "done" &&
          this.fileList[i].response &&
          this.fileList[i].response.data
        ) {
          img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == "uploading") {
          state = false;
          break;
        } else if (
          this.fileList[i].status == "error" ||
          this.fileList[i].response != 200
        ) {
          errors.push(i + 1);
          this.errorUploadState = true;
        } else {
          this.fileList[i].status == "error";
        }
      }
      if (!state) return false;
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(",")}文件上传失败`);
        return false;
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false;
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: ids.join(","),
          img_url: img_url.join(","),
          album_id: this.album_id,
        },
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 300);
          if (res.data.status == 200) {
            this.uploadModal = false;
            setTimeout(() => {
              this.getPhoto();
            }, 200);
          } else if (res.data.status == 204) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    //上传照片
    handleuploadChange({ fileList }) {
      this.fileList = fileList;
      this.handleUpload();
    },
    //切换相册
    changeAlbum(e) {
      this.album_id = e;
      this.currentPhoto = 1;
      this.getPhoto();
    },
    refreshAlbum() {
      this.getPhoto();
    },
    clear() {
      this.drags[this.activeIndex].fontWeight = "";
      this.drags[this.activeIndex].fontStyle = "";
      this.drags[this.activeIndex].textDecoration = "";
      this.drags[this.activeIndex].fontFamily = "";

      this.drags[this.activeIndex].fColor = "#101010";
      this.drags[this.activeIndex].textAlign = "left";
      this.drags[this.activeIndex].textIndent = 0;
      this.drags[this.activeIndex].bColor = "";
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(14 * 1.23);
      }
      this.drags[this.activeIndex].fSize = 14;
      this.$forceUpdate();
    },
    addTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 9) return false;

      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent + 1
        : 1;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    decTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 0) return false;
      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent - 1
        : 0;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          class_id: this.userInfo.class_id,
          limit: 200,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            if (res.data.data.data.length > 0) {
              this.albumList = res.data.data.data;
              this.album_id = this.albumList[0].id;
              this.getPhoto();
            }
          }
        })
        .catch((res) => {
          console.log("getalbum错误");
          this.$message.error("服务器或网络错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    onSearchphotos(e) {
      this.frameTag = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    onSearchphotos2(e) {
      this.frameTag2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    onSearchbacks(e) {
      this.backgroundTag = e;
      this.currentBack = 1;
      this.getBackground();
    },
    onSearchimgs(e) {
      this.pasterTag = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    onSearchbuildup(e) {
      this.buildUpTag = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changeGrowPage(index) {
      if (
        this.pages2[index].is_lock &&
        this.pages2[index].lock_info.teacher_name != this.userInfo.teacher_name
      ) {
        if (this.pages2[index].lock_info.is_teacher) {
          this.$message.error(
            "页面已经被老师[" +
              this.pages2[index].lock_info.teacher_name +
              "]使用"
          );
        } else {
          this.$message.error(
            "页面已经被学生[" + this.pages2[index].lock_info.relation + "]使用"
          );
        }
        return false;
      }
      this.uploadWaitDrag();
      this.dragsSelect = [];
      this.dragsSelectIndexs = [];
      this.dragsSelectList = [];
      this.page = index;
      this.activeIndex = -1;
      this.getGrowupPageDetail(1);
      this.czHistory = [];
      this.step = -1;
    },
    getGrowupDetail() {
      this.drags = [];
      this.dragsSelect = null;
      this.dragsSelectIndexs = [];
      this.dragsSelectList = [];
      this.$message.loading({ content: "读取中", key: "loaddetail" });
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.czHistory = [];
            this.step = -1;
            this.pages = res.data.data.page;
            console.log(this.pages,'hahha'+this.page)
            this.getGrowupPageDetail();
            this.$message.success({ content: "获取成功", key: "loaddetail" });
          } else {
            this.$message.error({
              content: res.data.message,
              key: "loaddetail",
            });
          }
        })
        .catch((res) => {
          console.log(res)
          this.$message.error(res.data.msg);
        });
    },
    getGrowPages() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growPages,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.pages[this.page].guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.guc_id = this.pages[this.page].guc_id;
            var pages2 = res.data.data;
            this.gu_id = pages2[this.page].gu_id;
            this.getLogList();
            if (
              pages2[this.page].is_lock &&
              pages2[this.page].lock_info.teacher_name !=
                this.userInfo.teacher_name
            ) {
              this.$message.error("此页面已经被占用");
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            }
            pages2.forEach((page, index) => {
              page.img_bg =
                page.img_bg +
                "?x-image-process=image/resize,w_300/quality,Q_80";
              page.content = page.content.map((arr) => {
                // arr.textarea = decodeURI(arr.textarea);
                // arr.draggable = true
                arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                  ? this.clearUrl(arr.backgroundImg) +
                    "?x-image-process=image/resize,w_100/quality,Q_80"
                  : "";
                arr.backImg2 = this.clearUrl(arr.backImg2)
                  ? this.clearUrl(arr.backImg2) +
                    "?x-image-process=image/resize,w_100/quality,Q_80"
                  : "";
                arr.showPhoto = this.clearUrl(arr.showPhoto)
                  ? this.clearUrl(arr.showPhoto) +
                    "?x-image-process=image/resize,w_100/quality,Q_80"
                  : "";
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                  if (arr.coms[0] && arr.coms[0].width >= 0) {
                  } else {
                    arr.coms = [];
                  }
                }
                return arr;
              });
            });
            this.pages2 = pages2;
            this.kongwei = true;
            this.$forceUpdate();
            clearTimeout(this.pagesTime);
            this.pagesTime = setTimeout(() => {
              this.getGrowPages();
            }, 180000);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    catchClick() {
      var that = this;
      
      setTimeout(() => {
        if (that.activeIndex >= 0 && this.dragsSelectIndexs && this.dragsSelectIndexs.length < 2) {
          // that.dragsSelectIndexs = [];
          that.dragsSelectList = [];
          if (that.$refs["drag"][that.activeIndex]) {
            that.$refs["drag"][that.activeIndex].activeDrag();
            that.dragsSelect = [{ ...that.drags[that.activeIndex] }];
            // that.dragsSelectIndexs = [that.activeIndex];
            that.dragsSelect[0].index = that.activeIndex;
            that.$set(that.drags[that.activeIndex], "shiftkey", true);
            that.showIcon = true;
          } 
        } else {
          if (this.multipleDrag && this.dragsSelectIndexs.length > 1) {
            that.$refs.multiDrag.activeDrag();
          }
          
        }
      }, 100);
    },
    handleCustomMatcher(node, delta) {
      console.log("粘贴前的样式");
      const opsList = [];
      delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          opsList.push(op);
        } else if (!op.insert) {
          opsList.push(op);
        }
      });
      delta.ops = opsList;
      return delta;
    },
    getGrowupPageDetail(state) {
      if (this.pages.length == 0) {
        this.drags = [];
        this.backgroundImage = "";
        return false;
      }
      if (this.page > this.pages.length - 1) {
        this.page = this.$route.query.page ?  this.$route.query.page : 0
      }
      this.drags = [];
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.pages[this.page].guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.guc_id = this.pages[this.page].guc_id;
            this.pageDetail = res.data.data.info;
            this.drags = res.data.data.info.content.map((arr) => {
              arr.active = false;
              arr.draggable = false;
              arr.lock = arr.lock ? true : false;
              arr.pushState = false;
              arr.waitState = false;
              arr.orignWidth = arr.width;
              arr.textarea = arr.textarea
                ? arr.textarea.replace(/\\n/g, "<br/>")
                : "";
              arr.orignHeight = arr.height;
              arr.writeMode = arr.writeMode ? arr.writeMode : "horizontal-tb";
              arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                ? this.clearUrl(arr.backgroundImg) +
                  "?x-image-process=image/resize,w_650/quality,Q_120"
                : "";
              arr.showPhoto = this.clearUrl(arr.showPhoto)
                ? this.clearUrl(arr.showPhoto) +
                  "?x-image-process=image/resize,w_650/quality,Q_120"
                : "";
              if (arr.coms) {
                arr.coms = JSON.parse(arr.coms);
                if (arr.coms[0] && arr.coms[0].width >= 0) {
                } else {
                  arr.coms = [];
                }
              }
              if (
                (arr.type == 1 || arr.type == 2 || arr.type == 9) &&
                !arr.is_filled
              ) {
                arr.noFill = true;
              }
              if (
                arr.type == 0 &&
                arr.is_count &&
                !arr.is_filled &&
                !arr.backgroundImg
              ) {
                arr.noFill = true;
              }
              if (arr.type == 5 && !arr.is_filled && !arr.backgroundImg) {
                arr.noFill = true;
              }
              return arr;
            });
            this.backgroundImage = res.data.data.info.img_bg;
            var cover_size = res.data.data.info.size.cover_size.split("*");
            this.cover_size = cover_size;
            this.haomi = (11.8 * 3 * 750) / cover_size[1];
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            this.getBackground();
            setTimeout(() => {
              var dom = this.$refs["body"].getBoundingClientRect();
              this.fixBtnLeft = dom.right + 20;
            }, 600);

            if (state) {
              this.pageModal = false;
              this.transformX = 0;
              this.transformY = 0;
              this.rotateStyles = {
                left: 0,
                top: 0,
                rotateX: 0,
                rotateY: 0,
              };
            } else {
              this.getGrowPages();
            }
          }
        })
        .catch((res) => {
          this.$message.error(res);
        });
    },
    changePasterType(e) {
      this.pasterType = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    changePasterClassId(e) {
      this.pasterClassId = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    changeBuildType(e) {
      this.buildUpType = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changeFrameType(e) {
      this.frameType = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    changeFrameType2(e) {
      this.frameType2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    changeBackType(e) {
      this.backgroundType = e;
      this.currentBack = 1;
      this.getBackground();
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
          this.studentList.forEach((arr, index) => {
            if (arr.id == this.s_id) this.studentList[index].select = true;
          });
          this.getAlbum();
        })
        .catch((res) => {
          
          if (res.request) {
          // 请求已经成功发起，但没有收到响应
          // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
          // 而在node.js中是 http.ClientRequest 的实例
          this.$message.error('登录状态异常，请重新登录')
          Cookies.remove('token')
          this.$router.push({ path: "/login" });
        } else {
          this.$message.error(res.data.msg);
        }
        });
    },
    changeAddtype(e) {
      if (this.addType) {
        this.currentPage = 1;
        this.getPlateList();
      }
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    urladd(name) {
      let url = window.location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
    async pullPhoto() {
      if (this.pictures.length == 0 || !this.pictures) {
        this.$message.error("请先选择相册照片");
        return false;
      }
      let num = 0;
      this.studentList.forEach((arr) => {
        if (arr.select) num++;
      });
      if (num > 1) {
        this.$message.error("多选状态不可批量导入照片");
        return false;
      }
      this.$confirm({
        title: "提示",
        content: "确认自动导入照片吗？",
        centered: true,
        onOk: () => {
          this.pullState = true;
          this.$message.loading({ content: "导入中...", key: "pull" });
          const drags = [];
          let pullIndex = 0;
          let pictures = [];
          this.pictures.forEach((arr) => {
            if (arr.select) {
              pictures.push(arr);
            }
          });
          if (pictures.length == 0) {
            pictures = this.pictures;
          }
          this.drags.forEach((arr,index) => {
            
            if (arr.type == 1 || arr.type == 9) {
              if (pullIndex >= pictures.length) {
                return false;
              }
              if (arr.backgroundImg) return false;
              this.dropImg2(index, pictures[pullIndex].img_url)
              pullIndex++;
              drags.push(arr);
            } else if (arr.type == 2) {
              if (pullIndex >= pictures.length) {
                return false;
              }
              if (arr.showPhoto) return false;
              this.dropImg2(index, pictures[pullIndex].img_url)
              pullIndex++;
              drags.push(arr);
            }
          });

          this.$forceUpdate();
          this.$nextTick(() => {
            setTimeout(async () => {
              this.pictures = this.pictures.map((arr) => {
                arr.select = false;
                return arr;
              });
              // this.$message.success({ content: "导入成功", key: "pull" });
            }, 1500);
            // setTimeout(() => {
            //   this.getPhoto();
            // }, 1000);
          });
        },
      });
    },
    async clearPhoto() {
      this.$confirm({
        title: "提示",
        content: "确认清除相框内所有照片吗？",
        centered: true,
        onOk: () => {
          this.pullState = true;
          const drags = [];
          let pullIndex = 0;
          this.drags.forEach((arr) => {
            if (arr.type == 1 || arr.type == 9) {
              arr.backgroundImg = "";
              arr.lockAspectRatio = true;
              pullIndex++;
              drags.push(arr);
            } else if (arr.type == 2) {
              arr.photoLeft = 0;
              arr.photoTop = 0;
              arr.photoScale = 1;
              arr.showPhoto = "";
              pullIndex++;
              drags.push(arr);
            }
          });

          this.$forceUpdate();
          this.$nextTick(() => {
            setTimeout(async () => {
              const res = await this.changeBatchDrags(drags);
              this.pullState = false;
            }, 1000);
          });
        },
        onCancel() {},
      });
    },
    async changeBatchDrags(drags) {
      this.saveDraging = true;
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers },
          data: {
            content: JSON.stringify(drags),
            is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
          },
        });
        if (res.data.status == 200) {
          this.saveDraging = false;
          return res;
        } else {
          this.$message.error({
            content: res.data.msg,
            duration: res.data.msg.indexOf('成长册已提交') > -1 ? 100000 : 2
          });
          this.saveDraging = false;
          return false;
        }
      } catch (error) {
        this.saveDraging = false;
        return false;
      }
    },
    async cancelStep() {
      this.activeIndex = -1;
      if (this.step == -1) return false;
      console.log('cancel' ,this.czHistory[this.step])
      if (this.czHistory[this.step].type == "change") {
        this.czHistory[this.step].detail.old = this.czHistory[this.step].detail.old.map(arr=> {
          if (arr.type == 3) {
            arr.coms = JSON.parse(arr.coms)
          } 
          return arr 
        })
        var changeState = await this.batchChangeDrag2(
          this.czHistory[this.step].detail.old
        );
        console.log(this.czHistory[this.step].detail.old)
        
        this.drags.forEach((arr, index) => {
          this.czHistory[this.step].detail.old.forEach((oldDrag) => {
            if (oldDrag.ec_id == arr.ec_id) {
              let changeDrag =_.cloneDeep(this.czHistory[this.step].detail.changeDrag) 
              for (const key in changeDrag) {
                changeDrag[key] = oldDrag[key];
              }
              // this.drags[index] = changeDrag;
              this.changeStepState = true
              this.drags.splice(index, 1);
              setTimeout(() => {
                this.drags.splice(index, 0 ,changeDrag);
                // const drags = _.cloneDeep(this.drags)
                // this.drags = []
                // this.drags = drags
                this.dragKey++
                // this.drags.push(changeDrag);
                console.log(this.drags,this.$refs.drag)
              }, 40);
            }
          });
        });
      }
      if (this.czHistory[this.step].type == "changeBack") {
        await axios({
          method: "POST",
          url: api.domain + api.batchEditBg,
          headers: { Authorization: this.$store.state.headers},
          data: {
            guc_id: this.guc_id,
            img_bg: this.czHistory[this.step].detail,
            is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
          },
        })
          .then(() => {
            var back = _.cloneDeep(this.backgroundImage);
            this.backgroundImage = this.czHistory[this.step].detail;
            this.czHistory[this.step].detail = back;
          })
          .catch((res) => {});
      }
      if (this.czHistory[this.step].type == "delete") {
        var addState = await this.batchCancelDrag(
          this.czHistory[this.step].detail.eguc_ids,
          this.czHistory[this.step].ids
        );
        if (addState) {
          this.drags = [
            ...this.drags,
            this.czHistory[this.step].detail.cancelDrag,
          ];
        }
      }
      if (this.czHistory[this.step].type == "adddrag") {
        var delres = await this.batchDel(
          this.czHistory[this.step].detail.new[0].eguc_id,
          this.czHistory[this.step].detail.sids
        );
        if (delres) {
          this.drags.splice(this.drags.length - 1, 1);
        }
      }
      if (this.czHistory[this.step].type == "confirmCom") {
        
        // this.drags = [...this.drags, this.czHistory[this.step].detail];
        var eguc_ids = []
        console.log('detail', this.czHistory[this.step].detail,this.drags.length  - this.czHistory[this.step].detail.coms.length)
        this.drags.forEach(async (arr,index) => {
          if (this.drags.length - 1 - this.czHistory[this.step].detail.coms.length <= index) {
            eguc_ids.push(arr.eguc_id)
          }
          this.batchDel(
            arr.eguc_id,
              this.czHistory[this.step].ids
          );
        })
        this.drags.splice(
          this.drags.length - this.czHistory[this.step].detail.coms.length,
          this.czHistory[this.step].detail.coms.length
        );
        // this.confirmComb(this.czHistory[this.step].index);
        await this.batchCancelDrag(
          this.czHistory[this.step].detail.eguc_id,
          this.czHistory[this.step].ids
        );
        this.drags.push(this.czHistory[this.step].detail)
      }
      if (this.czHistory[this.step].type == "addCom") {
        this.confirmComb(this.czHistory[this.step].index);
        this.czHistory.splice(this.step, 1);
      }
      this.originDrags = _.cloneDeep(this.drags);
      this.step--;

      this.$forceUpdate();
    },
    togoPhoto(photo, index) {
      this.$set(this.pictures[index], "select", !this.pictures[index].select);
    },
    async uploadWaitDrag() {
      if (!this.drag_eguc_check) {
        return false;
      }
      if (!this.waitTimeState) {
        return false;
      }
      if (
        this.waitDrag &&
        this.waitEditList &&
        this.waitEditList.length &&
        this.waitEditList[0].eguc_id == this.waitDrag.eguc_id
      ) {
        clearTimeout(this.waitTime);
        var drags = [];
        var oldDrag = [];
        this.drags.forEach((arr) => {
          if (arr.ec_id == this.waitDrag.ec_id) {
            this.waitDrag = arr;
          }
        });
        this.waitStudentList.forEach((arr) => {
          if (arr.select) {
            this.waitEditList.forEach((edit) => {
              var drag = _.cloneDeep(this.waitDrag);
              if (arr.id == edit.s_id) {
                drag.ec_id = edit.ec_id;
                drag.guc_id = edit.guc_id;
                drag.c_id = edit.c_id;
                drag.eguc_id = edit.eguc_id;
                if (edit.type == 1 || edit.type == 9) {
                  drag.backgroundImg = edit.backgroundImg
                    ? this.clearUrl(edit.backgroundImg)
                    : this.clearUrl(drag.backgroundImg);
                }

                if (edit.type == 2) {
                  drag.showPhoto = edit.showPhoto
                    ? this.clearUrl(edit.showPhoto)
                    : this.clearUrl(drag.showPhoto);
                }

                delete drag.textarea;
                drags.push(drag);
                oldDrag.push(edit);
              }
            });
          }
        });

        var changeState = false;
        var waitId = "";
        this.drags.forEach((arr, index) => {
          drags.forEach((drag, index2) => {
            if (arr.ec_id == drag.ec_id) {
              changeState = true;
              waitId = arr.ec_id;
            }
          });
        });
        this.waitDrag = null;
        this.waitTimeState = false;
        if (!changeState) return false;
        var state = false;
        var drags2 = _.cloneDeep(drags);

        this.saveDraging = true;

        drags2.forEach((arr, index) => {
          drags2[index].showPhoto = this.clearUrl(drags2[index].showPhoto);
          drags2[index].backgroundImg = this.clearUrl(
            drags2[index].backgroundImg
          );
          // this.drags.forEach((arr2, index2) => {
          //   if (arr.ec_id == arr2.ec_id) {
          //     this.drags[index2].pushState = true;
          //   }
          // });
        });
        try {
          var res = await axios({
            method: "POST",
            url: api.domain + api.batchEdit,
            headers: { Authorization: this.$store.state.headers},
            data: {
              content: JSON.stringify(drags2).replace(/\\t/g, "    "),
              is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
            },
          });
          setTimeout(() => {
            this.saveDraging = false;
          }, 800);
          if (res.data.status == 200) {
            return true;
          } else {
            this.$message.error({
            content: res.data.msg,
            duration: res.data.msg.indexOf('成长册已提交') > -1 ? 100000 : 2
          });
            return false;
          }
        } catch (error) {
          this.$message.error("保存失败");
          this.saveDraging = false;
          return state;
        }
      }
    },
    async batchCancelDrag(eguc_ids, sids) {
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchCancel,
          headers: { Authorization: this.$store.state.headers },
          data: {
            eguc_ids: eguc_ids,
            s_ids: sids,
          },
        });
        if (res.data.status == 200) {
          return true;
        } else {
          this.$message.error(res.data.msg);
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    onChangeAutoSize(e) {
      this.drags[this.activeIndex].lineHeightAutoSize = e.target.checked
        ? 1
        : 0;
      if (e.target.checked) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(
          this.drags[this.activeIndex].fSize * 1.23
        );
      }
      this.changeDragHistory(this.activeIndex);
    },
    async batchChangeDrag(drags) {
      // if (this.pullState) {
      //   return false;
      // }
      drags = drags.map((arr) => {
        if (arr && arr.textarea) arr.textarea = this.matchSpace(arr.textarea);
        return arr;
      });
      if (!this.$store.state.online) {
        this.$message.error("网络已断开，请重新连接并刷新页面");
        return false;
      }
      if (!this.drag_eguc_check && this.studentNum > 1) {
        this.$message.error("同位素差异，无法编辑");
        return false;
      }

      var changeState = false;
      var waitId = "";
      var waitDrag = null;
      this.drags.forEach((arr) => {
        drags.forEach((drag) => {
          if (arr.ec_id == drag.ec_id) {
            changeState = true;
            waitDrag = arr;
            waitId = arr.ec_id;
          }
        });
      });

      if (!changeState) return false;
      // if (this.waitDrag && waitDrag.ec_id == this.waitDrag.ec_id) {
      //   this.waitTimeState = true;
      //   this.waitTime = setTimeout(() => {
      //     this.uploadWaitDrag();
      //   }, 500);
      //   return false;
      // }
      var state = false;
      var drags2 = _.cloneDeep(drags);
      this.waitDrag = _.cloneDeep(waitDrag);
      this.waitEditList = _.cloneDeep(this.editList);
      this.waitStudentList = _.cloneDeep(this.studentList);
      this.saveDraging = true;
      drags2.forEach((arr, index) => {
        drags2[index].showPhoto = this.clearUrl(drags2[index].showPhoto);
        drags2[index].backgroundImg = this.clearUrl(
          drags2[index].backgroundImg
        );
        this.drags.forEach((arr2, index2) => {
          if (arr.ec_id == arr2.ec_id) {
            this.drags[index2].pushState = true;
          }
        });
      });
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers},
          data: {
            content: JSON.stringify(drags2).replace(/\\t/g, "    "),
            is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
        }, 800);
        if (res.data.status == 200) {
          if (this.waitDrag && waitId == this.waitDrag.ec_id && this.waitTime) {
            this.uploadWaitDrag();
          } else {
            this.waitDrag = null;
          }
          drags2.forEach((arr, index) => {
            this.drags.forEach((arr2, index2) => {
              if (arr.ec_id == arr2.ec_id) {
                this.drags[index2].pushState = false;
              }
            });
          });
          this.saveDraging = false;
        } else {
          // this.$message.error(res.data.msg);
          this.$message.error({
            content: res.data.msg,
            duration: res.data.msg.indexOf('成长册已提交') > -1 ? 1000000 : 2
          });
          this.saveDraging = false;
          return false;
        }
        return true;
      } catch (error) {
        this.$message.error("保存失败");
        this.saveDraging = false;
        return state;
      }
    },
    matchSpace(text) {
      return text;
      var rel = />[\s]+/g;
      var match = text.match(rel);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/\t/g, "    "); //&nbsp;
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log("空格处理");
      console.log(text);
      console.log(match);
      console.log(content);
      content = this.matchSpace2(content);
      return content;
    },
    matchSpace2(text, rel) {
      var rel = /&nbsp;[\s]+/g;
      var match = text.match(rel);
      console.log("空格二次处理");
      console.log(text);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/\t/g, "    ");
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log(content);
      return content;
    },
    async batchChangeDrag2(drags) {
      var drags2 = _.cloneDeep(drags);
      console.log(drags);
      this.saveDraging = true;
      drags2.forEach((arr, index) => {
        drags2[index].showPhoto = drags2[index].showPhoto
          ? this.clearUrl(drags2[index].showPhoto)
          : "";
        drags2[index].backgroundImg = drags2[index].backgroundImg
          ? this.clearUrl(drags2[index].backgroundImg)
          : "";
      });
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers},
          data: {
            content: JSON.stringify(drags2).replace(/\\t/g, "    "),
            is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
        }, 400);
        if (res.data.status == 200) {
          drags2.forEach((arr, index) => {
            this.drags.forEach((arr2, index2) => {
              if (arr.ec_id == arr2.ec_id) {
                this.drags[index2].pushState = false;
              }
            });
          });
          this.saveDraging = false;
        } else {
          this.$message.error({
            content: res.data.msg,
            duration: res.data.msg.indexOf('成长册已提交') > -1 ? 100000 : 2
          });
          this.saveDraging = false;
          return false;
        }
        return true;
      } catch (error) {
        console.log(error);
        this.saveDraging = false;
        return state;
      }
    },
    exhcnageBr(val, str) {
      let arr = [];
      val.split(str).forEach((item) => arr.push(`${item.trim()}`));
      return arr.join("\n");
      console.log("content:" + this.content);
    },
    async batchGetElement(id) {
      this.editState = false;
      this.editList = [];
      this.getElementState = true;
      var state = false;
      try {
        var res = await axios({
          method: "GET",
          url: api.domain + api.batchGetElement,
          headers: { Authorization: this.$store.state.headers },
          params: {
            guc_id: this.guc_id,
            eguc_id: id,
          },
        });
        this.getElementState = false;
        if (res.data.status == 201) {
          this.$message.error(res.data.msg);
          return false;
        }
        if (!res.data.data) return false;
        this.editList = res.data.data;
        this.editList = this.editList.map((arr) => {
          if (arr.textarea) {
            arr.textarea = this.exhcnageBr(arr.textarea, "\\n");
          }
          arr.enable = false;
          return arr;
        });
        if (res.data.data[0].type == 5) {
          this.editListCach = _.cloneDeep(this.editList);
        }
        var res = this.check_drag_edit(id);
        setTimeout(() => {
          if (this.tabIndex == 7) {
            this.editList = this.editList.map((arr) => {
              arr.enable = true;
              return arr;
            });
          }
        }, 100);
        return res
      } catch (error) {
        this.getElementState = false;
        this.drag_eguc_check = false;
        if (error.request) {
          // 请求已经成功发起，但没有收到响应
          // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
          // 而在node.js中是 http.ClientRequest 的实例
          console.log(error.request);
          this.$message.error('登录状态异常，请重新登录')
          Cookies.remove('token')
          this.$router.push({ path: "/login" });
        }
        return state;
      }
    },
    check_drag_edit(id) {
      if (!id) {
        if (this.activeIndex < 0) return false;
        id = this.drags[this.activeIndex].eguc_id;
      }
      var dragIndex = -1;
      var students = [];
      var student_num = 0;
      var originDrag = null;
      this.drags.forEach((arr, index) => {
        if (arr.eguc_id == id) {
          originDrag = arr;
          dragIndex = index;
        }
      });
      try {
        this.studentList.forEach((arr, index) => {
          if (arr.select) {
            student_num++;
            var has_element = false;
            this.editList.forEach((edit) => {
              if (arr.id == edit.s_id) {
                console.log(
                  this.clearUrl(originDrag.backgroundImg) ==
                    this.clearUrl(edit.backgroundImg)
                );
                if (edit.type != 1 && edit.type != 2 && edit.type != 9) {
                  has_element = true;
                  students.push(edit);
                }
                if (
                  (edit.type == 1 || edit.type == 9) &&
                  this.clearUrl(originDrag.backgroundImg) ==
                    this.clearUrl(edit.backgroundImg)
                ) {
                  has_element = true;
                  students.push(edit);
                }
                if (
                  edit.type == 2 &&
                  this.clearUrl(originDrag.showPhoto) ==
                    this.clearUrl(edit.showPhoto)
                ) {
                  has_element = true;
                  students.push(edit);
                }
                // if (edit.type == 0 && (this.drags[this.activeIndex].textarea == edit.textarea || edit.textarea == '')) {
                //   has_element = true;
                //   students.push(edit);
                // }
              }
            });
            if (this.photoChangeState && dragIndex == this.photoChangeState) {
              this.studentList[index].has_element = true;
            } else {
              this.studentList[index].has_element = has_element;
            }
            
          }
        });
      } catch (error) {
        console.log(error);
      }
      if (this.photoChangeState && dragIndex == this.photoChangeState) {
        this.drag_eguc_check = true;
        return true
      }
      if (students.length < student_num && student_num > 1) {
        this.drag_eguc_check = false;
        this.$refs.drag[dragIndex].cancelActive();
        this.drags[dragIndex].draggable = false;
        this.activeIndex = -1;
        this.$forceUpdate();
      } else {
        this.drag_eguc_check = true;
        this.drags[dragIndex].draggable = true;
        this.drags[dragIndex].enable = true;
        this.$forceUpdate();
      }
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    async batchAddDrag(drag, ids2) {
      if (this.pageDetail.is_locked) {
        this.$message.error('页面已锁定不支持新增')
        return false
      }
      
      if (this.adddragState) return false;
      const msgHide = this.$message.info("新增组件中,请稍后", 0);
      this.adddragState = true;
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      drag[0].zIndex = this.drags.length;
      drag = drag.map((arr) => {
        arr.backgroundImg = this.clearUrl(arr.backgroundImg);
        arr.showPhoto = this.clearUrl(arr.showPhoto);
        arr.backImg2 = this.clearUrl(arr.backImg2);
        return arr;
      });
      try {
        this.saveDraging = true;
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchAdd,
          headers: { Authorization: this.$store.state.headers},
          data: {
            s_ids: ids2 && ids2 != "" ? ids2 : ids.join(","),
            guc_id: this.guc_id,
            content: JSON.stringify(drag),
            is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
          },
        });
        this.adddragState = false;
        this.$message.destroy();
        setTimeout(() => {
          this.saveDraging = false;
        }, 300);
        if (res.data.status == 201) {
          this.$message.error(res.data.msg);
          return false;
        }
        return res.data.data;
      } catch (error) {
        this.$message.destroy();
        this.adddragState = false;
        this.$message.error("保存失败");
        return false;
      }
    },
    searchId() {
      let dragIndex = -1;
      for (let index = 0; index < this.drags.length; index++) {
        const arr = this.drags[index];
        if (arr.c_id == this.search_id) {
          dragIndex = index;
        }
      }
      if (dragIndex > -1) {
        this.changeDrag(dragIndex);
      } else {
        this.$message.error("未检索到匹配组件");
      }
    },
    searchId2() {
      let dragIndex = -1;
      for (let index = 0; index < this.drags.length; index++) {
        const arr = this.drags[index];
        if (arr.ec_id == this.search_id2) {
          dragIndex = index;
        }
      }
      if (dragIndex > -1) {
        this.changeDrag(dragIndex);
      } else {
        this.$message.error("未检索到匹配组件");
      }
    },
    async nextStep() {
     
      if (this.step < this.czHistory.length - 1) {
        this.step++
        this.changeStepState = true;
        var drags = _.cloneDeep(this.drags);
        if (this.czHistory[this.step].type == "change") {
          var changeState = await this.batchChangeDrag2(
            this.czHistory[this.step].detail.new
          );
          if (changeState) {

            this.drags.forEach((arr, index) => {
              this.czHistory[this.step].detail.new.map((newDrag) => {
                if (newDrag.ec_id == arr.ec_id) {
                  this.changeStepState = true
                  this.drags.splice(index,1)
                  const newdrag2 = _.cloneDeep(newDrag)
                  console.log('next', newdrag2,this.czHistory[this.step].detail.new)
                  setTimeout(() => {
                    this.drags.splice(index, 0 ,newdrag2);
                    this.dragKey++
                    // this.drags.push(newdrag2)
                    // const drags = _.cloneDeep(this.drags)
                    // this.drags = []
                    // this.drags = drags
                  }, 60);
                  
                  // this.drags[index] = newDrag;
                }
              });
            });
          }
        }
        if (this.czHistory[this.step].type == "changeBack") {
          this.saveDraging = true;
          await axios({
            method: "POST",
            url: api.domain + api.batchEditBg,
            headers: { Authorization: this.$store.state.headers },
            data: {
              guc_id: this.guc_id,
              img_bg: this.czHistory[this.step].detail,
              is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
            },
          })
            .then((res) => {
              setTimeout(() => {
                this.saveDraging = false;
              }, 800);
              if (res.data.status == 201) {
                this.$message.error(res.data.msg);
                return false;
              }
              var back = _.cloneDeep(this.backgroundImage);
              this.backgroundImage = this.czHistory[this.step].detail;
              this.czHistory[this.step].detail = back;
            })
            .catch((res) => {
              console.log(res);
              this.$message.error("保存失败");
            });
        }
        if (this.czHistory[this.step].type == "delete") {
          var index = -1;
          this.drags.forEach((element, index2) => {
            if (
              element.ec_id == this.czHistory[this.step].detail.cancelDrag.ec_id
            ) {
              index = index2;
            }
          });
          if (index == -1) return false;
          var that = this;
          var delZindex = that.drags[index].zIndex;
          if (that.drags[index].eguc_id) {
            var res = await that.batchDel(
              that.drags[index].eguc_id,
              this.czHistory[this.step].detail.sids
            );
            if (res) {
              that.activeIndex = -1;
              that.drags.splice(index, 1);
              if (that.drags.length > 0) {
                that.drags.map((arr) => {
                  if (arr.zIndex > delZindex) {
                    arr.zIndex--;
                  }
                  return arr;
                });
              }
            }
          }
        }
        if (this.czHistory[this.step].type == "adddrag") {
          var drags = this.czHistory[this.step].detail.new;
          var addState = await this.batchAddDrag(drags);
          if (addState) {
            this.drags = [...this.drags, ...addState];
            var getElement = await this.batchGetElement(addState[0].eguc_id);
            var ids = [];
            if (getElement) {
              this.studentList.forEach((arr) => {
                if (arr.select) {
                  this.editList.forEach((edit) => {
                    if (arr.id == edit.s_id) {
                      ids.push(edit.ec_id);
                    }
                  });
                }
              });
            }
            this.czHistory[this.step] = {
              type: "adddrag",
              index: null,
              detail: { new: addState, old: null, sids: this.czHistory[this.step].detail.sids},
            };
            console.log(this.czHistory[this.step])
          }
        }
        if (this.czHistory[this.step].type == "confirmCom") {
          this.confirmComb(this.czHistory[this.step].index,true)
        }
        this.originDrags = _.cloneDeep(this.drags);
        this.$forceUpdate();
      }
    },
    changeB() {
      const s = this.drags[this.activeIndex].fontWeight == "bold" ? "" : "bold";
      this.$set(this.drags[this.activeIndex], "fontWeight", s);
    },
    changeI() {
      const s =
        this.drags[this.activeIndex].fontStyle == "italic" ? "" : "italic";
      this.$set(this.drags[this.activeIndex], "fontStyle", s);
    },
    changeFSize(size) {
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(size * 1.23);
      }
      this.$set(this.drags[this.activeIndex], "fSize", size);
    },
    changeFamily(name) {
      this.$set(this.drags[this.activeIndex], "fontFamily", name);
    },
    handleChangeFamily() {
      this.familyMask = true;
    },
    changeU() {
      const s =
        this.drags[this.activeIndex].textDecoration == "underline"
          ? ""
          : "underline";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    changeS() {
      const s =
        this.drags[this.activeIndex].textDecoration == "line-through"
          ? ""
          : "line-through";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    saveHistoryChange() {
      if (this.historyChangeState) {
        this.savePlateContent();
      }
      this.saveTimeout = setTimeout(() => {
        this.saveHistoryChange();
      }, 10000);
    },
    listenMouseDown(e) {
      if (this.leftChatMouseStateMove) {
        this.leftChatPointX = e.layerX;
        this.leftChatPointY = e.layerY;
        this.originbodyTranslateX = this.bodyTranslateX;
        this.originbodyTranslateY = this.bodyTranslateY;
        this.$refs["leftChat"].addEventListener(
          "mousemove",
          this.listenMouseMove
        );
      }
    },
    changeHeight(height, index) {
      this.drags[index].height = height;
    },
    changeLevelData(type, num, level, size, index) {
      setTimeout(() => {
        if (this.editList.length) {
          this.changeDragHistory(index);
        }
      }, 100);
    },
    copyText(text) {},
    listenMouseMove(e) {
      if (!this.leftChatMouseStateMove) {
        this.$refs["leftChat"].removeEventListener(
          "mousemove",
          this.listenMouseMove
        );
        return false;
      }
      e.stopPropagation();
      var transformX = this.leftChatPointX - e.layerX;
      var transformY = this.leftChatPointY - e.layerY;
      this.bodyTranslateX = this.originbodyTranslateX - transformX;
      this.bodyTranslateY = this.originbodyTranslateY - transformY;
    },
    async changeDragHistory(index, type, editList) {
      try {
        var drags = [];
        var oldDrag = [];
        // if (this.drags[index].pushState) {
        //   this.drags[index].waitState = true
        //   return false
        // }
        var sids = [];

        if (this.drags[index].type == 5 && type == "text") {
          this.studentList.forEach((arr) => {
            if (arr.select) {
              editList.forEach((edit) => {
                var drag = _.cloneDeep(this.drags[index]);
                if (arr.id == edit.s_id) {
                  console.log(edit.ec_id);
                  drag.ec_id = edit.ec_id;
                  drag.guc_id = edit.guc_id;
                  drag.c_id = edit.c_id;
                  drag.eguc_id = edit.eguc_id;

                  if (!type) {
                    delete drag.textarea;
                  } else {
                  }
                  drags.push(drag);
                  oldDrag.push(edit);
                  sids.push(edit.s_id);
                }
              });
            }
          });
        } else {
          let editList = [];
          const studentList = _.cloneDeep(this.studentList);

          var res = await axios({
            method: "GET",
            url: api.domain + api.batchGetElement,
            headers: { Authorization: this.$store.state.headers },
            params: {
              guc_id: this.guc_id,
              eguc_id: this.drags[index].eguc_id,
            },
          });
          if (res.data.status == 200) {
            editList = res.data.data;
            
            studentList.forEach((arr, studentIndex) => {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
              if (arr.select) {
                editList.forEach((edit) => {
                  var drag = _.cloneDeep(this.drags[index]);
                  // if (arr.id == this.s_id) {
                  //   var drag = _.cloneDeep(this.drags[index]);
                  //   if (drag.type == 1 || drag.type == 9) {
                  //     drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                  //   }

                  //   if (drag.type == 2) {
                  //     drag.showPhoto = this.clearUrl(drag.showPhoto);
                  //     drag.bRight = 0;
                  //     drag.bBottom = 0;
                  //     drag.bLeft = 0;
                  //     drag.bTop = 0;
                  //   }

                  //   if (!type) {
                  //     delete drag.textarea;
                  //   } else {
                  //   }
                  //   drags.push(drag);
                  //   editList.forEach((edit) => {
                  //       oldDrag.push(edit);
                  //   });
                  //   sids.push(drag.s_id);
                  // }

                  drag.photoScale = drag.photoScale ? drag.photoScale : 1;
                  if (arr.id == edit.s_id) {
                    drag.ec_id = edit.ec_id;
                    drag.guc_id = edit.guc_id;
                    drag.c_id = edit.c_id;
                    drag.eguc_id = edit.eguc_id;
                    console.log(drag,edit.type,'2131231231231')
                    if ((edit.type == 1 || edit.type == 9) && arr.id != this.s_id && drag.type != 2 ) {
                      drag.backgroundImg =  this.clearUrl(drag.backgroundImg);
                      drag.type = 9
                      // drag.backgroundImg = edit.backgroundImg
                      //   ? this.clearUrl(edit.backgroundImg)
                      //   : this.clearUrl(drag.backgroundImg);
                    }

                    if (edit.type == 2 && arr.id != this.s_id) {
                      drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                      drag.showPhoto =  this.clearUrl(drag.showPhoto);
                        // drag.showPhoto = edit.showPhoto
                        // ? this.clearUrl(edit.showPhoto)
                        // : this.clearUrl(drag.showPhoto);
                      // drag.photoLeft = edit.photoLeft;
                      // drag.photoTop = edit.photoTop;
                      // drag.photoScale = edit.photoScale ? edit.photoScale : 1;
                      // console.log(edit.photoScale)
                      // drag.photoRotate = edit.photoRotate;
                    }
                    
                    if (drag.type == 2 && edit.type == 9) {
                      drag.bRight = 0;
                      drag.bBottom = 0;
                      drag.bLeft = 0;
                      drag.bTop = 0;
                      drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                      drag.backImg2 = this.clearUrl(drag.backImg2)
                      drag.showPhoto =  this.clearUrl(edit.showPhoto);
                    }
                    if (!type) {
                      delete drag.textarea;
                    } else {
                    }
                    drags.push(drag);
                    oldDrag.push(edit);
                    sids.push(edit.s_id);
                  }
                });
              }
            });
          }
        }
        var changeDrag = _.cloneDeep(this.drags[index]);

        var changeState;
        if (type) { 
          changeState = await this.batchChangeDrag2(drags);
        } else {
          changeState = await this.batchChangeDrag(drags);
        }
        const indexNum = _.cloneDeep(index)
        if (changeState) {
          this.drags[index].spinning = false
          this.drags[index].draggable = true;
          this.getPhoto();
          this.photoChangeState = ''
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          console.log(oldDrag,changeDrag)
          this.czHistory = [
            ...this.czHistory,
            {
              type: "change",
              index: index,
              detail: { new: drags, old: oldDrag, changeDrag: changeDrag },
              ids: sids,
            },
          ];
          this.originDrags = _.cloneDeep(this.drags);
          this.step = this.czHistory.length - 1;
        }
      } catch (error) {
        console.log(error);
      }

      return false;
    },
    refreshDrags() {
      this.uploadWaitDrag();
      this.dragsSelect = [];
      this.dragsSelectIndexs = [];
      this.dragsSelectList = [];
      this.activeIndex = -1;
      this.getGrowupPageDetail(1);
      this.czHistory = [];
      this.step = -1;
    },
    confirmPageType() {
      if (!this.addType) {
        axios({
          method: "POST",
          url: api.domain + api.addPlateContent,
          data: {
            uid: this.uid,
            t_id: this.plate_id,
            type: this.selectPageType,
            page_num: this.selectPageType == 2 ? this.maxPage + 1 : 0,
            thumb: "",
          },
        })
          .then((res) => {
            if (res.data.status == 200) {
              this.$message.success(res.data.msg);
              this.getPlateRows(true);
              this.showTypeSelect = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((res) => {
            // this.$message('请求错误')
          });
      } else {
        var plate = null;
        this.plateList.forEach((arr) => {
          if (arr.select) {
            plate = arr;
          }
        });
        if (!plate) {
          this.$message.error("请先选择复制的模板");
        } else {
          console.log(plate);
          axios({
            method: "POST",
            url: api.domain + api.copyPlate,
            data: {
              uid: this.uid,
              st_id: plate.t_id,
              tt_id: this.plate_id,
            },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg);
                this.getPlateRows();
                this.showTypeSelect = false;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((res) => {
              // this.$message('请求错误')
            });
        }
      }
    },
    async addCom2(x, y) {
      var that = this;
      var drag = {
        left: null,
        top: null,
        width: 200,
        height: 28,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 11,
        name: "组合",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        draggable: true,
      };
      drag.left = x;
      drag.top = y;
      drag.orignWidth = this.selectXY.maxX - this.selectXY.minX;
      drag.orignHeight = this.selectXY.maxY - this.selectXY.minY;
      drag.width = this.selectXY.maxX - this.selectXY.minX;
      drag.height = this.selectXY.maxY - this.selectXY.minY;
      let isComs = false;
      this.dragsSelectIndexs.forEach((dragIndex) => {
        let arr = this.drags[dragIndex];
        if (arr.coms) {
          isComs = true;
        }
      });
      if (isComs) {
        this.$message.error("组合不可以重复组合");
        return;
      }
      let lock = false;
      // drag.coms = this.dragsSelectIndexs.map((dragIndex) => {
      //   let arr = { ...this.drags[dragIndex] };
      //   if (this.drags[dragIndex].lock) {
      //     lock = true;
      //   }
      //   arr.left = arr.left - this.selectXY.minX;
      //   arr.top = arr.top - this.selectXY.minY;
      //   this.drags[dragIndex].show = false;
      //   // delete arr.ec_id;
      //   // delete arr.eguc_id;
      //   if (arr.coms) {
      //   }
      //   return arr;
      // });
      // if (lock) {
      //   this.$message.error("锁定的组件无法继续组合");
      //   return false;
      // }
      if (that.keyDown.ctrlKey) {
        drag.zIndex = 0;
      }
      
      this.multipleDrag = _.cloneDeep(drag);
      console.log(this.multipleDrag);
      this.$nextTick(() => {
        this.$refs.multiDrag.activeDrag();
        console.log(this.activeIndex);
        this.$refs.drag[this.activeIndex].cancelActive();
        this.$refs.drag[this.activeIndex].active = false;
        this.$forceUpdate();
      });
    },

    addCom(mode) {
      if (this.dragsSelectIndexs.length < 2) {
        return;
      }
      this.initSelectDom();
      this.addCom2(this.selectXY.minX, this.selectXY.minY);
    },
    changePage(e) {
      this.selectPageType = e;
      console.log(e);
    },
    saveTextTel() {
      this.textTel.content = this.drags[this.activeIndex].textarea;
      this.showSaveText = true;
    },
    confirmSaveText() {
      if (!this.textTel.name) {
        this.$message.error("请先输入文本标题");
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.addTextTel,
        headers: { Authorization: this.$store.state.headers },
        data: this.textTel,
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success(res.data.msg);
            this.showSaveText = false;
            this.telPage.currentPage = 1
            this.getTextTel();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {});
    },
    addPage() {
      this.showTypeSelect = true;
    },
    async confirmComb(index, state = false) {
      console.log(state)
      var drags = _.cloneDeep(this.drags[index].coms);
      var originDrag = _.cloneDeep(this.drags[index]);

      drags = drags.map((arr) => {
        const scaleX = this.drags[index].orignWidth
          ? this.drags[index].width / this.drags[index].orignWidth
          : 1;
        const scaleY = this.drags[index].orignHeight
          ? this.drags[index].height / this.drags[index].orignHeight
          : 1;
        arr.left = arr.left * scaleX + originDrag.left;
        arr.top = arr.top * scaleY + originDrag.top;
        arr.width = arr.width * scaleX;
        arr.height = arr.height * scaleY;
        arr.c_id ? delete arr.c_id : () => {};
        arr.bu_id ? delete arr.bu_id : () => {};
        arr.ebu_id ? delete arr.ebu_id : () => {};
        arr.create_time ? delete arr.create_time : () => {};
        arr.update_time ? delete arr.update_time : () => {};
        return arr;
      });
      var ids = [];
      this.studentList.forEach((arr) => {
          if (arr.select) {
            ids.push(arr.id);
          }
        });
      drags.forEach((drag) => {
        
        this.saveDraging = true;
        axios({
          method: "POST",
          url: api.domain + api.batchAdd,
          headers: { Authorization: this.$store.state.headers },
          data: {
            s_ids: ids.join(","),
            guc_id: this.guc_id,
            content: JSON.stringify([drag]),
          },
        })
          .then((res) => {
            setTimeout(() => {
              this.saveDraging = false;
            }, 800);
            this.drags = [...this.drags, ...res.data.data];
          })
          .catch((res) => {
            this.$message.error("保存失败");
          });
      });
      const drag = _.cloneDeep(this.drags[index])
      await this.removeDragNoStep(index);
      this.allIndex = this.drags.length;
      if (state) return
      if (this.step < this.czHistory.length - 1) {
        this.czHistory.splice(
          this.step + 1,
          this.czHistory.length - this.step - 1
        )
      } else {
        this.czHistory = [
          ...this.czHistory,
          { type: 'confirmCom', index: index, detail:drag,
            ids: ids.join(",") }
        ]
      }
      this.step++
      // var ids = [];
      //   this.studentList.forEach((arr) => {
      //     if (arr.select) {
      //       ids.push(arr.id);
      //     }
      //   });
      //   this.saveDraging = true;
      //   axios({
      //     method: "POST",
      //     url: api.domain + api.batchAdd,
      //     headers: { Authorization: this.$store.state.headers },
      //     data: {
      //       s_ids: ids.join(","),
      //       guc_id: this.guc_id,
      //       content: JSON.stringify(drags),
      //     },
      //   })
      //     .then((res) => {
      //       setTimeout(() => {
      //         this.saveDraging = false;
      //       }, 800);
      //       this.drags = [...this.drags, ...res.data.data];
      //     })
      //     .catch((res) => {
      //       this.$message.error("保存失败");
      //     });
      
    },
    async addDrag(e) {
      console.log(this.selectPhoto,'adddrag')
      var drag;
      var select = this.selectImg;
      if (this.ComIndex >= 0) {
        drag = _.cloneDeep(this.buildUp[this.ComIndex]);
        drag.left = e.layerX - drag.width / 2;
        drag.top = e.layerY - drag.height / 2;
        drag.orignWidth = drag.width;
        drag.orignHeight = drag.height;
        drag.left < 0 ? (drag.left = 0) : () => {};
        drag.top < 0 ? (drag.top = 0) : () => {};
        drag.left + drag.width > this.wrapperWidth
          ? (drag.left = this.wrapperWidth - drag.width)
          : drag.top + drag.height > 750
          ? (drag.top = 750 - drag.height)
          : () => {};
      } else if (this.selectPhoto) {
        console.log(this.selectPhoto)
        this.selectPhoto.left = e.layerX - this.selectPhoto.width / 2;
        this.selectPhoto.top = e.layerY;

        drag = {
          allIndex: this.drags.length + 1,
          left: e.layerX - this.selectPhoto.width / 2,
          top:
            e.layerY -
            (this.selectPhoto.height != "auto"
              ? this.selectPhoto.height
              : this.selectHeight) /
              2,
          width: this.selectPhoto.width,
          height: this.selectPhoto.height ? this.selectPhoto.height : "auto",
          rotate: this.selectPhoto.rotate,
          lockAspectRatio: this.selectPhoto.lockAspectRatio,
          textarea: this.selectPhoto.textarea,
          minW: this.selectPhoto.minW,
          minH: this.selectPhoto.minH,
          type: this.selectPhoto.type,
          backgroundImg: this.clearUrl(this.selectPhoto.backgroundImg),
          backImg2: this.clearUrl(this.selectPhoto.backImg2),
          maxW: this.selectPhoto.maxW,
          maxH: this.selectPhoto.maxH,
          lock: this.selectPhoto.lock,
          zIndex: this.drags.length + 1,
          bColor: this.selectPhoto.bColor,
          fSize: this.selectPhoto.fSize,
          fColor: this.selectPhoto.fColor,
          bordersColor: this.selectPhoto.bordersColor,
          bLeft: this.selectPhoto.bLeft,
          bTop: this.selectPhoto.bTop,
          bRight: this.selectPhoto.bRight,
          bBottom: this.selectPhoto.bBottom,
          bStyle: this.selectPhoto.bStyle,
          borderRadius: this.selectPhoto.borderRadius,
          paddingLeft: this.selectPhoto.paddingLeft,
          paddingTop: this.selectPhoto.paddingTop,
          paddingRight: this.selectPhoto.paddingRight,
          paddingBottom: this.selectPhoto.paddingBottom,
          opacity: this.selectPhoto.opacity,
          showPhoto: this.clearUrl(this.selectPhoto.showPhoto),
          lineHeight: this.selectPhoto.lineHeight,
          fontWeight: this.selectPhoto.fontWeight,
          fontStyle: this.selectPhoto.fontStyle,
          textAlign: this.selectPhoto.textAlign,
          combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
          level: this.selectPhoto.level,
          levelType: this.selectPhoto.levelType,
          levelNum: this.selectPhoto.levelNum,
        };
        drag.left < 0 ? (drag.left = 0) : () => {};
        drag.top < 0 ? (drag.top = 0) : () => {};
        drag.left + drag.width > this.wrapperWidth
          ? (drag.left = this.wrapperWidth - drag.width)
          : () => {};
        drag.top + drag.height > 750
          ? (drag.top = 750 - drag.height)
          : () => {};
      } else if (this.selectImg) {
        console.log(this.selectImg);
        var img = new Image();
        img.setAttribute("crossOrigin", "Anonymous");
        img.src = this.selectImg;
        img.onload = async () => {
          const height = Math.ceil((240 * img.height) / img.width);
          drag = {
            left: e.layerX - 240 / 2,
            top: e.layerY - height / 2,
            width: 240,
            height: Math.ceil((240 * img.height) / img.width),
            rotate: 0,
            lockAspectRatio: true,
            aspectFactor: null,
            textarea: "",
            minW: null,
            minH: null,
            backgroundImg: this.clearUrl(select),
            maxW: null,
            maxH: null,
            lock: false,
            zIndex: null,
            bColor: "#cccccc",
            fColor: null,
            fSize: 14,
            lHeight: 18,
            bordersColor: "#ffffff",
            bLeft: 0,
            bTop: 0,
            bRight: 0,
            bBottom: 0,
            bStyle: "solid",
            paddingLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            opacity: 100,
            shadow: false,
            active: false,
            type: 9,
            name: "方块一",
            lineHeight: "18",
            fontStyle: "horizontal-tb",
            fontWeight: "normal",
            textAlign: "left",
            borderRadius: 0,
            zIndex: 0,
          };

          var addState = await this.batchAddDrag([drag]);
          if (addState.length > 0) {
            addState[0].lineHeightAutoSize = 1;
            this.drags = [...this.drags, ...addState];
            setTimeout(() => {
              this.getPhoto();
            }, 500);

            this.drags.forEach((arr, index) => {
              arr.active = false;
              if (index == this.drags.length - 1) {
                arr.active = true;
              }
              return arr;
            });
            setTimeout(() => {
              this.$refs.drag[this.drags.length - 1].activeDrag();
              this.showIcon = true;
              this.calcPos(this.drags.length - 1);
              setTimeout(() => {
                this.activeIndex = this.drags.length - 1;
                this.tabIndex = 0;
                this.priviewImg = "";
              }, 100);
            }, 60);

            this.allIndex = this.drags.length;
            this.selectPhoto = null;
            this.ComIndex = -1;
            var getElement = await this.batchGetElement(addState[0].eguc_id);
            var ids = [];
            var sids = [];
            if (getElement) {
              this.studentList.forEach((arr) => {
                if (arr.select) {
                  this.editList.forEach((edit) => {
                    if (arr.id == edit.s_id) {
                      ids.push(edit.ec_id);
                      sids.push(edit.s_id);
                    }
                  });
                }
              });
            }
            if (this.step < this.czHistory.length - 1) {
              this.czHistory.splice(
                this.step + 1,
                this.czHistory.length - this.step - 1
              );
            }
            this.czHistory = [
              ...this.czHistory,
              {
                type: "adddrag",
                index: null,
                detail: { new: addState, old: null, sids: sids.join(",") },
                ids: ids.join(","),
              },
            ];
            this.step++;
            this.originDrags = _.cloneDeep(this.drags);
          }
        };
      }
      if (select) return false;
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        addState[0].lineHeightAutoSize = 1;
        this.drags = [...this.drags, ...addState];
        this.drags.forEach((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.activeIndex = this.drags.length - 1;
        setTimeout(() => {
          this.calcPos(this.activeIndex);
        }, 200);
        this.allIndex = this.drags.length;
        this.selectPhoto = null;
        this.ComIndex = -1;
        var getElement = await this.batchGetElement(addState[0].eguc_id);
        var ids = [];
        var sids = [];
        if (getElement) {
          this.studentList.forEach((arr) => {
            if (arr.select) {
              this.editList.forEach((edit) => {
                if (arr.id == edit.s_id) {
                  ids.push(edit.ec_id);
                  sids.push(edit.s_id);
                }
              });
            }
          });
        }
        if (this.step < this.czHistory.length - 1) {
          this.czHistory.splice(
            this.step + 1,
            this.czHistory.length - this.step - 1
          );
        }
        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: { new: addState, old: null, sids: sids.join(",") },
            ids: ids.join(","),
          },
        ];
        this.step++;
        this.originDrags = _.cloneDeep(this.drags);
      }
    },
    clearPage() {
      this.$confirm({
        title: "确认清除并还原此页面的组件吗?",
        content: "清除后只保留模板最初组件状态，后编辑的组件将清除",
        centered: true,
        onOk: () => {
          axios({
            method: "GET",
            url: api.domain + api.resetGrowupPage,
            headers: { Authorization: this.$store.state.headers },
            params: {
              s_ids: this.s_id,
              guc_id: this.guc_id,
              is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
            },
          })
            .then((res) => {
              this.$message.info(res.data.msg);
              this.getGrowupDetail();
            })
            .catch((res) => {
              this.$message.error("清除失败");
            });
        },
        onCancel() {},
      });
    },
    calcDrag(index) {
      this.drags[index].active = true;
      this.drags[index].draggable = true;
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left +
          this.$refs.drag[index].width / 2 -
          22 +
          6,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    cancelDrawimg() {
      this.drawImg = false;
      clearInterval(this.getPdfTaskPageTime);
    },
    resetPage() {
      this.$confirm({
        title: "确认重置此学生的成长册?",
        content:
          "重置后，此学生成长册所有页面会还原成模板最初状态，需要重新编辑",
        centered: true,
        onOk: () => {
          axios({
            method: "GET",
            url: api.domain + api.resetGrowupPageSid,
            headers: { Authorization: this.$store.state.headers },
            params: {
              s_ids: this.s_id,
              // guc_id: this.guc_id,
            },
          })
            .then((res) => {
              this.$message.info(res.data.msg);
              if (res.data.status == "200") {
                this.getGrowupDetail();
              }
            })
            .catch((res) => {
              this.$message.error("清除失败");
            });
        },
        onCancel() {},
      });
    },
    save() {
      if (this.drags.length == 0) {
        this.$message.error("请先添加组件");
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.getBuiltUp,
        data: {
          uid: this.uid,
          thumb: "",
          content: this.drags,
        },
      })
        .then((res) => {
          this.$message.success("保存组合成功");
          if (res.data.status == 200) {
            this.drags = [];
          }
        })
        .catch(() => {});
    },
    getBuiltUp() {
      axios({
        method: "GET",
        url: api.domain + api.getBuiltUp2,
        headers: { Authorization: this.$store.state.headers },
        params: {
          tags: this.buildUpTag,
          type: this.buildUpType,
          limit: 15,
          page: this.currentBuild,
        },
      })
        .then((res) => {
          this.buildUpPage = res.data.data;
          this.buildUp = [];
          res.data.data.data.forEach((arr, index) => {
            var coms = arr.content;
            let data;
            coms.forEach((com, index) => {
              if (index == 0) {
                data = arr.content[0];
                var maxL = data.width > data.height ? data.width : data.height;
                data.scale = 99 / maxL;
                data.type = 3;
                data.coms = [];
              } else {
                data.coms.push(com);
              }
            });
            this.buildUp.push(data);
          });
          console.log(this.buildUp);
        })
        .catch((res) => {});
    },
    getFrame2() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag2,
          type: this.frameType2,
          limit: 18,
          page: this.currentFrame2,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage2 = res.data.data;
          this.photos2 = [];
          res.data.data.data.forEach((arr) => {
            this.photos2.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getFrame() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag,
          type: this.frameType,
          limit: 14,
          page: this.currentFrame,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage = res.data.data;
          this.photos = [];
          res.data.data.data.forEach((arr) => {
            this.photos.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getPhoto() {
      this.photoLoad = true;
      var ids = [];
      // this.studentList.forEach((arr) => {
      //   if (arr.select) {
      //     ids.push(arr.id);
      //   }
      // });
      axios({
        method: "GET",
        url: api.domain + api.getPhoto2,
        headers: { Authorization: this.$store.state.headers },
        params: {
          s_id: this.s_id,
          album_id: this.album_id,
          limit: 15,
          page: this.currentPhoto,
        },
      })
        .then((res) => {
          this.photoLoad = false;
          console.log(this.photoLoad);
          res.data.data.current_page = Number(res.data.data.current_page)
          this.picturePage = res.data.data;
          this.pictures = res.data.data.data.map((arr) => {
            arr.img_url += "?x-image-process=image/resize,w_180/quality,Q_80";
            return arr;
          });
          this.$forceUpdate();
        })
        .catch((res) => {
          // this.$message('请求错误')
          if (res.request) {
          // 请求已经成功发起，但没有收到响应
          // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
          // 而在node.js中是 http.ClientRequest 的实例
            console.log(error.request);
            this.$message.error('登录状态异常，请重新登录')
            Cookies.remove('token')
            this.$router.push({ path: "/login" });
          }
          this.photoLoad = false;
        });
    },
    getPasterClass() {
      axios({
        method: "POST",
        url: this.$api.domain + this.$api.pasterClass,
        data: {
          uid: 18,
          limit: 100,
        },
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.pasterClass = res.data.data.rows;
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    onTelSearch() {
      this.telPage.currentPage = 1;
      this.getTextTel();
    },
    getPaster() {
      if (this.pasterType == 3) {
        axios({
          method: "GET",
          url: this.$api.domain + this.$api.personalPhoto,
          headers: { Authorization: this.$store.state.headers },
          params: {
            limit: 16,
            page: this.currentPaster,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.imgs = res.data.data.list;
              this.imgPage = {
                total: res.data.data.count,
                current_page: this.currentPaster,
              };
              console.log(this.imgPage);
            }
          })
          .catch((res) => {
            console.log(res);
            console.log("getpaster错误");
            this.$message.error("服务器或网络错误");
          });
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.getPaster2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.pasterTag,
          type: this.pasterType,
          paster_class: this.pasterClassId,
          limit: 16,
          page: this.currentPaster,
        },
      })
        .then((res) => {
          this.imgPage = res.data.data;
          this.imgs = [];
          for (var index in res.data.data.data) {
            res.data.data.data[index].paster +=
              "?x-image-process=image/resize,w_100/quality,Q_80";
            this.imgs.push(res.data.data.data[index]);
          }
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getBackground() {
      axios({
        method: "POST",
        url: api.domain + api.getBackground2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.backgroundTag,
          size: this.cover_size.join("*"),
          limit: 12,
          type: this.backgroundType,
          page: this.currentBack,
        },
      })
        .then((res) => {
          this.backPage = res.data.data;
          this.backs = res.data.data.data.map((arr) => {
            arr.background +=
              "?x-image-process=image/resize,w_100/quality,Q_80";
            return arr;
          });
        })
        .catch((res) => {});
    },
    onChangeImgPage(e) {
      this.currentPaster = e;
      this.getPaster();
    },
    onChangeBuildPage(e) {
      this.currentBuild = e;
      this.getBuiltUp();
    },
    onChangeTelPage(e) {
      this.telPage.currentPage = e;
      this.getTextTel();
    },
    onChangeframePage(e) {
      this.currentFrame = e;
      this.getFrame();
    },
    onChangeframePage2(e) {
      this.currentFrame2 = e;
      this.getFrame2();
    },
    onChangepicturePage(e) {
      this.currentPhoto = e;
      this.getPhoto();
    },
    deactivated(index) {
      // if (this.activeIndex == index) {
      //   this.showIcon = false
      // }
    },
    changePageNum(index) {
      this.currentRowPage = index;
      this.czHistory = [];
      this.historyChangeState = false;
      this.activeIndex = -1;
      this.getPlateContent(this.pageObject[index].tc_id);
    },
    selectStudent(index, $event) {
      console.log($event)
      this.uploadWaitDrag();
      this.activeIndex = -1;
      this.studentList = this.studentList.map((arr) => {
        arr.has_element = true;
        return arr;
      });
      if ($event.altKey) {
        this.studentName = this.studentList[index].name;
        this.s_id = this.studentList[index].id;
        this.currentStudentIndex = index;
        this.studentList[index].select = true;
        this.getGrowupDetail();
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        return false;
      }
      if (this.moreSelect && !this.selectState) {
        this.studentList[index].select = !this.studentList[index].select;
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        return false;
      }
      if ($event.ctrlKey && !this.selectState) {
        this.studentList[index].select = !this.studentList[index].select;
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        return false;
      }
      if ($event.altKey && this.selectState) {
        this.studentName = this.studentList[index].name;
        this.s_id = this.studentList[index].id;
        this.currentStudentIndex = index;
        this.getGrowupDetail();
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        return false;
      }

      if ($event.ctrlKey && this.selectState) {
        this.studentList[index].select = !this.studentList[index].select;
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        return false;
      }
      const spinning = false
      this.drags.forEach(arr=>{
        if(arr.spinning) {
          spinning = true 
        }
      })
      if (spinning) {
        this.$message.error('部分组件正在保存，请稍后切换学生')
        return false 
      }
      if (this.moreSelect && this.selectState) {
        this.studentName = this.studentList[index].name;
        this.s_id = this.studentList[index].id;
        this.$router.replace();
        this.currentStudentIndex = index;
        this.getGrowupDetail();
        this.currentPhoto = 1;
        this.getPhoto();
        this.$forceUpdate();
        this.check_drag_edit();
        this.getLogList()
        return false;
      }
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.studentList[index].select = true;
      this.selectState = false;
      this.studentName = this.studentList[index].name;
      this.s_id = this.studentList[index].id;
      this.currentStudentIndex = index;
      this.check_drag_edit();
      this.getGrowupDetail();
      this.currentPhoto = 1;
      this.getPhoto();
      this.getLogList()
      this.$forceUpdate();
      
    },
    onChangeBackPage(e) {
      this.currentBack = e;
      this.getBackground();
    },
    changeContent(content, height, oldContent, index) {
      console.log("changetext" + index);
      console.log(content, height, oldContent, index);
      this.editorState = false;
      oldContent = this.drags[index].textarea;
      this.$set(this.drags[index], "textarea", content);
      this.changeDragHistory(index, "text", this.editListCach);
      // this.$forceUpdate();
    },
    lockPage() {
      this.saveDraging = true;
      var ids = [];
              this.studentList.forEach((arr) => {
                if (arr.select) {
                      ids.push(arr.id);
                }
              });
      axios({
        method: "POST",
        url: api.domain + api.batchEditBg,
        headers: { Authorization: this.$store.state.headers},
        data: {
          guc_id: this.guc_id,
          img_bg: this.backgroundImage,
          is_locked: this.pageDetail.is_locked ? 0 : 1,
          s_ids: ids.join(','),
          is_force: this.$store.state.forceToken ? 1 : 0,
          'force-token': this.$store.state.forceToken
      }}).then((res) => {
          setTimeout(() => {
            this.saveDraging = false;
          }, 200);
          if (res.data.status == 200) {
            this.pageDetail.is_locked = this.pageDetail.is_locked ? 0 : 1;
            return false;
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("保存失败");
        });
    },
    handleMoveCom(e) {
      e.preventDefault;
      e.stopPropagation;
    },

    rightClick(e) {
      console.log(e);
    },
    handleSelectCombination(e, index) {
      e.preventDefault;
      e.stopPropagation;
      console.log(index);
      this.ComIndex = index;
      // var fixcom = document.getElementById("fixcom");
      // console.log(this.$refs.comItem[index]);
      // this.comHtml = this.$refs.comItem[index];
    },
    handleEndMovecom() {
      console.log("111");
      setTimeout(() => {
        this.ComIndex = -1;
      }, 400);
    },
    mouseUpCombination() {},
    handleSelectPhoto2(photo, index) {
      console.log(photo);
      this.selectPhoto = photo;
      console.log(this.$refs.frame[index].height);
      this.selectHeight = (160 / 100) * this.$refs.frame[index].height;
    },
    handleSelectPhotoUrl(url, index) {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: url,
        backImg2: "",
        borderRadius: 0,
        type: 0,
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
      // this.selectHeight = (160 / 100) * this.$refs.paster[index].height;
      console.log(this.selectPhoto);
    },
    handleStarSelect() {
      this.selectPhoto = this.stars;
    },
    handleSelectText() {
      this.selectPhoto = this.texts;
    },
    handleSelectSquire() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 200,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#fff",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 7,
        name: "矢量框",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    handleSelectCircle() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 200,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#fff",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#999",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 200,
        type: 7,
        name: "矢量圆",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    handleSelectLine() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 2,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#333333",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 2,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 8,
        name: "矢量线",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    onCopy: function(e) {
      console.log("复制成功！");
      this.$message.success("复制成功");
    },
    onError: function(e) {
      this.$message.error("复制失败");
    },
    handleAddSquire(index) {
      this.selectPhoto = this.suireList[index];
    },
    cancelBcolor() {
      this.drags[this.activeIndex].bColor = null;
      this.$forceUpdate();
    },
    calcelbordersColor() {
      this.drags[this.activeIndex].bordersColor = null;
      this.$forceUpdate();
    },
    calcelPhoto() {
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = "";
      } else {
        this.drags[this.activeIndex].showPhoto = "";
        this.drags[this.activeIndex].photoLeft = 0;
        this.drags[this.activeIndex].photoTop = 0;
        this.drags[this.activeIndex].photoScale = 1;
      }
    },
    async dropImg(index, e) {
      console.log(index,this.selectPhoto)
      if (this.selectPhoto || this.ComIndex > -1) {
        this.changeStepState = false
        await this.addDrag(e);
        return false;
      }
      if (this.selectImg && this.drags[index].type == 0) {
        this.changeStepState = false
        await this.addDrag(e);
        return false;
      }
      if (!this.selectImg) return false;
      if (this.drags[index].spinning) {
          this.$message.error('组件正在保存，请稍后')
          return 
      }
      await this.batchGetElement(this.drags[index].eguc_id);
      if (!this.drag_eguc_check) {
        this.drags[index].spinning = false
        return false
      };
      this.changeStepState = false
      if (this.drags[index].type == 1 || this.drags[index].type == 9) {
        if (this.clearUrl(this.selectImg) != this.clearUrl(this.drags[index].backgroundImg)) {
          this.drags[index].spinning = true
          this.drags[index].draggable = false
        } else {
          this.drags[index].spinning = false
        }

        
        this.drags[index].lockAspectRatio = true;
        this.drags[index].backgroundImg =
          this.clearUrl(this.selectImg) +
          "?x-image-process=image/resize,w_650/quality,Q_120";
      } else if (
        this.drags[index].type == 2 
      ) {
        if (this.clearUrl(this.selectImg) != this.clearUrl(this.drags[index].showPhoto)) {
          this.drags[index].spinning = true
          this.drags[index].draggable = false
          this.drags[index].showPhoto =
          this.clearUrl(this.selectImg) +
          "?x-image-process=image/resize,w_650/quality,Q_120";
        } else {
          this.drags[index].spinning = false
          console.log('ha2')
        }
        
        // this.drags[index].photoLeft = 0;
        // this.drags[index].photoTop = 0;
        // this.drags[index].photoScale = 1;
      }
    },
    async dropImg2(index, imgUrl) {
      if (this.drags[index].spinning) {
          this.$message.error('组件正在保存，请稍后')
          return 
      }
      if (this.drags[index].type == 1 || this.drags[index].type == 9) {
        if (this.clearUrl(imgUrl) != this.clearUrl(this.drags[index].backgroundImg)) {
          this.drags[index].spinning = true
          this.drags[index].draggable = false
        } else {
          this.drags[index].spinning = false
        }

        
        this.drags[index].lockAspectRatio = true;
        this.drags[index].backgroundImg =
          this.clearUrl(imgUrl) +
          "?x-image-process=image/resize,w_650/quality,Q_120";
      } else if (
        this.drags[index].type == 2 
      ) {
        if (this.clearUrl(imgUrl) != this.clearUrl(this.drags[index].showPhoto)) {
          this.drags[index].spinning = true
          this.drags[index].draggable = false
          this.drags[index].showPhoto =
          this.clearUrl(imgUrl) +
          "?x-image-process=image/resize,w_650/quality,Q_120";
        } else {
          this.drags[index].spinning = false
          console.log('ha2')
        }
        
        // this.drags[index].photoLeft = 0;
        // this.drags[index].photoTop = 0;
        // this.drags[index].photoScale = 1;
      }
    },
    mouseUpPhoto() {
      setTimeout(() => {
        this.selectPhoto = null;
        this.selectImg = ''
      }, 80);
    },
    handleSelectPhoto(img) {
      this.selectPhoto = null;
      this.priviewImg = "";
      this.selectImg = img;
    },
    listenMouseEnter(dragIndex, zIndex) {
      this.mouseIn.push(this.dragIndex);
    },
    listenMouseLeave(dragIndex, zIndex) {
      this.mouseIn.forEach((arr, index) => {
        if (arr == dragIndex) {
          this.mouseIn.splice(index, 1);
        }
      });
    },
    up() {
      if (this.activeIndex < 0) return false;
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1)
        return false;

      // this.drags = this.drags.map((arr, index) => {
      //   if (
      //     this.drags[index].zIndex ==
      //     this.drags[this.activeIndex].zIndex + 1
      //   ) {
      //     arr.zIndex--;
      //   }
      //   return arr;
      // });
      this.drags[this.activeIndex].zIndex++;
      this.changeDragHistory(this.activeIndex);
    },
    down() {
      if (this.activeIndex < 0) return false;
      if (this.drags[this.activeIndex].zIndex == 0) return false;

      // this.drags = this.drags.map((arr, index) => {
      //   if (
      //     this.drags[index].zIndex ==
      //     this.drags[this.activeIndex].zIndex - 1
      //   ) {
      //     arr.zIndex++;
      //   }
      //   return arr;
      // });
      if (this.drags[this.activeIndex].zIndex == 1) {
        this.drags.forEach((arr, index) => {
          if (arr.zIndex == 0) {
            this.drags[index].zIndex = 1;
            this.changeDragHistory(index);
          }
        });
      }
      this.drags[this.activeIndex].zIndex--;
      this.changeDragHistory(this.activeIndex);
    },

    toTop() {
      if (this.activeIndex < 0) return false;
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1)
        return false;
      var zIndexs = [];
      this.drags.forEach((arr) => {
        zIndexs.push(arr.zIndex);
      });
      this.drags[this.activeIndex].zIndex = _.max(zIndexs)
        ? _.max(zIndexs) + 1
        : 1;
      this.changeDragHistory(this.activeIndex);
      return;
      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex > this.drags[this.activeIndex].zIndex) {
          arr.zIndex--;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = this.drags.length - 1;
      this.changeDragHistory(this.activeIndex);
    },
    toBottom() {
      if (this.activeIndex < 0) return false;
      if (this.drags[this.activeIndex].zIndex == 0) return false;
      this.drags.forEach((arr, index) => {
        if (arr.zIndex == 0) {
          this.drags[index].zIndex = 1;
          this.changeDragHistory(index);
        }
      });
      this.drags[this.activeIndex].zIndex = 0;
      this.changeDragHistory(this.activeIndex);
      return;
      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex < this.drags[this.activeIndex].zIndex) {
          arr.zIndex++;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = 0;
      this.changeDragHistory(this.activeIndex);
    },
    handledownZJ() {
      this.drags[this.activeIndex].active = true;
    },
    rotating(left, top, width, height, rotate, index) {
      this.drags[index].rotate =
        parseInt(rotate) < 0
          ? 360 - (-parseInt(rotate) % 360)
          : parseInt(rotate);
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    pmoving(left, top, rotate, scale, index) {
      console.log(scale);
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.drags[index].photoRotate = parseFloat(rotate);
      this.$forceUpdate();
      this.changeStepState = false
      console.log(scale);
      this.changeDragHistory(index);
    },
    photoChange(left, top, rotate, scale, index) {
      console.log('photoChange',left, top, rotate, scale);
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.drags[index].photoRotate = parseFloat(rotate);
      this.selectImg = ''
      this.$forceUpdate();
      
      console.log('nextStepState',this.nextStepState);
      if (this.changeStepState ) {
          this.changeStepState = false
          return false
      } 
      this.photoChangeState = index
      this.changeDragHistory(index);
      
    },
    movingStop(left, top, scale, index) {
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.$forceUpdate();
      console.log(scale);
      this.changeDragHistory(index);
    },
    resizing(left, top, width, height, picLeft, picTop, index, raduis) {
      this.drags[index].left = parseInt(left) ? parseInt(left) : 0;
      this.drags[index].top = parseInt(top);
      this.drags[index].width = parseInt(width);
      this.drags[index].height = parseInt(height);
      this.drags[index].photoLeft = parseInt(picLeft);
      this.drags[index].photoTop = parseInt(picTop);
      console.log(raduis);
      if (raduis) {
        this.drags[index].borderRadius = parseInt(raduis);
      }
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    dragging(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      if (isNaN(left) || isNaN(top)) return false;
      this.drags[dragIndex].left = parseInt(left);
      this.drags[dragIndex].top = parseInt(top);
      this.$forceUpdate();
      this.changeDragHistory(dragIndex);
    },

    resizing(left, top, width, height, picLeft, picTop, index, raduis) {
      this.drags[index].left = parseInt(left) ? parseInt(left) : 0;
      this.drags[index].top = parseInt(top);
      this.drags[index].width = parseInt(width);
      this.drags[index].height = parseInt(height);
      this.drags[index].photoLeft = parseInt(picLeft);
      this.drags[index].photoTop = parseInt(picTop);
      console.log(raduis);
      if (raduis) {
        this.drags[index].borderRadius = parseInt(raduis);
      }
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    resizingComStop(left, top, width, height, picLeft, picTop, index, raduis,scaleP) {
      console.log("dragging:" ,height);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      this.multipleDrag.left = left;
      this.multipleDrag.top = top;
      this.multipleDrag.width = width;
      this.multipleDrag.height = height;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        let left = this.multipleDrag.left + (this.drags[dragIndex].left  - this.multipleDrag.left ) * scaleP + parseInt(movLeft);
        let top = this.multipleDrag.top + (this.drags[dragIndex].top - this.multipleDrag.top)* scaleP + parseInt(movTop);
        const width = this.drags[dragIndex].width * scaleP
        const height =  this.drags[dragIndex].height == 'auto' ? 'auto' :  this.drags[dragIndex].height * scaleP
        const fSize = this.drags[dragIndex].fSize ? Number((this.drags[dragIndex].fontSize * scaleP).toFixed(2)): 12
        let borderRadius;
        if (this.drags[dragIndex].type == 9) {
          borderRadius = this.drags[dragIndex].borderRadius * scaleP
        }
        this.drags[dragIndex].left = left;
        this.drags[dragIndex].top = top;
        this.drags[dragIndex].width = width;
        this.drags[dragIndex].height = height;
        this.drags[dragIndex].borderRadius = borderRadius
        this.$forceUpdate();
        this.changeDragHistory(dragIndex);
      });
      
    },
    resizingCom(left, top, width, height, picLeft, picTop, index,scaleP) {
      console.log("dragging:" ,height);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      // const scaleP = width / this.multipleDrag.width
      // this.multipleDrag.left = left;
      // this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        let left = this.multipleDrag.left + (this.drags[dragIndex].left  - this.multipleDrag.left ) * scaleP + parseInt(movLeft);
        let top = this.multipleDrag.top + (this.drags[dragIndex].top - this.multipleDrag.top)* scaleP + parseInt(movTop);
        const width = this.drags[dragIndex].width * scaleP
        const height =  this.drags[dragIndex].height == 'auto' ? 'auto' :  this.drags[dragIndex].height * scaleP
        const fSize = this.drags[dragIndex].fSize ? Number((this.drags[dragIndex].fontSize * scaleP).toFixed(2)): 12
        let borderRadius;
        if (this.drags[dragIndex].type == 9) {
          borderRadius = this.drags[dragIndex].borderRadius * scaleP
        }
        this.$refs.drag[dragIndex].setData({ left: left, top: top ,width,height,fSize,borderRadius});
      });
      this.$forceUpdate();
    },
    draggingCom(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      // this.multipleDrag.left = left;
      // this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        const left = this.drags[dragIndex].left + parseInt(movLeft);
        const top = this.drags[dragIndex].top + parseInt(movTop);

        this.$refs.drag[dragIndex].setData({ left: left, top: top });
        this.$forceUpdate();
      });
    },
    draggingComStop(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      this.multipleDrag.left = left;
      this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        this.drags[dragIndex].left =
          this.drags[dragIndex].left + parseInt(movLeft);
        this.drags[dragIndex].top =
          this.drags[dragIndex].top + parseInt(movTop);
        this.$forceUpdate();
        this.$refs.drag[dragIndex].update()
        this.changeDragHistory(dragIndex);
      });
    },
    beforeUpload(file) {
          const { valid, message } = checkFileFormat(file);
          if (!valid) {
            this.$message.warning(message);
            return false;
          }
          return true;
        },
    clearErrorDrag() {
      const ids = this.drags.filter(arr => {
        return arr.width === null || arr.width === NaN || arr.width === undefined
      })
      if (ids.length) {
        this.batchDel(ids, this.s_id)
      } else {
        this.$message.error('未检测到异常组件')
      }
      
    },
    async batchDel(ids, s_ids) {
      // if (this.delState) return false;
      this.activeIndex = -1;
      if (this.msgHide) {
        this.msgHide();
      }
      this.msgHide = this.$message.info("正在删除中,请稍后操作", 0);
      this.saveDraging = true;
      this.delState = true;
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchDel,
          headers: { Authorization: this.$store.state.headers },
          data: {
            eguc_ids: ids,
            s_ids: s_ids,
          },
        });
        // this.delState = false;
        this.$message.destroy();
        setTimeout(() => {
          this.saveDraging = false;
        }, 300);
        this.getPhoto();
        return true;
      } catch (error) {
        this.delState = false;
        this.$message.destroy();
        this.$message.error("请求失败");
        return false;
      }
    },
    calcPos(index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;
      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        70;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left +
          this.$refs.drag[index].width / 2 -
          22 +
          6,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
      this.activeIndex = index;
      this.$refs.drag[index].activeDrag();
    },
    async delAll() {
      this.$confirm({
        title: "删除组件",
        content: "空白的文本、矢量相框、相框都将清空，确认删除吗？",
        centered: true,
        onOk: async () => {
          var that = this;
          var sids = [];
          that.studentList.forEach((arr) => {
            if (arr.select) {
              sids.push(arr.id);
            }
          });
          const ids = this.drags.filter(drag=>drag.noFill).map((arr) => {
            return arr.eguc_id;
          }).join(",");
          if (!ids) {
            this.$message.error("没有可删除的组件");
            return false;
          }
          var res = await that.batchDel(ids, sids.join(","));
          setTimeout(() => {
              this.getGrowupDetail();
              this.currentPhoto = 1;
              this.getPhoto();
              this.$forceUpdate();
            }, 100);
        },
        onCancel() {
          console.log("取消删除");
        },
      });
      
      // this.drags.forEach(async (drag,index) => {
      //   if ((drag.type == 9 || drag.type == 1) && !drag.backgroundImg) {
      //     var res = await that.batchDel(drag.eguc_id, sids.join(","));
      //   }
      //   if (index == this.drags.length -1)  {
      //       setTimeout(() => {
      //         this.getGrowupDetail();
      //         this.currentPhoto = 1;
      //         this.getPhoto();
      //         this.$forceUpdate();
      //       }, 100);
      //     }
      // });
    },
    async handleRemoveDrag(e) {
      if (this.dragsSelectIndexs && this.dragsSelectIndexs.length > 1) {
        var arr = this.dragsSelectIndexs.sort().reverse();
        console.log(arr);
        arr.forEach(async (dragIndex, index) => {
          await this.handleRemoveDrags(dragIndex);
          if (index == arr.length - 1) {
            setTimeout(() => {
              this.dragsSelectIndexs = [];
              arr.forEach((dragIndex) => {
                this.drags.splice(dragIndex, 1);
              });
            }, 200);
          }
        });
        return false;
      }
      var index = this.activeIndex;
      if (
        (this.drags[index] && this.drags[index].lock) ||
        this.pageDetail.is_locked
      )
        return false;
      if (index < 0) return false;

      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      // this.drags[this.activeIndex].active = true;
      // this.$message.loading({ content: "删除中", key: "del", duration: 2 });
      if (that.drags[index].eguc_id) {
        var drag = that.drags[index];
        var res = await that.batchDel(drag.eguc_id, sids.join(","));
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { eguc_ids: drag.eguc_id, sids: sids, cancelDrag: drag },
              ids: sids.join(","),
            },
          ];
          // this.$message.success({
          //   content: "删除成功",
          //   key: "del",
          //   duration: 2,
          // });
          this.step++;
          if (that.drags.length > 0) {
            // that.drags.map((arr) => {
            //   if (arr.zIndex > delZindex) {
            //     arr.zIndex--;
            //   }
            //   return arr;
            // });
          } else {
            that.activeIndex = -1;
          }
        }
      }
    },
    async handleRemoveDrags(dragIndex) {
      var index = dragIndex;
      if (
        (this.drags[index] && this.drags[index].lock) ||
        this.pageDetail.is_locked
      )
        return false;
      if (index < 0) return false;

      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      // this.drags[this.activeIndex].active = true;
      // this.$message.loading({ content: "删除中", key: "del", duration: 2 });

      if (that.drags[index].eguc_id) {
        console.log(that.drags[index]);
        var drag = that.drags[index];
        var res = await that.batchDel(drag.eguc_id, sids.join(","));
        console.log(res);
        if (res) {
          that.activeIndex = -1;
          // that.drags.splice(index, 1);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { eguc_ids: drag.eguc_id, sids: sids, cancelDrag: drag },
              ids: sids.join(","),
            },
          ];
          // this.$message.success({
          //   content: "删除成功",
          //   key: "del",
          //   duration: 2,
          // });
          this.step++;
          if (that.drags.length > 0) {
            // that.drags.map((arr) => {
            //   if (arr.zIndex > delZindex) {
            //     arr.zIndex--;
            //   }
            //   return arr;
            // });
          } else {
            that.activeIndex = -1;
          }
        }
      }
    },
    async handleRemoveDrag2(index2) {
      var index = index2 ? index2 : this.activeIndex;
      console.log(index);
      if (
        (this.drags[index] && this.drags[index].lock) ||
        this.pageDetail.is_locked
      )
        return false;
      if (index < 0) return false;

      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      // this.drags[this.activeIndex].active = true;
      // this.$message.loading({ content: "删除中", key: "del", duration: 2 });
      if (that.drags[index].eguc_id) {
        var drag = that.drags[index];
        var res = await that.batchDel(drag.eguc_id, sids.join(","));
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { eguc_ids: drag.eguc_id, sids: sids, cancelDrag: drag },
              ids: sids.join(","),
            },
          ];
          // this.$message.success({
          //   content: "删除成功",
          //   key: "del",
          //   duration: 2,
          // });
          this.step++;
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          } else {
            that.activeIndex = -1;
          }
        }
      }
    },
    async removeDrag(index) {
      if (this.drags[index].lock || this.pageDetail.is_locked) return false;
      var that = this;
      var delZindex = that.drags[index].zIndex;
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      if (that.drags[index].eguc_id) {
        var res = await that.batchDel(
          that.drags[index].eguc_id,
          sids.join(",")
        );
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { new: that.editList[0], old: null },
              ids: sids.join(","),
            },
          ];
          this.step++;
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          }
        }
      }
    },
    async removeDragNoStep(index) {
      if (this.drags[index].lock || this.pageDetail.is_locked) return false;
      var that = this;
      var delZindex = that.drags[index].zIndex;
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      if (that.drags[index].eguc_id) {
        var res = await that.batchDel(
          that.drags[index].eguc_id,
          sids.join(",")
        );
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          }
        }
      }
    },
    dqdrags(mode) {
      if (this.dragsSelectIndexs.length < 2) {
        return;
      }
      let x2, y2;
      switch (mode) {
        case "left":
          x2 = this.selectXY.minX;
          y2 = 0;
          break;

        case "right":
          x2 = this.selectXY.maxX;
          y2 = 0;
          break;

        case "top":
          x2 = 0;
          y2 = this.selectXY.minY;
          break;

        case "bottom":
          x2 = 0;
          y2 = this.selectXY.maxY;
          break;

        case "horCenter":
          x2 = (this.selectXY.minX + this.selectXY.maxX) / 2;
          y2 = 0;
          break;
        case "verCenter":
          x2 = 0;
          y2 = (this.selectXY.minY + this.selectXY.maxY) / 2;
          break;

        default:
          break;
      }
      this.moveDrags(mode, x2, y2);
    },
    moveDrags(mode, moveX, moveY) {
      console.log(mode, moveX, moveY);
      const list = [];
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        const arrayX = [];
        const arrayY = [];
        this.dragsSelectList[index].forEach((arr2) => {
          arrayX.push(arr2.x);
          arrayY.push(arr2.y);
        });
        const orginXy = {
          minX: _.min(arrayX),
          minY: _.min(arrayY),
          maxX: _.max(arrayX),
          maxY: _.max(arrayY),
        };
        switch (mode) {
          case "left":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left - (orginXy.minX - moveX)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "right":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left - (orginXy.maxX - moveX)
            );
            this.batchChangeDrag2(this.drags[dragIndex]);
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "top":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top - (orginXy.minY - moveY)
            );
            this.batchChangeDrag2(this.drags[dragIndex]);
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "bottom":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top - (orginXy.maxY - moveY)
            );
            this.batchChangeDrag2(this.drags[dragIndex]);
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "horCenter":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left -
                (this.drags[dragIndex].left +
                  this.drags[dragIndex].width / 2 -
                  moveX)
            );
            this.batchChangeDrag2(this.drags[dragIndex]);
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;
          case "verCenter":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top -
                (this.drags[dragIndex].top +
                  this.drags[dragIndex].height / 2 -
                  moveY)
            );
            this.batchChangeDrag2(this.drags[dragIndex]);
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          default:
            break;
        }
        list.push(this.drags[dragIndex]);
        this.dq_step = true;
      });
      this.batchChangeDrag2(list);
    },
    initSelectDom() {
      const list = [];
      const arrayX = [];
      const arrayY = [];
      let minx, miny, maxX, maxY;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        console.log(dragIndex);
        const arr = this.drags[dragIndex];
        const xy = getCoordinate(
          arr.left + arr.width / 2,
          arr.top + arr.height / 2,
          arr.rotate,
          arr.left,
          arr.top
        );
        xy.forEach((arr2) => {
          arrayX.push(arr2.x);
          arrayY.push(arr2.y);
        });
        list.push(xy);
      });
      this.dragsSelectList = [...list];
      this.arrayX = arrayX;
      this.arrayY = arrayY;
      this.selectXY = {
        minX: _.min(arrayX),
        minY: _.min(arrayY),
        maxX: _.max(arrayX),
        maxY: _.max(arrayY),
      };
      // setTimeout(() => {
      //   this.dragsSelectIndexs.forEach((arr) => {
      //     this.$refs.drag[arr].activeDrag();
      //   });
      // }, 80);
    },
    changeDrag(index) {
      console.log(index,this.activeIndex)
      console.log(this.keyDown.ctrlKey, this.dragsSelect);
      if (this.drags[index].spinning) {
        this.$message.error('此组件正在保存，请稍后操作')
        return
      }
      if (this.keyDown.shiftKey && this.dragsSelect && !this.pageDetail.is_locked) {
        let isCF = false;
        this.dragsSelectIndexs.forEach((dragIndex) => {
          if (dragIndex === index) {
            isCF = true;
          }
        });
        if (isCF) {
        } else {
          if (this.drags[index].lock || this.pageDetail.is_locked) {
            this.$message.error('锁定组件不能组合')
            return false
          } 
          this.dragsSelect = [...this.dragsSelect, { ...this.drags[index] }];
          this.dragsSelectIndexs = [...this.dragsSelectIndexs, index];
          console.log(this.dragsSelect);
        }
        // this.initSelectDom();
        this.addCom();
        if (this.dragsSelect && this.dragsSelect.length == 1) {
          this.dq_step = false;
          this.dragsSelect = null;
          this.dragsSelectIndexs = null;
          this.dragsSelect = [{ ...this.drags[index] }];
          this.dragsSelectIndexs = [index];
          this.dragsSelect[0].index = index;
          this.$set(this.drags[index], "shiftkey", true);
          this.uploadWaitDrag();
          this.activeIndex = index;
          var orignX =
            this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
          var orignY =
            this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

          this.moveBoxRight =
            this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
          this.moveBoxTop =
            this.$refs.drag[index].top +
            this.$refs.drag[index].getHeight() / 2 -
            67;
          this.transformX = orignX - this.moveBoxRight;
          this.transformY = orignY - this.moveBoxTop;
          this.rotateStyles = {
            top: this.$refs.drag[index].top - 10,
            left:
              this.$refs.drag[index].left +
              this.$refs.drag[index].width / 2 -
              22,
            rotateX:
              orignX -
              (this.$refs.drag[index].left +
                this.$refs.drag[index].width / 2 -
                22),
            rotateY: orignY - (this.$refs.drag[index].top - 10),
          };
          this.moveBoxRotate = this.$refs.drag[index].rotate;
          if (this.tabIndex != 10) {
            this.tabIndex = 0;
          }
          this.showIcon = true;
          // setTimeout(() => {
          //   this.$refs["drag"][index].active = false
          //   this.$refs["drag"][index].cancelActive()
          // }, 100);

          this.batchGetElement(this.drags[index].eguc_id);
          this.getLogList(this.drags[index].ec_id);

        }
      } else {
        this.multipleDrag = null;
        this.dq_step = false;
        this.dragsSelect = null;
        this.dragsSelectIndexs = null;
        this.dragsSelect = [{ ...this.drags[index] }];
        this.dragsSelectIndexs = [index];
        this.dragsSelect[0].index = index;
        this.$set(this.drags[index], "shiftkey", true);
        this.uploadWaitDrag();
        this.activeIndex = index;
        console.log(index,this.activeIndex)
        this.$refs["drag"][index].activeDrag();
        var orignX =
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
        var orignY =
          this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

        this.moveBoxRight =
          this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
        this.moveBoxTop =
          this.$refs.drag[index].top +
          this.$refs.drag[index].getHeight() / 2 -
          67;
        this.transformX = orignX - this.moveBoxRight;
        this.transformY = orignY - this.moveBoxTop;
        this.rotateStyles = {
          top: this.$refs.drag[index].top - 10,
          left:
            this.$refs.drag[index].left +
            this.$refs.drag[index].width / 2 -
            22 +
            6,
          rotateX:
            orignX -
            (this.$refs.drag[index].left +
              this.$refs.drag[index].width / 2 -
              22),
          rotateY: orignY - (this.$refs.drag[index].top - 10),
        };
        this.moveBoxRotate = this.$refs.drag[index].rotate;
        if (this.tabIndex != 10) {
          this.tabIndex = 0;
        }
        this.showIcon = true;
        this.batchGetElement(this.drags[index].eguc_id);
          this.getLogList(this.drags[index].ec_id);

      }
      
    },
    selectAllStudent() {
      this.uploadWaitDrag();
      this.studentList = this.studentList.map((arr) => {
        if (this.selectState) {
          arr.select = false;
        } else {
          arr.select = true;
        }
        arr.has_element = true;
        return arr;
      });
      if (this.selectState) {
        this.selectState = false;
      } else {
        this.selectState = true;
      }
      if (this.currentStudentIndex > -1) {
        this.studentList[this.currentStudentIndex].select = true;
      }
      this.check_drag_edit()
    },
    changeSwitch(e) {
      console.log(e);
      this.drags[this.activeIndex].shadow = e;
      this.$forceUpdate();
    },
    changeSwitch2(e) {
      this.drags[this.activeIndex].textShadow = e;
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params;
      let id = 0;
      this.vLine = vLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
      this.hLine = hLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
    },
    async addText() {
      return false;
      var item = this.texts;
      var drag = {
        allIndex: this.drags.length + 1,
        left: 216 - item.width / 2,
        top: 350 - (item.height ? item.height : 0) / 2,
        width: item.width,
        height: item.height ? item.height : "auto",
        rotate: item.rotate,
        lockAspectRatio: item.lockAspectRatio,
        textarea: item.textarea,
        minW: item.minW,
        minH: item.minH,
        type: item.type,
        backgroundImg: item.type == 1 ? "" : item.backgroundImg,
        backImg2: item.backImg2,
        maxW: item.maxW,
        maxH: item.maxH,
        lock: item.lock,
        zIndex: this.drags.length + 1,
        bColor: item.bColor,
        fColor: item.fColor,
        bordersColor: item.bordersColor,
        bLeft: item.bLeft,
        bTop: item.bTop,
        bRight: item.bRight,
        bBottom: item.bBottom,
        bStyle: item.bStyle,
        paddingLeft: item.paddingLeft,
        paddingTop: item.paddingTop,
        paddingRight: item.paddingRight,
        paddingBottom: item.paddingBottom,
        opacity: item.opacity,
        showPhoto: item.showPhoto,
        lineHeight: item.lineHeight,
        fontWeight: item.fontWeight,
        fontStyle: item.fontStyle,
        textAlign: item.textAlign,
        combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
      };
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        this.drags = [...this.drags, ...addState];
        this.drags.forEach((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.activeIndex = this.drags.length - 1;
        this.allIndex = this.drags.length;
        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: addState,
          },
        ];
        this.originDrags = _.cloneDeep(this.drags);
      }
    },
    async addPhoto2(url) {
      return false;
      console.log(url);
      var drag = {
        left: 265 - 160 / 2,
        top: 250,
        width: 160,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: url,
        backImg2: "",
        borderRadius: 0,
        type: 1,
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        this.drags = [...this.drags, ...addState];
        this.drags.forEach((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.activeIndex = this.drags.length - 1;
        this.allIndex = this.drags.length;
        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: addState,
          },
        ];
        this.originDrags = _.cloneDeep(this.drags);
      }
    },
    async addPhoto(item) {
      return false;
      var drag = {
        allIndex: this.drags.length + 1,
        left: 216 - item.width / 2,
        top: 350 - (item.height ? item.height : 0) / 2,
        width: item.width,
        height: item.height ? item.height : "auto",
        rotate: item.rotate,
        lockAspectRatio: item.lockAspectRatio,
        textarea: item.textarea,
        minW: item.minW,
        minH: item.minH,
        type: item.type,
        backgroundImg: item.type == 1 ? "" : item.backgroundImg,
        backImg2: item.backImg2,
        maxW: item.maxW,
        maxH: item.maxH,
        lock: item.lock,
        zIndex: this.drags.length + 1,
        bColor: item.bColor,
        fColor: item.fColor,
        bordersColor: item.bordersColor,
        bLeft: item.bLeft,
        bTop: item.bTop,
        bRight: item.bRight,
        bBottom: item.bBottom,
        bStyle: item.bStyle,
        paddingLeft: item.paddingLeft,
        paddingTop: item.paddingTop,
        paddingRight: item.paddingRight,
        paddingBottom: item.paddingBottom,
        opacity: item.opacity,
        showPhoto: item.showPhoto,
        lineHeight: item.lineHeight,
        fontWeight: item.fontWeight,
        fontStyle: item.fontStyle,
        textAlign: item.textAlign,
      };
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        this.drags = [...this.drags, ...addState];
        this.drags.forEach((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.activeIndex = this.drags.length - 1;
        this.allIndex = this.drags.length;
        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: addState,
          },
        ];
        this.originDrags = _.cloneDeep(this.drags);
      }
    },
    changeTab(index) {
      console.log(this.activeIndex);
      this.tabIndex = index;
      if (this.tabIndex == 7) {
        setTimeout(() => {
          this.editState = true;
        }, 400);
      } else {
        this.editState = false;
      }

      if (this.tabIndex == 8 && this.telList.length == 0) {
        this.getTextTel();
      }
    },
    selectPlate(index) {
      this.plateList = this.plateList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.plateList[index].select = true;
      this.$forceUpdate();
    },
    changeBack2(url) {
      var s_ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          s_ids.push(arr.id);
        }
      });
      axios({
        method: "POST",
        url: api.domain + api.batchEditBg,
        headers: { Authorization: this.$store.state.headers},
        data: {
          guc_id: this.guc_id,
          img_bg: url,
          s_ids: s_ids.join(","),
          is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
        },
      })
        .then((res) => {})
        .catch((res) => {});
    },
    cancelPasterDrag() {
      this.copyDrag = null;
    },
    changeBack(url) {
      this.$confirm({
        title: "确认替换背景吗?",
        content: "背景替换后可能无法撤销，请谨慎使用",
        centered: true,
        onOk: () => {
          var originUrl = this.backgroundImage;
          var s_ids = [];
          if (url.indexOf("?")) {
            url = url.split("?")[0];
          }
          this.studentList.forEach((arr) => {
            if (arr.select) {
              s_ids.push(arr.id);
            }
          });
          axios({
            method: "POST",
            url: api.domain + api.batchEditBg,
            headers: { Authorization: this.$store.state.headers},
            data: {
              guc_id: this.guc_id,
              img_bg: url,
              s_ids: s_ids.join(","),
              is_force: this.$store.state.forceToken ? 1 : 0, 'force-token': this.$store.state.forceToken
            },
          })
            .then((res) => {
              if (res.data.status == 201) {
                this.$message.error(res.data.msg);
                return false;
              }
              this.backgroundImage = url;
              // this.$message.success('切换背景成功')
              if (this.step < this.czHistory.length - 1) {
                this.czHistory.splice(
                  this.step + 1,
                  this.czHistory.length - this.step - 1
                );
              }
              this.czHistory = [
                ...this.czHistory,
                {
                  type: "changeBack",
                  index: null,
                  detail: originUrl,
                },
              ];

              this.step = this.czHistory.length - 1;
              console.log(this.czHistory, this.step);
            })
            .catch((res) => {});
        },
        onCancel() {},
      });
    },
    changeImgs(url) {
      this.drags[this.activeIndex].active = true;
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = url;
      } else {
        this.drags[this.activeIndex].showPhoto = url;
        this.drags[this.activeIndex].photoLeft = 0;
        this.drags[this.activeIndex].photoTop = 0;
        this.drags[this.activeIndex].photoScale = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .quill-editor {
  -webkit-text-size-adjust: none;
  height: 90%;
}

.rotatebox {
  position: absolute;
  width: 30px;
  z-index: 1100;
  right: 0;
  top: 0;
  height: 30px;
  text-align: center;

  &::before {
    font-size: 22px;
    color: #399fe4;
    font-weight: bold;
    line-height: 30px;
    text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0;
  }

  i {
    font-size: 22px;
    color: #399fe4;
    font-weight: bold;
    line-height: 30px;
  }
}

.moveBOX {
  position: absolute;
  width: 45px;
  z-index: 1100;
  display: flex;
  // background: #fff;
  padding: 4px 0px;
  right: -40px;
  top: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  i {
    font-size: 25px;
    color: #399fe4;
  }

  img {
    width: 28px;
    height: 28px;
    margin: 6px 0;
    cursor: move;
  }
}

.fixtop {
  position: fixed;
  left: 0;
  right: 381px;
  box-sizing: border-box;
  top: 0;
  height: 60px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 30;

  .left {
    widows: 385px;
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 20px;
    top: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-items: center;

    .name {
      width: 70px;
      margin-right: 5px;
      cursor: pointer;
    }

    .main {
      font-size: 16px;
      margin-left: 5px;
    }
  }

  .right {
    position: absolute;
    right: 10px;
    top: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .save {
      background: #746bff;
      color: #fff;
      text-align: center;
      padding: 4px 12px;
      font-size: 12px;
      border-radius: 2px;
    }
  }

  .cz {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 250px;
    margin-right: 10px;
    text-align: center;
    font-size: 12px;
    color: #5d5d5d;

    .cz-item {
      flex: 1 1 0%;
      cursor: pointer;

      .name {
        margin-top: 4px;
      }
    }
  }
}

.leftLine {
  position: absolute;
  width: 1px;
  background: #c70a0a;
  z-index: 10000;
}

.topLine {
  position: absolute;
  height: 1px;
  background: #c70a0a;
  z-index: 10000;
}

.rightLine {
  position: absolute;
  width: 1px;
  background: #c70a0a;
  z-index: 10000;
}

.bottomLine {
  position: absolute;
  height: 1px;
  background: #c70a0a;
  z-index: 10000;
}

.circles {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 20px;

  .circle {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    div {
      width: 18px;
      height: 18px;
      border-radius: 18px;
      border: 1px solid #c70a0a;
      background: transparent;
    }
  }
}

.item-line .input {
  width: 120px;
}

.uploadstate {
  color: #2f73da;
  text-align: center;
}

.edit-list {
  width: 100%;

  .edit-cell {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    .quill-editor {
      flex: 1 1 0%;

      ::v-deep .ql-toolbar {
        display: none !important;
      }

      ::v-deep .ql-container {
        border-top: 1px solid #ccc;
        height: auto;
      }
    }

    .name {
      width: 4em;
      margin-right: 6px;
    }
  }
}

.clearbt {
  position: fixed;
  bottom: 10px;
  right: 390px;
}

.num-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .num-cell {
    margin-right: 10px;
  }

  i {
    margin-right: 8px;
  }

  .el-input-number {
    width: 90px;
  }
}

.flex-1 {
  flex: 1 1 0%;
}

.section {
  width: 100%;

  .section-item {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;

    .item-line {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      margin-bottom: 10px;

      span.name2 {
        font-size: 14px;
        color: rgb(141, 158, 167);
        line-height: 38px;
        margin: 0 10px;
        box-sizing: border-box;
        width: 20px;
      }

      .title {
        flex: 1 1 0%;
      }

      .cell {
        box-sizing: border-box;
        width: 160px;
        display: flex;
        margin-right: 12px;
        flex-direction: row;
        align-items: center;
        color: rgb(125, 139, 148);

        span.name {
          font-size: 14px;
          color: rgb(141, 158, 167);
          line-height: 38px;
          margin: 0 10px;
          box-sizing: border-box;
          width: 20px;
        }
      }

      .el-input-number {
        flex: 1 1 0%;
      }
    }
  }
}

.fixbtn {
  position: fixed;
  display: flex;
  flex-direction: column;

  .ant-btn {
    margin-bottom: 10px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    user-select: none;

    .item {
      cursor: pointer;
    }
  }
}

.backimg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
}

.photo-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.build-item {
  width: 99px;
  height: 99px;
  overflow: hidden;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  -webkit-user-drag: element;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #f3f3f3;

  .wrap {
    position: relative;
  }

  .img {
    width: 100%;
    height: auto;
  }

  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.searchbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 20px 10px 10px;
  box-sizing: border-box;

  ::v-deep .ant-input-search {
    flex: 1 1 0%;
  }
}

.fixtop div,
.tabbar div {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.body {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;

  &.mask {
    position: relative;

    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: "";
    }
  }
}

.student-list {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.content img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.photo-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 99px;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  position: relative;

  .img {
    width: 100%;
    height: auto;
  }

  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.dragtext {
  width: 99px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  color: #333;
  border: 1px solid #666;
  margin-bottom: 10px;
}

.photo-item .look {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.back-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 100px;
  float: left;
  box-sizing: border-box;
  margin: 6px 10px;
}

.plate-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  .cell {
    width: 134px;
    margin-right: 20px;
    height: 180px;
    background: #eee;
    position: relative;
    margin-bottom: 60px;

    &.select {
      border: 2px solid #9ebee4;
    }

    .name {
      position: absolute;
      left: 0;
      top: 185px;
      color: #888;
      line-height: 1.2;
      padding: 5px;
      box-sizing: border-box;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

.back-item .back {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  position: relative;

  &.select {
    // border: 4px solid #55aaff;
    border-radius: 2px;
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: "";
      line-height: 100%;
      font-family: "iconfont";
      background: rgba($color: #000000, $alpha: 0.3);
      z-index: 100;
      color: #fff;
      font-size: 30px;
      text-align: center;
    }

    .iconfont3 {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      color: #fff;
      z-index: 101;
    }
  }

  .times {
    position: absolute;
    right: 0;
    top: 0;
    padding: 4px 6px;
    color: #fff;
    background: #ff0000;
    border-radius: 16px;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    transform: translate(50%, -50%);
  }
}

.back-item .back .img {
  width: 100%;
  height: auto;
  max-height: 160px;
  background: #f3f3f3;
  display: block;
}

.photo-item .look .img {
  width: 100%;
  background: #f3f3f3;
  display: block;
}

.photo-item .name {
  text-align: center;
}

body,
html {
  background: #f3f3f3;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}

.page-list {
  width: 100%;
  overflow: hidden;

  .cell {
    float: left;
    width: 120px;
    margin: 0 10px 10px 10px;
    position: relative;
    overflow: hidden;

    .dragbox {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: relative;

      .lock {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.6);
        text-align: center;
        font-family: "iconfont";
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 1000;
        color: #fff;
        align-items: center;

        i {
          color: #fff;
          font-size: 16px;
          margin-bottom: 2px;
        }

        .name {
          font-size: 14px;
          color: #fff;
        }
      }
    }

    .cover {
      width: 120px;
      height: 170px;
      background: #eee;
      margin-bottom: 15px;
      background-size: contain;
    }

    .name {
      color: #666666;
      font-size: 14px;
      text-align: center;
      height: 20px;
      margin-top: 10px;
      line-height: 20px;
      z-index: 100;
    }
  }
}
.leftDrags {
  position: fixed;
  left: 330px;
  top: 135px;
  background: #fff;
  width: 130px;
  overflow-y: scroll;
  max-height: calc(100% - 160px);
  padding: 10px 0px 10px 0px;
  z-index: 0;
  .title {
    font-size: 12px;
    padding: 6px 0;
    color: #999;
    padding: 0 5px;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .drag-cell {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    &.active {
      background: #eee;
    }
    .msg {
      flex: 1 1 0%;
    }
    .status {
      width: 6px;
      height: 6px;
      border-radius: 6px;
      background: #ff0000;
    }
  }
}
.left-tools {
  position: fixed;
  left: 330px;
  top: 75px;
  background: #fff;
  width: 130px;
  height: 50px;
  padding: 10px 5px 10px 8px;
  display: flex;
  flex-direction: row;

  .item {
    flex: 1 1 0%;
    margin: 0 4px;
    display: flex;
    float: left;
    align-items: center;
    justify-content: center;
    height: 30px;
    -webkit-user-drag: element;

    &:hover {
      background: #eee;
    }

    .type-line {
      width: 17px;
      height: 2px;
      background: #6a6a6a;
      border-radius: 2px;
      transform: rotate(-45deg);
    }

    .type-squire {
      width: 20px;
      height: 16px;
      border: 2px solid #6a6a6a;
      border-radius: 2px;
    }

    .type-circle {
      width: 18px;
      height: 18px;
      border-radius: 20px;
      border: 2px solid #6a6a6a;
    }
  }
}

.student-list {
  position: fixed;
  left: 0;
  top: 60px;
  bottom: 0;
  width: 315px;
  padding: 0 1px;
  overflow-y: scroll;
  background: #fff;
  z-index: 100;
  align-items: flex-start;
  justify-content: flex-start;

  .selectall {
    width: 100%;
    text-align: center;
    padding: 15px;
    background: #e8e8f3;
    color: #666;
    cursor: pointer;
    margin-bottom: 10px;
  }

  .cell {
    width: 72px;
    text-align: center;
    margin: 0 1px 10px 1px;
    padding: 10px 0;
    float: left;
    position: relative;

    .pos-tip {
      position: absolute;
      background: #ff0000;
      color: #fff;
      top: -4px;
      left: 0;
      right: 0;
      border-radius: 4px;
    }

    &.select {
      background: #dfe7ec;
      border-radius: 4px;
    }

    &.active {
      background: #4e9ecf;
      border-radius: 4px;

      .name {
        color: #fff;
      }
    }

    img {
      width: 44px;
      height: 44px;
      border-radius: 60px;
    }

    .name {
      text-align: center;
      color: #999;
      margin-top: 10px;
    }
  }
}

::v-deep .ant-input {
  border: 1px solid #eee;
}

::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}

::v-deep .ant-upload-list {
  overflow: hidden;
}

.leftChat {
  box-sizing: border-box;
  padding: 40px 381px 0 315px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
}

.body {
  position: relative;
  -webkit-text-size-adjust: none;
  width: 432px;
  height: 700px;
  min-height: 600px;
  border: 1px solid #999;
  margin-top: 20px;
  // overflow: hidden;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px)
      10px 10px / 20px 20px,
    linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px) 0% 0% / 20px 20px;
}

.test1 {
  background-color: #fff;
}

.test1 img {
  width: 100%;
  height: 100%;
}

.editor {
  /* 所有空格都会原样显示 */
  white-space: pre-wrap;
}

.priview-img {
  position: fixed;
  top: 60px;
  right: 381px;
  width: 380px;
}

textarea {
  background: transparent;
}

.rightChat {
  position: fixed;
  right: 0;
  top: 0;
  width: 381px;
  height: 100vh;
  background: #fff;
  overflow-y: scroll;
  z-index: 20;
  display: flex;
  flex-direction: column;

  .content {
    overflow-x: hidden;
    flex: 1 1 0%;
    padding-bottom: 55px;
    box-sizing: border-box;
  }
}

.rightChat .tabbar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
}

.rightChat .tabbar .tab-item {
  padding: 8px 8px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
}

.rightChat .tabbar .tab-item.active {
  color: #746bff;
  position: relative;
}

.rightChat .tabbar .tab-item.active::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 2px;
  background: #746bff;
  content: "";
}

textarea {
  width: 100%;
  height: auto;
  max-height: 100%;
  border: none;
  // outline: none;
}

.mask2 {
  position: absolute;
  right: 0;
  top: 0;
  content: "";
  bottom: 0;
  width: 379px;
  z-index: 100;
  background: rgba($color: #000000, $alpha: 0.6);
}

.selectFamily {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 300px;
  background: #fff;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow-y: scroll;
  z-index: 1000;

  div {
    font-size: 14px;
    background: #fff;
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.text {
  box-sizing: border-box;
}

::v-deep .el-color-dropdown__value {
  margin-top: 5px !important;
}

#app,
.app {
  background: #f3f3f3;
  width: 100%;
}

.pagebox {
  position: absolute;
  bottom: 0px;
  padding: 15px 0;
  left: 5px;
  right: 5px;
  background: #fff;
}

.section {
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .label {
      flex: 1 1 0%;
      border-radius: 5px;
      border: 1px solid #eee;
      text-align: center;
      margin-left: 10px;
      padding: 2px 0;
      cursor: pointer;
      &.active {
        background: #e1eff8;
      }

      &:first-child {
        margin-left: 0;
      }

      &.outline {
        border: none;
      }
    }
  }

  .col-3 {
    width: 100% !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #f3f3f3;
    padding: 5px;
    border-radius: 5px;

    .cell {
      flex: 1 1 0%;
      border-radius: 5px;
      border: 1px solid #eee;
      text-align: center;
      margin-right: 10px;
      font-weight: bold;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 0;

      &.active {
        background: #fff;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.bottomChat {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 381px;
  background: #fff;
  height: 50px;

  .pagebox {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    box-sizing: border-box;
    align-items: center;

    .item {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      margin-right: 4px;
      color: #16bda4;
      cursor: pointer;
    }

    .add-page {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      box-sizing: border-box;
      padding: 0;
      color: #16bda4;
      margin-right: 4px;
      cursor: pointer;
    }

    .active {
      background: #00d182;
      color: #fff;
    }
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.savebox {
  margin-right: 12px;

  span {
    margin-left: 5px;
  }
}

.sizebox {
  .name {
    margin-right: 5px;
  }
}

.fixbtn .tip {
  position: absolute;
  right: 0;
  top: -40px;
  white-space: nowrap;
  color: #4f5866;
}
.dq_none i {
  color: #ccc;
}
.ql-container ::v-deep .ql-editor {
  white-space: pre-wrap;
}

.frameModal {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}

.frameModal .photo-item {
  width: 100px;
}
::v-deep .ant-select-selection-selected-value .total {
  display: none;
}

.rightfix {
  position: fixed;
  right: 381px;
  bottom: 30px;
  img {
    width: 26px;
    margin-right: 5px;
    margin-top: -2px;
  }
  .pull-p {
    padding: 8px 15px 8px 8px;
    background: #679dbd;
    color: #fff;
    border-radius: 30px 0 0 30px;
    cursor: pointer;
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .clear-p {
    background: #e73a37;
    padding: 8px 15px 8px 8px;
    color: #fff;
    border-radius: 30px 0 0 30px;
    cursor: pointer;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.tel-list {
  padding: 20px;
  .search {
    margin-bottom: 20px;
  }
  .tel-cell {
    background: #f3f3f3;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
    .ant-btn {
      margin-top: 10px;
      float: right;
    }
  }
}

/* 日志列表头部样式 */
.log-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
}

.log-view-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.log-view-label {
  font-size: 14px;
  color: #666;
}

.log-view-text {
  font-size: 14px;
  font-weight: 600;
  
  &.mode-all {
    color: #52c41a;
  }
  
  &.mode-single {
    color: #1890ff;
  }
}

.log-view-ec {
  font-size: 12px;
  color: #999;
}
</style>
